export default [
  {
    codCiudad: 423,
    codPcia: 13,
    CP: 2000,
    letra: '',
    nombre: 'ROSARIO',
  },
  {
    codCiudad: 2296,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: '20 De Febrero',
  },
  {
    codCiudad: 838,
    codPcia: 3,
    CP: 4242,
    letra: '',
    nombre: '25 DE MAYO',
  },
  {
    codCiudad: 1385,
    codPcia: 19,
    CP: 8201,
    letra: '',
    nombre: '25 DE MAYO',
  },
  {
    codCiudad: 847,
    codPcia: 14,
    CP: 4353,
    letra: '',
    nombre: '25 DE MAYO',
  },
  {
    codCiudad: 1366,
    codPcia: 11,
    CP: 5443,
    letra: '',
    nombre: '25 DE MAYO',
  },
  {
    codCiudad: 835,
    codPcia: 14,
    CP: 4231,
    letra: '',
    nombre: '25 DE MAYO',
  },
  {
    codCiudad: 1583,
    codPcia: 2,
    CP: 6660,
    letra: '',
    nombre: '25 DE MAYO',
  },
  {
    codCiudad: 1258,
    codPcia: 23,
    CP: 9408,
    letra: '',
    nombre: '28 DE NOVIEMBRE',
  },
  {
    codCiudad: 316,
    codPcia: 2,
    CP: 1654,
    letra: '',
    nombre: '3 DE FEBRERO',
  },
  {
    codCiudad: 1237,
    codPcia: 9,
    CP: 5543,
    letra: '',
    nombre: '3 DE MAYO - LAVALLE',
  },
  {
    codCiudad: 1283,
    codPcia: 2,
    CP: 6500,
    letra: '',
    nombre: '9 DE JULIO',
  },
  {
    codCiudad: 953,
    codPcia: 11,
    CP: 5417,
    letra: '',
    nombre: '9 DE JULIO',
  },
  {
    codCiudad: 789,
    codPcia: 14,
    CP: 3760,
    letra: '',
    nombre: 'A',
  },
  {
    codCiudad: 394,
    codPcia: 2,
    CP: 1864,
    letra: '',
    nombre: 'A KORN',
  },
  {
    codCiudad: 414,
    codPcia: 2,
    CP: 1903,
    letra: '',
    nombre: 'ABASTO',
  },
  {
    codCiudad: 2217,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'Ablome',
  },
  {
    codCiudad: 3029,
    codPcia: 10,
    CP: 4650,
    letra: '',
    nombre: 'Abra De Peqas',
  },
  {
    codCiudad: 2062,
    codPcia: 10,
    CP: 4411,
    letra: '',
    nombre: 'Abra Del Gallo',
  },
  {
    codCiudad: 2689,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'Abra Grande',
  },
  {
    codCiudad: 1486,
    codPcia: 19,
    CP: 8212,
    letra: '',
    nombre: 'ABRAMO',
  },
  {
    codCiudad: 2956,
    codPcia: 10,
    CP: 4568,
    letra: '',
    nombre: 'Acambuco',
  },
  {
    codCiudad: 2063,
    codPcia: 10,
    CP: 4411,
    letra: '',
    nombre: 'Acazoque',
  },
  {
    codCiudad: 431,
    codPcia: 13,
    CP: 2109,
    letra: '',
    nombre: 'ACEBAL',
  },
  {
    codCiudad: 2438,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'Acharas',
  },
  {
    codCiudad: 1018,
    codPcia: 4,
    CP: 5833,
    letra: '',
    nombre: 'ACHIRAS',
  },
  {
    codCiudad: 2297,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'Acosta',
  },
  {
    codCiudad: 3035,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'Acoyte',
  },
  {
    codCiudad: 1019,
    codPcia: 4,
    CP: 5843,
    letra: '',
    nombre: 'ADELIA MARIA',
  },
  {
    codCiudad: 1495,
    codPcia: 2,
    CP: 6430,
    letra: '',
    nombre: 'ADOLFO ALSINA',
  },
  {
    codCiudad: 1609,
    codPcia: 2,
    CP: 7513,
    letra: '',
    nombre: 'ADOLFO GONZALES CHAVES',
  },
  {
    codCiudad: 387,
    codPcia: 2,
    CP: 1846,
    letra: '',
    nombre: 'ADROGUE',
  },
  {
    codCiudad: 936,
    codPcia: 8,
    CP: 5301,
    letra: '',
    nombre: 'AGUA BLANCA',
  },
  {
    codCiudad: 2412,
    codPcia: 10,
    CP: 4431,
    letra: '',
    nombre: 'Agua Caliente',
  },
  {
    codCiudad: 877,
    codPcia: 4,
    CP: 5107,
    letra: '',
    nombre: 'AGUA DE ORO',
  },
  {
    codCiudad: 2110,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Agua Negra',
  },
  {
    codCiudad: 2593,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'Agua Sucia',
  },
  {
    codCiudad: 2919,
    codPcia: 10,
    CP: 4561,
    letra: '',
    nombre: 'Agua Verde',
  },
  {
    codCiudad: 909,
    codPcia: 4,
    CP: 5211,
    letra: '',
    nombre: 'AGUADA',
  },
  {
    codCiudad: 1480,
    codPcia: 21,
    CP: 8305,
    letra: '',
    nombre: 'AGUADA SAN ROQUE',
  },
  {
    codCiudad: 1538,
    codPcia: 13,
    CP: 3074,
    letra: '',
    nombre: 'AGUARÁ GRANDE',
  },
  {
    codCiudad: 2951,
    codPcia: 10,
    CP: 4566,
    letra: '',
    nombre: 'Aguaray',
  },
  {
    codCiudad: 1706,
    codPcia: 10,
    CP: 4531,
    letra: '',
    nombre: 'Aguas Blancas',
  },
  {
    codCiudad: 2690,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'Aguas Blancas',
  },
  {
    codCiudad: 1824,
    codPcia: 10,
    CP: 4190,
    letra: '',
    nombre: 'Aguas Calientes',
  },
  {
    codCiudad: 2375,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'Aguas Calientes',
  },
  {
    codCiudad: 2753,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'Aguas Muertas',
  },
  {
    codCiudad: 814,
    codPcia: 3,
    CP: 4152,
    letra: '',
    nombre: 'AGUILARES',
  },
  {
    codCiudad: 1596,
    codPcia: 19,
    CP: 6361,
    letra: '',
    nombre: 'AGUSTONI',
  },
  {
    codCiudad: 1901,
    codPcia: 10,
    CP: 4197,
    letra: '',
    nombre: 'Ahi Veremos',
  },
  {
    codCiudad: 943,
    codPcia: 8,
    CP: 5310,
    letra: '',
    nombre: 'AIMOGASTA',
  },
  {
    codCiudad: 1350,
    codPcia: 11,
    CP: 5419,
    letra: '',
    nombre: 'ALBARDON',
  },
  {
    codCiudad: 1071,
    codPcia: 2,
    CP: 6034,
    letra: '',
    nombre: 'ALBERDI',
  },
  {
    codCiudad: 1123,
    codPcia: 2,
    CP: 6634,
    letra: '',
    nombre: 'ALBERTI',
  },
  {
    codCiudad: 697,
    codPcia: 6,
    CP: 3138,
    letra: '',
    nombre: 'ALCARAZ',
  },
  {
    codCiudad: 1271,
    codPcia: 4,
    CP: 5813,
    letra: '',
    nombre: 'ALCIRA GIGENA',
  },
  {
    codCiudad: 437,
    codPcia: 13,
    CP: 2117,
    letra: '',
    nombre: 'ALCORTA',
  },
  {
    codCiudad: 1662,
    codPcia: 6,
    CP: 2826,
    letra: '',
    nombre: 'ALDEA SAN ANTONIO',
  },
  {
    codCiudad: 824,
    codPcia: 3,
    CP: 4178,
    letra: '',
    nombre: 'ALDERETES',
  },
  {
    codCiudad: 363,
    codPcia: 2,
    CP: 1770,
    letra: '',
    nombre: 'ALDO BONZI',
  },
  {
    codCiudad: 677,
    codPcia: 13,
    CP: 3051,
    letra: '',
    nombre: 'ALEJANDRA',
  },
  {
    codCiudad: 1611,
    codPcia: 4,
    CP: 2686,
    letra: '',
    nombre: 'ALEJANDRO ROCA',
  },
  {
    codCiudad: 2023,
    codPcia: 10,
    CP: 4407,
    letra: '',
    nombre: 'Alejo De Alberro',
  },
  {
    codCiudad: 587,
    codPcia: 4,
    CP: 2662,
    letra: '',
    nombre: 'ALEJO LEDESMA',
  },
  {
    codCiudad: 1775,
    codPcia: 10,
    CP: 4126,
    letra: '',
    nombre: 'Alem',
  },
  {
    codCiudad: 2298,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'Alemania',
  },
  {
    codCiudad: 2032,
    codPcia: 10,
    CP: 4409,
    letra: '',
    nombre: 'Alfarcito',
  },
  {
    codCiudad: 2373,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'Algarrobal',
  },
  {
    codCiudad: 2739,
    codPcia: 10,
    CP: 4534,
    letra: '',
    nombre: 'Algarrobal',
  },
  {
    codCiudad: 2670,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Algarrobal',
  },
  {
    codCiudad: 2754,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'Algarrobal',
  },
  {
    codCiudad: 2524,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'Algarrobal Viejo',
  },
  {
    codCiudad: 1524,
    codPcia: 19,
    CP: 6323,
    letra: '',
    nombre: 'ALGARROBO DEL AGUILA',
  },
  {
    codCiudad: 1641,
    codPcia: 22,
    CP: 8328,
    letra: '',
    nombre: 'ALLEN',
  },
  {
    codCiudad: 1023,
    codPcia: 4,
    CP: 5854,
    letra: '',
    nombre: 'ALMAFUERTE',
  },
  {
    codCiudad: 1845,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'Almirante Brown',
  },
  {
    codCiudad: 2218,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'Almona',
  },
  {
    codCiudad: 1008,
    codPcia: 4,
    CP: 5801,
    letra: '',
    nombre: 'ALPA CORRAL',
  },
  {
    codCiudad: 1531,
    codPcia: 19,
    CP: 6309,
    letra: '',
    nombre: 'ALPACHIRI',
  },
  {
    codCiudad: 645,
    codPcia: 2,
    CP: 2938,
    letra: '',
    nombre: 'ALSINA',
  },
  {
    codCiudad: 903,
    codPcia: 4,
    CP: 5186,
    letra: '',
    nombre: 'ALTA GRACIA',
  },
  {
    codCiudad: 421,
    codPcia: 2,
    CP: 1986,
    letra: '',
    nombre: 'ALTAMIRANO',
  },
  {
    codCiudad: 1038,
    codPcia: 4,
    CP: 5907,
    letra: '',
    nombre: 'ALTO ALEGRE',
  },
  {
    codCiudad: 2594,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'Alto Alegre',
  },
  {
    codCiudad: 2920,
    codPcia: 10,
    CP: 4561,
    letra: '',
    nombre: 'Alto De La Sierra',
  },
  {
    codCiudad: 957,
    codPcia: 11,
    CP: 5438,
    letra: '',
    nombre: 'ALTO DE SIERRA',
  },
  {
    codCiudad: 2525,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'Alto Del Mistol',
  },
  {
    codCiudad: 1586,
    codPcia: 17,
    CP: 9033,
    letra: '',
    nombre: 'ALTO RIO SENGUER',
  },
  {
    codCiudad: 2755,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'Alto Verde',
  },
  {
    codCiudad: 514,
    codPcia: 14,
    CP: 2417,
    letra: '',
    nombre: 'ALTOS DE CHIPION - D',
  },
  {
    codCiudad: 2413,
    codPcia: 10,
    CP: 4432,
    letra: '',
    nombre: 'Altos H. Guemes',
  },
  {
    codCiudad: 1505,
    codPcia: 21,
    CP: 8345,
    letra: '',
    nombre: 'ALUMINE',
  },
  {
    codCiudad: 429,
    codPcia: 13,
    CP: 2107,
    letra: '',
    nombre: 'ALVAREZ',
  },
  {
    codCiudad: 1411,
    codPcia: 2,
    CP: 1416,
    letra: '',
    nombre: 'ALVAREZ JONTE',
  },
  {
    codCiudad: 450,
    codPcia: 13,
    CP: 2126,
    letra: '',
    nombre: 'ALVEAR',
  },
  {
    codCiudad: 2180,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'Amaicha',
  },
  {
    codCiudad: 1622,
    codPcia: 15,
    CP: 4137,
    letra: '',
    nombre: 'AMAICHA DEL VALLE',
  },
  {
    codCiudad: 2921,
    codPcia: 10,
    CP: 4561,
    letra: '',
    nombre: 'Amberes',
  },
  {
    codCiudad: 2299,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'Amblayo',
  },
  {
    codCiudad: 3154,
    codPcia: 13,
    CP: 2352,
    letra: '',
    nombre: 'AMBROSETTI',
  },
  {
    codCiudad: 1300,
    codPcia: 2,
    CP: 6064,
    letra: '',
    nombre: 'AMEGHINO',
  },
  {
    codCiudad: 1076,
    codPcia: 13,
    CP: 6103,
    letra: '',
    nombre: 'AMENABAR',
  },
  {
    codCiudad: 1275,
    codPcia: 2,
    CP: 6237,
    letra: '',
    nombre: 'AMERICA',
  },
  {
    codCiudad: 941,
    codPcia: 8,
    CP: 5301,
    letra: '',
    nombre: 'AMINGA',
  },
  {
    codCiudad: 2219,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'Ampascachi',
  },
  {
    codCiudad: 2111,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Ampata',
  },
  {
    codCiudad: 1566,
    codPcia: 12,
    CP: 6389,
    letra: '',
    nombre: 'ANCHORENA',
  },
  {
    codCiudad: 1413,
    codPcia: 21,
    CP: 8353,
    letra: '',
    nombre: 'ANDACOLLO',
  },
  {
    codCiudad: 1399,
    codPcia: 3,
    CP: 4740,
    letra: '',
    nombre: 'ANDALGALA',
  },
  {
    codCiudad: 1109,
    codPcia: 2,
    CP: 6555,
    letra: '',
    nombre: 'ANDANT',
  },
  {
    codCiudad: 487,
    codPcia: 13,
    CP: 2214,
    letra: '',
    nombre: 'ANDINO',
  },
  {
    codCiudad: 1328,
    codPcia: 11,
    CP: 5417,
    letra: '',
    nombre: 'ANGACO',
  },
  {
    codCiudad: 1525,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'ANGASTACO',
  },
  {
    codCiudad: 2336,
    codPcia: 10,
    CP: 4426,
    letra: '',
    nombre: 'Angastaco',
  },
  {
    codCiudad: 2731,
    codPcia: 10,
    CP: 4533,
    letra: '',
    nombre: 'Angel Peredo',
  },
  {
    codCiudad: 2732,
    codPcia: 10,
    CP: 4533,
    letra: '',
    nombre: 'Angelica',
  },
  {
    codCiudad: 504,
    codPcia: 13,
    CP: 2303,
    letra: '',
    nombre: 'ANGELICA',
  },
  {
    codCiudad: 2181,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'Angostura',
  },
  {
    codCiudad: 2886,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'Angostura',
  },
  {
    codCiudad: 2112,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Angostura',
  },
  {
    codCiudad: 934,
    codPcia: 8,
    CP: 5301,
    letra: '',
    nombre: 'ANILLACO',
  },
  {
    codCiudad: 2338,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'Animana',
  },
  {
    codCiudad: 2372,
    codPcia: 10,
    CP: 4429,
    letra: '',
    nombre: 'Animana',
  },
  {
    codCiudad: 1799,
    codPcia: 10,
    CP: 4141,
    letra: '',
    nombre: 'Anjuana',
  },
  {
    codCiudad: 942,
    codPcia: 8,
    CP: 5303,
    letra: '',
    nombre: 'ANJULLON',
  },
  {
    codCiudad: 2439,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'Anta',
  },
  {
    codCiudad: 1846,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'Antilla',
  },
  {
    codCiudad: 1947,
    codPcia: 10,
    CP: 4401,
    letra: '',
    nombre: 'Antonio Alice',
  },
  {
    codCiudad: 2831,
    codPcia: 10,
    CP: 4552,
    letra: '',
    nombre: 'Antonio Quijarro',
  },
  {
    codCiudad: 2595,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'Apolinario Saravia',
  },
  {
    codCiudad: 1303,
    codPcia: 20,
    CP: 3350,
    letra: '',
    nombre: 'APOSTOLES',
  },
  {
    codCiudad: 700,
    codPcia: 6,
    CP: 3162,
    letra: '',
    nombre: 'ARANGUREN',
  },
  {
    codCiudad: 2740,
    codPcia: 10,
    CP: 4534,
    letra: '',
    nombre: 'Arbol Solo',
  },
  {
    codCiudad: 1280,
    codPcia: 2,
    CP: 6557,
    letra: '',
    nombre: 'ARBOLEDAS',
  },
  {
    codCiudad: 811,
    codPcia: 3,
    CP: 4147,
    letra: '',
    nombre: 'ARCADIA',
  },
  {
    codCiudad: 2887,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'Arenal',
  },
  {
    codCiudad: 1906,
    codPcia: 10,
    CP: 4198,
    letra: '',
    nombre: 'Arenal',
  },
  {
    codCiudad: 2756,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'Arenales',
  },
  {
    codCiudad: 1065,
    codPcia: 2,
    CP: 6005,
    letra: '',
    nombre: 'ARENALES',
  },
  {
    codCiudad: 1379,
    codPcia: 2,
    CP: 6075,
    letra: '',
    nombre: 'ARENAZA',
  },
  {
    codCiudad: 476,
    codPcia: 13,
    CP: 2183,
    letra: '',
    nombre: 'AREQUITO',
  },
  {
    codCiudad: 892,
    codPcia: 4,
    CP: 5147,
    letra: '',
    nombre: 'ARGUELLO',
  },
  {
    codCiudad: 570,
    codPcia: 4,
    CP: 2624,
    letra: '',
    nombre: 'ARIAS',
  },
  {
    codCiudad: 1156,
    codPcia: 2,
    CP: 7163,
    letra: '',
    nombre: 'ARIAS',
  },
  {
    codCiudad: 2596,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'Arita',
  },
  {
    codCiudad: 1098,
    codPcia: 12,
    CP: 6389,
    letra: '',
    nombre: 'ARIZONA',
  },
  {
    codCiudad: 2376,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'Arjuntas',
  },
  {
    codCiudad: 439,
    codPcia: 13,
    CP: 2119,
    letra: '',
    nombre: 'ARMINDA',
  },
  {
    codCiudad: 529,
    codPcia: 13,
    CP: 2508,
    letra: '',
    nombre: 'ARMSTRONG',
  },
  {
    codCiudad: 493,
    codPcia: 13,
    CP: 2242,
    letra: '',
    nombre: 'AROCENA',
  },
  {
    codCiudad: 715,
    codPcia: 20,
    CP: 3317,
    letra: '',
    nombre: 'AROCENA',
  },
  {
    codCiudad: 611,
    codPcia: 2,
    CP: 2740,
    letra: '',
    nombre: 'ARRECIFES',
  },
  {
    codCiudad: 1066,
    codPcia: 2,
    CP: 6007,
    letra: '',
    nombre: 'ARRIBE',
  },
  {
    codCiudad: 1585,
    codPcia: 2,
    CP: 6007,
    letra: '',
    nombre: 'ARRIBEÑOS',
  },
  {
    codCiudad: 2510,
    codPcia: 10,
    CP: 4444,
    letra: '',
    nombre: 'Arrocero Italiano',
  },
  {
    codCiudad: 1232,
    codPcia: 4,
    CP: 2434,
    letra: '',
    nombre: 'ARROYITO',
  },
  {
    codCiudad: 659,
    codPcia: 13,
    CP: 3014,
    letra: '',
    nombre: 'ARROYO AGUIAR',
  },
  {
    codCiudad: 1039,
    codPcia: 4,
    CP: 5909,
    letra: '',
    nombre: 'ARROYO ALGODON',
  },
  {
    codCiudad: 1593,
    codPcia: 6,
    CP: 3133,
    letra: '',
    nombre: 'ARROYO BURGOS',
  },
  {
    codCiudad: 1378,
    codPcia: 4,
    CP: 5917,
    letra: '',
    nombre: 'ARROYO CABRAL',
  },
  {
    codCiudad: 2683,
    codPcia: 10,
    CP: 4500,
    letra: '',
    nombre: 'Arroyo Colorado',
  },
  {
    codCiudad: 613,
    codPcia: 2,
    CP: 2743,
    letra: '',
    nombre: 'ARROYO DULCE',
  },
  {
    codCiudad: 312,
    codPcia: 1,
    CP: 1649,
    letra: '',
    nombre: 'ARROYO LARGO',
  },
  {
    codCiudad: 3109,
    codPcia: 13,
    CP: 3001,
    letra: '',
    nombre: 'ARROYO LEYES',
  },
  {
    codCiudad: 453,
    codPcia: 13,
    CP: 2128,
    letra: '',
    nombre: 'ARROYO SECO',
  },
  {
    codCiudad: 441,
    codPcia: 13,
    CP: 2120,
    letra: '',
    nombre: 'ARROYO SECO',
  },
  {
    codCiudad: 1698,
    codPcia: 13,
    CP: 2344,
    letra: '',
    nombre: 'ARRUFÓ',
  },
  {
    codCiudad: 478,
    codPcia: 13,
    CP: 2187,
    letra: '',
    nombre: 'ARTEAGA',
  },
  {
    codCiudad: 409,
    codPcia: 2,
    CP: 1895,
    letra: '',
    nombre: 'ARTURO SEGUI',
  },
  {
    codCiudad: 1594,
    codPcia: 2,
    CP: 6003,
    letra: '',
    nombre: 'ASCENCION',
  },
  {
    codCiudad: 2969,
    codPcia: 10,
    CP: 4633,
    letra: '',
    nombre: 'Astillero',
  },
  {
    codCiudad: 2962,
    codPcia: 10,
    CP: 4600,
    letra: '',
    nombre: 'Atalaya',
  },
  {
    codCiudad: 505,
    codPcia: 13,
    CP: 2307,
    letra: '',
    nombre: 'ATALIVA',
  },
  {
    codCiudad: 1948,
    codPcia: 10,
    CP: 4401,
    letra: '',
    nombre: 'Atocha',
  },
  {
    codCiudad: 2113,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Atudillo',
  },
  {
    codCiudad: 396,
    codPcia: 2,
    CP: 1870,
    letra: '',
    nombre: 'AVELLANEDA',
  },
  {
    codCiudad: 761,
    codPcia: 13,
    CP: 3561,
    letra: '',
    nombre: 'AVELLANEDA',
  },
  {
    codCiudad: 910,
    codPcia: 4,
    CP: 5212,
    letra: '',
    nombre: 'AVELLANEDA',
  },
  {
    codCiudad: 3133,
    codPcia: 14,
    CP: 3766,
    letra: '',
    nombre: 'AVERIAS',
  },
  {
    codCiudad: 1155,
    codPcia: 2,
    CP: 7150,
    letra: '',
    nombre: 'AYACUCHO',
  },
  {
    codCiudad: 1137,
    codPcia: 2,
    CP: 6721,
    letra: '',
    nombre: 'AZCUENAGA',
  },
  {
    codCiudad: 1170,
    codPcia: 2,
    CP: 7300,
    letra: '',
    nombre: 'AZUL',
  },
  {
    codCiudad: 3036,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'Azul Cuesta',
  },
  {
    codCiudad: 2963,
    codPcia: 10,
    CP: 4600,
    letra: '',
    nombre: 'B Alto La Viqa',
  },
  {
    codCiudad: 2511,
    codPcia: 10,
    CP: 4444,
    letra: '',
    nombre: 'B G Desvio Fcgb',
  },
  {
    codCiudad: 1772,
    codPcia: 10,
    CP: 3698,
    letra: '',
    nombre: 'B Gral J De S M',
  },
  {
    codCiudad: 2684,
    codPcia: 10,
    CP: 4500,
    letra: '',
    nombre: 'B La Providencia',
  },
  {
    codCiudad: 3003,
    codPcia: 10,
    CP: 4644,
    letra: '',
    nombre: 'Bacoya',
  },
  {
    codCiudad: 1902,
    codPcia: 10,
    CP: 4197,
    letra: '',
    nombre: 'Bagual Muerto',
  },
  {
    codCiudad: 1190,
    codPcia: 2,
    CP: 8000,
    letra: '',
    nombre: 'BAHIA BLANCA',
  },
  {
    codCiudad: 1068,
    codPcia: 2,
    CP: 6013,
    letra: '',
    nombre: 'BAIGORRITA',
  },
  {
    codCiudad: 1825,
    codPcia: 10,
    CP: 4190,
    letra: '',
    nombre: 'Bajada',
  },
  {
    codCiudad: 1847,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'Bajada Blanca',
  },
  {
    codCiudad: 1907,
    codPcia: 10,
    CP: 4198,
    letra: '',
    nombre: 'Bajada De Cavi',
  },
  {
    codCiudad: 1465,
    codPcia: 21,
    CP: 8351,
    letra: '',
    nombre: 'BAJADA DEL AGRIO  - PICUNCHES',
  },
  {
    codCiudad: 1908,
    codPcia: 10,
    CP: 4198,
    letra: '',
    nombre: 'Bajada Grande',
  },
  {
    codCiudad: 2526,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'Bajo Grande',
  },
  {
    codCiudad: 1848,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'Balboa',
  },
  {
    codCiudad: 2922,
    codPcia: 10,
    CP: 4561,
    letra: '',
    nombre: 'Balbuena',
  },
  {
    codCiudad: 1187,
    codPcia: 2,
    CP: 7620,
    letra: '',
    nombre: 'BALCARCE',
  },
  {
    codCiudad: 2482,
    codPcia: 10,
    CP: 4440,
    letra: '',
    nombre: 'Balderrama',
  },
  {
    codCiudad: 1999,
    codPcia: 10,
    CP: 4405,
    letra: '',
    nombre: 'Ballenal',
  },
  {
    codCiudad: 550,
    codPcia: 4,
    CP: 2572,
    letra: '',
    nombre: 'BALLESTEROS',
  },
  {
    codCiudad: 1686,
    codPcia: 4,
    CP: 5141,
    letra: '',
    nombre: 'BALNEARIA',
  },
  {
    codCiudad: 796,
    codPcia: 3,
    CP: 4109,
    letra: '',
    nombre: 'BANDA DEL RIO SALI',
  },
  {
    codCiudad: 2182,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'Banda Grande',
  },
  {
    codCiudad: 1398,
    codPcia: 2,
    CP: 6244,
    letra: '',
    nombre: 'BANDERALO',
  },
  {
    codCiudad: 1568,
    codPcia: 14,
    CP: 3064,
    letra: '',
    nombre: 'BANDERAS',
  },
  {
    codCiudad: 381,
    codPcia: 2,
    CP: 1828,
    letra: '',
    nombre: 'BANFIELD',
  },
  {
    codCiudad: 646,
    codPcia: 2,
    CP: 2942,
    letra: '',
    nombre: 'BARADERO',
  },
  {
    codCiudad: 1826,
    codPcia: 10,
    CP: 4190,
    letra: '',
    nombre: 'Barbayasco',
  },
  {
    codCiudad: 1207,
    codPcia: 22,
    CP: 8400,
    letra: '',
    nombre: 'BARILOCHE',
  },
  {
    codCiudad: 3037,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'Baritu',
  },
  {
    codCiudad: 494,
    codPcia: 13,
    CP: 2246,
    letra: '',
    nombre: 'BARRANCAS',
  },
  {
    codCiudad: 743,
    codPcia: 16,
    CP: 3503,
    letra: '',
    nombre: 'BARRANQUERAS',
  },
  {
    codCiudad: 950,
    codPcia: 11,
    CP: 5405,
    letra: '',
    nombre: 'BARREAL',
  },
  {
    codCiudad: 2597,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'Barrealito',
  },
  {
    codCiudad: 2339,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'Barrial',
  },
  {
    codCiudad: 885,
    codPcia: 4,
    CP: 5123,
    letra: '',
    nombre: 'BARRIO DEAN FUNES',
  },
  {
    codCiudad: 1092,
    codPcia: 19,
    CP: 6300,
    letra: '',
    nombre: 'BARRIO FENIX',
  },
  {
    codCiudad: 2888,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'Barrio La Loma',
  },
  {
    codCiudad: 3028,
    codPcia: 10,
    CP: 4648,
    letra: '',
    nombre: 'Barrio La Union',
  },
  {
    codCiudad: 2166,
    codPcia: 10,
    CP: 4417,
    letra: '',
    nombre: 'Barrio Parabolica',
  },
  {
    codCiudad: 2889,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'Barrio S Cayetano',
  },
  {
    codCiudad: 2890,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'Barrio San Antonio',
  },
  {
    codCiudad: 2114,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Barro Negro',
  },
  {
    codCiudad: 1348,
    codPcia: 2,
    CP: 1911,
    letra: '',
    nombre: 'BARTOLOME BAVIO',
  },
  {
    codCiudad: 3194,
    codPcia: 6,
    CP: 3170,
    letra: '',
    nombre: 'BASAVILBASO',
  },
  {
    codCiudad: 1671,
    codPcia: 2,
    CP: 7601,
    letra: '',
    nombre: 'BATÁN  GENERAL PUEYRREDÓN',
  },
  {
    codCiudad: 308,
    codPcia: 2,
    CP: 1643,
    letra: '',
    nombre: 'BECCAR',
  },
  {
    codCiudad: 1519,
    codPcia: 2,
    CP: 1426,
    letra: '',
    nombre: 'BELGRANO',
  },
  {
    codCiudad: 1931,
    codPcia: 10,
    CP: 4400,
    letra: '',
    nombre: 'Belgrano',
  },
  {
    codCiudad: 2757,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'Belgrano Fortin 2',
  },
  {
    codCiudad: 540,
    codPcia: 4,
    CP: 2550,
    letra: '',
    nombre: 'BELL VILLE',
  },
  {
    codCiudad: 320,
    codPcia: 2,
    CP: 1661,
    letra: '',
    nombre: 'BELLA VISTA',
  },
  {
    codCiudad: 734,
    codPcia: 5,
    CP: 3432,
    letra: '',
    nombre: 'BELLA VISTA',
  },
  {
    codCiudad: 1849,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'Bella Vista',
  },
  {
    codCiudad: 2758,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'Bella Vista',
  },
  {
    codCiudad: 821,
    codPcia: 3,
    CP: 4168,
    letra: '',
    nombre: 'BELLA VISTA',
  },
  {
    codCiudad: 2267,
    codPcia: 10,
    CP: 4423,
    letra: '',
    nombre: 'Bella Vista',
  },
  {
    codCiudad: 2220,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'Bella Vista',
  },
  {
    codCiudad: 840,
    codPcia: 14,
    CP: 4308,
    letra: '',
    nombre: 'BELTRAN',
  },
  {
    codCiudad: 296,
    codPcia: 1,
    CP: 1621,
    letra: '',
    nombre: 'BENAVIDEZ',
  },
  {
    codCiudad: 1557,
    codPcia: 2,
    CP: 7020,
    letra: '',
    nombre: 'BENITO JUAREZ',
  },
  {
    codCiudad: 405,
    codPcia: 2,
    CP: 1884,
    letra: '',
    nombre: 'BERAZATEGUI',
  },
  {
    codCiudad: 418,
    codPcia: 2,
    CP: 1923,
    letra: '',
    nombre: 'BERISSO',
  },
  {
    codCiudad: 763,
    codPcia: 13,
    CP: 3569,
    letra: '',
    nombre: 'BERNA',
  },
  {
    codCiudad: 400,
    codPcia: 2,
    CP: 1876,
    letra: '',
    nombre: 'BERNAL OESTE',
  },
  {
    codCiudad: 1518,
    codPcia: 20,
    CP: 3366,
    letra: '',
    nombre: 'BERNARDO DE IRIGOYEN',
  },
  {
    codCiudad: 1667,
    codPcia: 19,
    CP: 8204,
    letra: '',
    nombre: 'BERNASCONI',
  },
  {
    codCiudad: 1013,
    codPcia: 4,
    CP: 5817,
    letra: '',
    nombre: 'BERROTARAN.',
  },
  {
    codCiudad: 1672,
    codPcia: 2,
    CP: 6424,
    letra: '',
    nombre: 'BERUTTI',
  },
  {
    codCiudad: 2414,
    codPcia: 10,
    CP: 4432,
    letra: '',
    nombre: 'Betania',
  },
  {
    codCiudad: 896,
    codPcia: 4,
    CP: 5158,
    letra: '',
    nombre: 'BIALET MASSE',
  },
  {
    codCiudad: 473,
    codPcia: 13,
    CP: 2177,
    letra: '',
    nombre: 'BIGAND',
  },
  {
    codCiudad: 1344,
    codPcia: 2,
    CP: 6065,
    letra: '',
    nombre: 'BLAQUIER',
  },
  {
    codCiudad: 869,
    codPcia: 4,
    CP: 5006,
    letra: '',
    nombre: 'BO ALTAMIRA (CBA)',
  },
  {
    codCiudad: 872,
    codPcia: 4,
    CP: 5012,
    letra: '',
    nombre: 'BO NUEVA ITALIA (CBA',
  },
  {
    codCiudad: 366,
    codPcia: 2,
    CP: 1776,
    letra: '',
    nombre: 'BO SAN SEBASTIAN-PDO',
  },
  {
    codCiudad: 871,
    codPcia: 4,
    CP: 5009,
    letra: '',
    nombre: 'BO.A.DE VILLA CABRER',
  },
  {
    codCiudad: 2300,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'Bodeguita',
  },
  {
    codCiudad: 1107,
    codPcia: 2,
    CP: 6550,
    letra: '',
    nombre: 'BOLIVAR',
  },
  {
    codCiudad: 1720,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Bolsa De Palomo',
  },
  {
    codCiudad: 474,
    codPcia: 13,
    CP: 2179,
    letra: '',
    nombre: 'BOMBAL',
  },
  {
    codCiudad: 2415,
    codPcia: 10,
    CP: 4432,
    letra: '',
    nombre: 'Borde De S Miguel',
  },
  {
    codCiudad: 1532,
    codPcia: 2,
    CP: 1889,
    letra: '',
    nombre: 'BOSQUES',
  },
  {
    codCiudad: 2671,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Botija',
  },
  {
    codCiudad: 288,
    codPcia: 2,
    CP: 1609,
    letra: '',
    nombre: 'BOULOGNE',
  },
  {
    codCiudad: 533,
    codPcia: 13,
    CP: 2523,
    letra: '',
    nombre: 'BOUQUET',
  },
  {
    codCiudad: 883,
    codPcia: 4,
    CP: 5119,
    letra: '',
    nombre: 'BOUWER',
  },
  {
    codCiudad: 1612,
    codPcia: 6,
    CP: 3142,
    letra: '',
    nombre: 'BOVRIL',
  },
  {
    codCiudad: 1124,
    codPcia: 2,
    CP: 6640,
    letra: '',
    nombre: 'BRAGADO',
  },
  {
    codCiudad: 841,
    codPcia: 14,
    CP: 4313,
    letra: '',
    nombre: 'BREA POZO',
  },
  {
    codCiudad: 2183,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'Brealito',
  },
  {
    codCiudad: 515,
    codPcia: 4,
    CP: 2419,
    letra: '',
    nombre: 'BRINKMAN',
  },
  {
    codCiudad: 874,
    codPcia: 4,
    CP: 5016,
    letra: '',
    nombre: 'BRIO EJERCITO ARG. *',
  },
  {
    codCiudad: 2817,
    codPcia: 10,
    CP: 4550,
    letra: '',
    nombre: 'Buen Lugar',
  },
  {
    codCiudad: 981,
    codPcia: 9,
    CP: 5571,
    letra: '',
    nombre: 'BUEN ORDEN',
  },
  {
    codCiudad: 1520,
    codPcia: 17,
    CP: 9023,
    letra: '',
    nombre: 'BUEN PASTO',
  },
  {
    codCiudad: 2923,
    codPcia: 10,
    CP: 4561,
    letra: '',
    nombre: 'Buena Fe',
  },
  {
    codCiudad: 970,
    codPcia: 9,
    CP: 5523,
    letra: '',
    nombre: 'BUENA NUEVA',
  },
  {
    codCiudad: 2340,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'Buena Vista',
  },
  {
    codCiudad: 2115,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Buena Vista',
  },
  {
    codCiudad: 1932,
    codPcia: 10,
    CP: 4400,
    letra: '',
    nombre: 'Buena Vista',
  },
  {
    codCiudad: 650,
    codPcia: 2,
    CP: 2952,
    letra: '',
    nombre: 'BUENOS AIRES',
  },
  {
    codCiudad: 2184,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'Burro Yaco',
  },
  {
    codCiudad: 800,
    codPcia: 3,
    CP: 4119,
    letra: '',
    nombre: 'BURRUYACU',
  },
  {
    codCiudad: 390,
    codPcia: 2,
    CP: 1852,
    letra: '',
    nombre: 'BURZACO',
  },
  {
    codCiudad: 524,
    codPcia: 13,
    CP: 2501,
    letra: '',
    nombre: 'BUSTINZA',
  },
  {
    codCiudad: 2691,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'C Agri S Agustin',
  },
  {
    codCiudad: 2924,
    codPcia: 10,
    CP: 4561,
    letra: '',
    nombre: 'C Buenaventura',
  },
  {
    codCiudad: 2185,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'C D A De La Falda',
  },
  {
    codCiudad: 2186,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'C De La Z Vieja',
  },
  {
    codCiudad: 3094,
    codPcia: 10,
    CP: 5236,
    letra: '',
    nombre: 'C De Las Piedras',
  },
  {
    codCiudad: 1210,
    codPcia: 2,
    CP: 8504,
    letra: '',
    nombre: 'C DE PATAGONES',
  },
  {
    codCiudad: 2416,
    codPcia: 10,
    CP: 4432,
    letra: '',
    nombre: 'C S Rosa De Lima',
  },
  {
    codCiudad: 1721,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'C Saavedra Lamas',
  },
  {
    codCiudad: 1820,
    codPcia: 10,
    CP: 4142,
    letra: '',
    nombre: 'C Santa Catalina',
  },
  {
    codCiudad: 2692,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'C Santa Maria',
  },
  {
    codCiudad: 2891,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'C Zanja Del Tigre',
  },
  {
    codCiudad: 1850,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'C. De Las Juntas',
  },
  {
    codCiudad: 576,
    codPcia: 13,
    CP: 2635,
    letra: '',
    nombre: 'CA',
  },
  {
    codCiudad: 373,
    codPcia: 2,
    CP: 1814,
    letra: '',
    nombre: 'CA',
  },
  {
    codCiudad: 523,
    codPcia: 13,
    CP: 2500,
    letra: '',
    nombre: 'CAÑADA DE GOMEZ',
  },
  {
    codCiudad: 1533,
    codPcia: 5,
    CP: 3407,
    letra: '',
    nombre: 'CAA CATI',
  },
  {
    codCiudad: 1851,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'Cabeza De Anta',
  },
  {
    codCiudad: 2440,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'Cabeza De Buey',
  },
  {
    codCiudad: 2221,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'Cabra Corral Dique',
  },
  {
    codCiudad: 1161,
    codPcia: 2,
    CP: 7214,
    letra: '',
    nombre: 'CACHARI',
  },
  {
    codCiudad: 1711,
    codPcia: 10,
    CP: 4417,
    letra: '',
    nombre: 'CACHI',
  },
  {
    codCiudad: 2167,
    codPcia: 10,
    CP: 4417,
    letra: '',
    nombre: 'Cachi Adentro',
  },
  {
    codCiudad: 2222,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'Cacho Molino',
  },
  {
    codCiudad: 671,
    codPcia: 13,
    CP: 3041,
    letra: '',
    nombre: 'CACIQUE ARIACAIQUIN',
  },
  {
    codCiudad: 1537,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'CAFAYATE',
  },
  {
    codCiudad: 2085,
    codPcia: 10,
    CP: 4413,
    letra: '',
    nombre: 'Caipe',
  },
  {
    codCiudad: 3038,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'Cajas',
  },
  {
    codCiudad: 1265,
    codPcia: 23,
    CP: 0,
    letra: '',
    nombre: 'CALAFATE',
  },
  {
    codCiudad: 676,
    codPcia: 13,
    CP: 3050,
    letra: '',
    nombre: 'CALCHAQUI',
  },
  {
    codCiudad: 1384,
    codPcia: 4,
    CP: 5969,
    letra: '',
    nombre: 'CALCHIN',
  },
  {
    codCiudad: 1949,
    codPcia: 10,
    CP: 4401,
    letra: '',
    nombre: 'Caldera',
  },
  {
    codCiudad: 1950,
    codPcia: 10,
    CP: 4401,
    letra: '',
    nombre: 'Calderilla',
  },
  {
    codCiudad: 1617,
    codPcia: 2,
    CP: 8101,
    letra: '',
    nombre: 'CALDERON',
  },
  {
    codCiudad: 1297,
    codPcia: 23,
    CP: 9011,
    letra: '',
    nombre: 'CALETA OLIVIA',
  },
  {
    codCiudad: 1800,
    codPcia: 10,
    CP: 4141,
    letra: '',
    nombre: 'Calimonte',
  },
  {
    codCiudad: 2223,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'Calvimonte',
  },
  {
    codCiudad: 2000,
    codPcia: 10,
    CP: 4405,
    letra: '',
    nombre: 'Camara',
  },
  {
    codCiudad: 1909,
    codPcia: 10,
    CP: 4198,
    letra: '',
    nombre: 'Camara',
  },
  {
    codCiudad: 554,
    codPcia: 4,
    CP: 2585,
    letra: '',
    nombre: 'CAMILO ALDAO',
  },
  {
    codCiudad: 2940,
    codPcia: 10,
    CP: 4563,
    letra: '',
    nombre: 'Caminera S Pedrito',
  },
  {
    codCiudad: 2941,
    codPcia: 10,
    CP: 4563,
    letra: '',
    nombre: 'Caminera San Pedrito',
  },
  {
    codCiudad: 2942,
    codPcia: 10,
    CP: 4563,
    letra: '',
    nombre: 'Camp Tablilla',
  },
  {
    codCiudad: 2943,
    codPcia: 10,
    CP: 4563,
    letra: '',
    nombre: 'Camp Vespucio',
  },
  {
    codCiudad: 2944,
    codPcia: 10,
    CP: 4563,
    letra: '',
    nombre: 'Campamento Vespucio',
  },
  {
    codCiudad: 621,
    codPcia: 2,
    CP: 2804,
    letra: '',
    nombre: 'CAMPANA',
  },
  {
    codCiudad: 2832,
    codPcia: 10,
    CP: 4552,
    letra: '',
    nombre: 'Campichuelo',
  },
  {
    codCiudad: 2598,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'Campo Alegre',
  },
  {
    codCiudad: 2483,
    codPcia: 10,
    CP: 4440,
    letra: '',
    nombre: 'Campo Alegre',
  },
  {
    codCiudad: 2268,
    codPcia: 10,
    CP: 4423,
    letra: '',
    nombre: 'Campo Alegre',
  },
  {
    codCiudad: 2759,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'Campo Argentino',
  },
  {
    codCiudad: 2484,
    codPcia: 10,
    CP: 4440,
    letra: '',
    nombre: 'Campo Azul',
  },
  {
    codCiudad: 1933,
    codPcia: 10,
    CP: 4400,
    letra: '',
    nombre: 'Campo Caseros',
  },
  {
    codCiudad: 477,
    codPcia: 13,
    CP: 2185,
    letra: '',
    nombre: 'CAMPO CRENNA',
  },
  {
    codCiudad: 319,
    codPcia: 2,
    CP: 1659,
    letra: '',
    nombre: 'CAMPO DE MAYO',
  },
  {
    codCiudad: 2952,
    codPcia: 10,
    CP: 4566,
    letra: '',
    nombre: 'Campo Duran',
  },
  {
    codCiudad: 1540,
    codPcia: 14,
    CP: 3747,
    letra: '',
    nombre: 'CAMPO GALLO',
  },
  {
    codCiudad: 1722,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Campo Grande',
  },
  {
    codCiudad: 2842,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Campo Largo',
  },
  {
    codCiudad: 781,
    codPcia: 16,
    CP: 3716,
    letra: '',
    nombre: 'CAMPO LARGO',
  },
  {
    codCiudad: 2843,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Campo Libre',
  },
  {
    codCiudad: 490,
    codPcia: 13,
    CP: 2222,
    letra: '',
    nombre: 'CAMPO MANSILLA',
  },
  {
    codCiudad: 2024,
    codPcia: 10,
    CP: 4407,
    letra: '',
    nombre: 'Campo Quijano',
  },
  {
    codCiudad: 2417,
    codPcia: 10,
    CP: 4432,
    letra: '',
    nombre: 'Campo Santo',
  },
  {
    codCiudad: 1235,
    codPcia: 18,
    CP: 3601,
    letra: '',
    nombre: 'CAMPO VILLAFAÑE',
  },
  {
    codCiudad: 629,
    codPcia: 2,
    CP: 2903,
    letra: '',
    nombre: 'CAMPOS SALLES',
  },
  {
    codCiudad: 701,
    codPcia: 6,
    CP: 3164,
    letra: '',
    nombre: 'CAMPS',
  },
  {
    codCiudad: 581,
    codPcia: 4,
    CP: 2650,
    letra: '',
    nombre: 'CANALS',
  },
  {
    codCiudad: 2970,
    codPcia: 10,
    CP: 4633,
    letra: '',
    nombre: 'Cancillar',
  },
  {
    codCiudad: 997,
    codPcia: 12,
    CP: 5713,
    letra: '',
    nombre: 'CANDELARIA',
  },
  {
    codCiudad: 1549,
    codPcia: 4,
    CP: 5249,
    letra: '',
    nombre: 'CANDELARIA',
  },
  {
    codCiudad: 915,
    codPcia: 4,
    CP: 5233,
    letra: '',
    nombre: 'CANDELARIA SUD',
  },
  {
    codCiudad: 3004,
    codPcia: 10,
    CP: 4644,
    letra: '',
    nombre: 'Cangrejillos',
  },
  {
    codCiudad: 2116,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Cangrejillos',
  },
  {
    codCiudad: 3005,
    codPcia: 10,
    CP: 4644,
    letra: '',
    nombre: 'Cangrejos',
  },
  {
    codCiudad: 2418,
    codPcia: 10,
    CP: 4432,
    letra: '',
    nombre: 'Cantera Del Sauce',
  },
  {
    codCiudad: 3114,
    codPcia: 13,
    CP: 2500,
    letra: '',
    nombre: 'CAÑADA DE GOMEZ',
  },
  {
    codCiudad: 1675,
    codPcia: 13,
    CP: 3551,
    letra: '',
    nombre: 'CAÑADA OMBÚ',
  },
  {
    codCiudad: 1576,
    codPcia: 13,
    CP: 2454,
    letra: '',
    nombre: 'CAÑADA ROSQUIN',
  },
  {
    codCiudad: 1470,
    codPcia: 2,
    CP: 0,
    letra: '',
    nombre: 'CAÑUELAS',
  },
  {
    codCiudad: 467,
    codPcia: 13,
    CP: 2154,
    letra: '',
    nombre: 'CAP. BERMUDEZ',
  },
  {
    codCiudad: 616,
    codPcia: 2,
    CP: 2752,
    letra: '',
    nombre: 'CAP. SARMIENTO',
  },
  {
    codCiudad: 212,
    codPcia: 1,
    CP: 1247,
    letra: '',
    nombre: 'CAP.FEDERAL',
  },
  {
    codCiudad: 2892,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'Capiazutti',
  },
  {
    codCiudad: 3081,
    codPcia: 10,
    CP: 5231,
    letra: '',
    nombre: 'Capilla De Siton',
  },
  {
    codCiudad: 1225,
    codPcia: 4,
    CP: 5184,
    letra: '',
    nombre: 'CAPILLA DEL MONTE',
  },
  {
    codCiudad: 623,
    codPcia: 2,
    CP: 2812,
    letra: '',
    nombre: 'CAPILLA DEL SEÑOR',
  },
  {
    codCiudad: 502,
    codPcia: 13,
    CP: 2301,
    letra: '',
    nombre: 'CAPILLA SAN JOSE',
  },
  {
    codCiudad: 334,
    codPcia: 1,
    CP: 1703,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 377,
    codPcia: 1,
    CP: 1823,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 9,
    codPcia: 1,
    CP: 1008,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 10,
    codPcia: 1,
    CP: 1009,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 11,
    codPcia: 1,
    CP: 1010,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 12,
    codPcia: 1,
    CP: 1012,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 13,
    codPcia: 1,
    CP: 1013,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 14,
    codPcia: 1,
    CP: 1014,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 15,
    codPcia: 1,
    CP: 1015,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 16,
    codPcia: 1,
    CP: 1016,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 17,
    codPcia: 1,
    CP: 1017,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 18,
    codPcia: 1,
    CP: 1018,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 19,
    codPcia: 1,
    CP: 1019,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 20,
    codPcia: 1,
    CP: 1020,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 21,
    codPcia: 1,
    CP: 1021,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 22,
    codPcia: 1,
    CP: 1022,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 23,
    codPcia: 1,
    CP: 1023,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 24,
    codPcia: 1,
    CP: 1024,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 25,
    codPcia: 1,
    CP: 1026,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 26,
    codPcia: 1,
    CP: 1027,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 27,
    codPcia: 1,
    CP: 1028,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 28,
    codPcia: 1,
    CP: 1029,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 29,
    codPcia: 1,
    CP: 1030,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 30,
    codPcia: 1,
    CP: 1031,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 31,
    codPcia: 1,
    CP: 1032,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 32,
    codPcia: 1,
    CP: 1033,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 33,
    codPcia: 1,
    CP: 1034,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 34,
    codPcia: 1,
    CP: 1035,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 35,
    codPcia: 1,
    CP: 1036,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 36,
    codPcia: 1,
    CP: 1037,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 37,
    codPcia: 1,
    CP: 1038,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 38,
    codPcia: 1,
    CP: 1039,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 39,
    codPcia: 1,
    CP: 1040,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 40,
    codPcia: 1,
    CP: 1041,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 41,
    codPcia: 1,
    CP: 1042,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 42,
    codPcia: 1,
    CP: 1043,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 43,
    codPcia: 1,
    CP: 1044,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 44,
    codPcia: 1,
    CP: 1045,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 45,
    codPcia: 1,
    CP: 1046,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 46,
    codPcia: 1,
    CP: 1047,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 47,
    codPcia: 1,
    CP: 1048,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 48,
    codPcia: 1,
    CP: 1049,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 49,
    codPcia: 1,
    CP: 1050,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 50,
    codPcia: 1,
    CP: 1052,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 51,
    codPcia: 1,
    CP: 1053,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 52,
    codPcia: 1,
    CP: 1054,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 53,
    codPcia: 1,
    CP: 1055,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 54,
    codPcia: 1,
    CP: 1056,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 55,
    codPcia: 1,
    CP: 1057,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 56,
    codPcia: 1,
    CP: 1058,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 57,
    codPcia: 1,
    CP: 1059,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 58,
    codPcia: 1,
    CP: 1060,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 59,
    codPcia: 1,
    CP: 1061,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 60,
    codPcia: 1,
    CP: 1062,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 61,
    codPcia: 1,
    CP: 1064,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 62,
    codPcia: 1,
    CP: 1065,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 63,
    codPcia: 1,
    CP: 1066,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 64,
    codPcia: 1,
    CP: 1067,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 65,
    codPcia: 1,
    CP: 1068,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 66,
    codPcia: 1,
    CP: 1069,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 67,
    codPcia: 1,
    CP: 1070,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 5,
    codPcia: 1,
    CP: 1003,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 69,
    codPcia: 1,
    CP: 1073,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 70,
    codPcia: 1,
    CP: 1075,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 71,
    codPcia: 1,
    CP: 1077,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 72,
    codPcia: 1,
    CP: 1078,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 73,
    codPcia: 1,
    CP: 1080,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 74,
    codPcia: 1,
    CP: 1081,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 75,
    codPcia: 1,
    CP: 1082,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 76,
    codPcia: 1,
    CP: 1083,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 77,
    codPcia: 1,
    CP: 1084,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 78,
    codPcia: 1,
    CP: 1085,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 79,
    codPcia: 1,
    CP: 1086,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 68,
    codPcia: 1,
    CP: 1071,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 81,
    codPcia: 1,
    CP: 1089,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 82,
    codPcia: 1,
    CP: 1090,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 83,
    codPcia: 1,
    CP: 1091,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 84,
    codPcia: 1,
    CP: 1092,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 85,
    codPcia: 1,
    CP: 1093,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 86,
    codPcia: 1,
    CP: 1094,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 87,
    codPcia: 1,
    CP: 1095,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 88,
    codPcia: 1,
    CP: 1096,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 89,
    codPcia: 1,
    CP: 1097,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 90,
    codPcia: 1,
    CP: 1100,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 91,
    codPcia: 1,
    CP: 1101,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 92,
    codPcia: 1,
    CP: 1102,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 93,
    codPcia: 1,
    CP: 1103,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 94,
    codPcia: 1,
    CP: 1104,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 95,
    codPcia: 1,
    CP: 1106,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 96,
    codPcia: 1,
    CP: 1107,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 97,
    codPcia: 1,
    CP: 1110,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 98,
    codPcia: 1,
    CP: 1112,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 99,
    codPcia: 1,
    CP: 1113,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 100,
    codPcia: 1,
    CP: 1114,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 101,
    codPcia: 1,
    CP: 1115,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 102,
    codPcia: 1,
    CP: 1117,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 103,
    codPcia: 1,
    CP: 1118,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 104,
    codPcia: 1,
    CP: 1119,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 105,
    codPcia: 1,
    CP: 1120,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 106,
    codPcia: 1,
    CP: 1121,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 107,
    codPcia: 1,
    CP: 1122,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 108,
    codPcia: 1,
    CP: 1123,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 109,
    codPcia: 1,
    CP: 1124,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 110,
    codPcia: 1,
    CP: 1125,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 111,
    codPcia: 1,
    CP: 1126,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 112,
    codPcia: 1,
    CP: 1127,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 113,
    codPcia: 1,
    CP: 1128,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 114,
    codPcia: 1,
    CP: 1129,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 115,
    codPcia: 1,
    CP: 1130,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 116,
    codPcia: 1,
    CP: 1131,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 117,
    codPcia: 1,
    CP: 1132,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 118,
    codPcia: 1,
    CP: 1133,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 119,
    codPcia: 1,
    CP: 1134,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 120,
    codPcia: 1,
    CP: 1135,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 121,
    codPcia: 1,
    CP: 1136,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 122,
    codPcia: 1,
    CP: 1137,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 123,
    codPcia: 1,
    CP: 1138,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 124,
    codPcia: 1,
    CP: 1139,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 125,
    codPcia: 1,
    CP: 1140,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 126,
    codPcia: 1,
    CP: 1141,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 127,
    codPcia: 1,
    CP: 1142,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 128,
    codPcia: 1,
    CP: 1143,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 129,
    codPcia: 1,
    CP: 1144,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 130,
    codPcia: 1,
    CP: 1145,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 131,
    codPcia: 1,
    CP: 1146,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 132,
    codPcia: 1,
    CP: 1147,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 133,
    codPcia: 1,
    CP: 1148,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 134,
    codPcia: 1,
    CP: 1149,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 135,
    codPcia: 1,
    CP: 1150,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 136,
    codPcia: 1,
    CP: 1151,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 137,
    codPcia: 1,
    CP: 1152,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 138,
    codPcia: 1,
    CP: 1153,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 139,
    codPcia: 1,
    CP: 1154,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 140,
    codPcia: 1,
    CP: 1155,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 141,
    codPcia: 1,
    CP: 1157,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 142,
    codPcia: 1,
    CP: 1165,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 143,
    codPcia: 1,
    CP: 1166,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 144,
    codPcia: 1,
    CP: 1168,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 145,
    codPcia: 1,
    CP: 1170,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 146,
    codPcia: 1,
    CP: 1171,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 147,
    codPcia: 1,
    CP: 1172,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 148,
    codPcia: 1,
    CP: 1173,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 149,
    codPcia: 1,
    CP: 1174,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 150,
    codPcia: 1,
    CP: 1175,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 151,
    codPcia: 1,
    CP: 1176,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 152,
    codPcia: 1,
    CP: 1177,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 153,
    codPcia: 1,
    CP: 1178,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 154,
    codPcia: 1,
    CP: 1179,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 155,
    codPcia: 1,
    CP: 1180,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 156,
    codPcia: 1,
    CP: 1181,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 157,
    codPcia: 1,
    CP: 1182,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 158,
    codPcia: 1,
    CP: 1183,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 159,
    codPcia: 1,
    CP: 1184,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 160,
    codPcia: 1,
    CP: 1185,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 161,
    codPcia: 1,
    CP: 1186,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 162,
    codPcia: 1,
    CP: 1187,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 163,
    codPcia: 1,
    CP: 1188,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 164,
    codPcia: 1,
    CP: 1189,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 165,
    codPcia: 1,
    CP: 1190,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 166,
    codPcia: 1,
    CP: 1191,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 167,
    codPcia: 1,
    CP: 1193,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 168,
    codPcia: 1,
    CP: 1194,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 169,
    codPcia: 1,
    CP: 1195,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 170,
    codPcia: 1,
    CP: 1196,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 171,
    codPcia: 1,
    CP: 1197,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 172,
    codPcia: 1,
    CP: 1198,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 173,
    codPcia: 1,
    CP: 1199,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 174,
    codPcia: 1,
    CP: 1201,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 175,
    codPcia: 1,
    CP: 1202,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 176,
    codPcia: 1,
    CP: 1203,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 177,
    codPcia: 1,
    CP: 1204,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 178,
    codPcia: 1,
    CP: 1205,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 259,
    codPcia: 1,
    CP: 1407,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 180,
    codPcia: 1,
    CP: 1206,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 181,
    codPcia: 1,
    CP: 1207,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 182,
    codPcia: 1,
    CP: 1208,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 183,
    codPcia: 1,
    CP: 1210,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 184,
    codPcia: 1,
    CP: 1211,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 185,
    codPcia: 1,
    CP: 1212,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 186,
    codPcia: 1,
    CP: 1213,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 187,
    codPcia: 1,
    CP: 1214,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 188,
    codPcia: 1,
    CP: 1215,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 189,
    codPcia: 1,
    CP: 1216,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 190,
    codPcia: 1,
    CP: 1217,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 191,
    codPcia: 1,
    CP: 1218,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 192,
    codPcia: 1,
    CP: 1219,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 193,
    codPcia: 1,
    CP: 1220,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 194,
    codPcia: 1,
    CP: 1221,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 195,
    codPcia: 1,
    CP: 1222,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 196,
    codPcia: 1,
    CP: 1224,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 197,
    codPcia: 1,
    CP: 1225,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 198,
    codPcia: 1,
    CP: 1226,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 199,
    codPcia: 1,
    CP: 1227,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 200,
    codPcia: 1,
    CP: 1228,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 201,
    codPcia: 1,
    CP: 1229,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 202,
    codPcia: 1,
    CP: 1230,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 203,
    codPcia: 1,
    CP: 1231,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 204,
    codPcia: 1,
    CP: 1232,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 205,
    codPcia: 1,
    CP: 1233,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 206,
    codPcia: 1,
    CP: 1234,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 207,
    codPcia: 1,
    CP: 1235,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 208,
    codPcia: 1,
    CP: 1236,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 209,
    codPcia: 1,
    CP: 1237,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 210,
    codPcia: 1,
    CP: 1242,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 211,
    codPcia: 1,
    CP: 1245,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 80,
    codPcia: 1,
    CP: 1088,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 213,
    codPcia: 1,
    CP: 1250,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 214,
    codPcia: 2,
    CP: 1252,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 215,
    codPcia: 1,
    CP: 1264,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 216,
    codPcia: 1,
    CP: 1267,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 217,
    codPcia: 1,
    CP: 1269,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 218,
    codPcia: 1,
    CP: 1270,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 219,
    codPcia: 1,
    CP: 1271,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 220,
    codPcia: 1,
    CP: 1272,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 221,
    codPcia: 1,
    CP: 1274,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 222,
    codPcia: 1,
    CP: 1275,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 223,
    codPcia: 1,
    CP: 1276,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 224,
    codPcia: 1,
    CP: 1278,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 225,
    codPcia: 1,
    CP: 1279,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 226,
    codPcia: 1,
    CP: 1282,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 227,
    codPcia: 1,
    CP: 1283,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 228,
    codPcia: 1,
    CP: 1284,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 229,
    codPcia: 1,
    CP: 1287,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 230,
    codPcia: 1,
    CP: 1291,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 231,
    codPcia: 1,
    CP: 1293,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 232,
    codPcia: 1,
    CP: 1295,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 233,
    codPcia: 1,
    CP: 1296,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 234,
    codPcia: 1,
    CP: 1309,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 235,
    codPcia: 1,
    CP: 1311,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 236,
    codPcia: 1,
    CP: 1321,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 237,
    codPcia: 1,
    CP: 1336,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 238,
    codPcia: 1,
    CP: 1340,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 239,
    codPcia: 1,
    CP: 1349,
    letra: '',
    nombre: 'Capital Federal',
  },
  {
    codCiudad: 240,
    codPcia: 1,
    CP: 1353,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 241,
    codPcia: 1,
    CP: 1354,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 242,
    codPcia: 1,
    CP: 1362,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 243,
    codPcia: 1,
    CP: 1368,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 244,
    codPcia: 1,
    CP: 1370,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 245,
    codPcia: 1,
    CP: 1372,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 246,
    codPcia: 1,
    CP: 1375,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 247,
    codPcia: 1,
    CP: 1376,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 248,
    codPcia: 1,
    CP: 1384,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 249,
    codPcia: 1,
    CP: 1385,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 250,
    codPcia: 1,
    CP: 1387,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 251,
    codPcia: 1,
    CP: 1391,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 252,
    codPcia: 1,
    CP: 1400,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 253,
    codPcia: 1,
    CP: 1401,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 254,
    codPcia: 1,
    CP: 1402,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 255,
    codPcia: 1,
    CP: 1403,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 256,
    codPcia: 1,
    CP: 1404,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 257,
    codPcia: 1,
    CP: 1405,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 258,
    codPcia: 1,
    CP: 1406,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 3,
    codPcia: 1,
    CP: 1001,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 260,
    codPcia: 1,
    CP: 1408,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 261,
    codPcia: 1,
    CP: 1409,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 262,
    codPcia: 1,
    CP: 1410,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 263,
    codPcia: 1,
    CP: 1411,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 264,
    codPcia: 1,
    CP: 1412,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 265,
    codPcia: 1,
    CP: 1414,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 266,
    codPcia: 1,
    CP: 1415,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 267,
    codPcia: 1,
    CP: 1416,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 268,
    codPcia: 1,
    CP: 1417,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 269,
    codPcia: 1,
    CP: 1419,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 270,
    codPcia: 1,
    CP: 1420,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 271,
    codPcia: 1,
    CP: 1424,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 272,
    codPcia: 1,
    CP: 1425,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 273,
    codPcia: 1,
    CP: 1426,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 274,
    codPcia: 1,
    CP: 1427,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 275,
    codPcia: 1,
    CP: 1428,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 276,
    codPcia: 1,
    CP: 1429,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 277,
    codPcia: 1,
    CP: 1430,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 278,
    codPcia: 1,
    CP: 1431,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 279,
    codPcia: 1,
    CP: 1436,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 280,
    codPcia: 1,
    CP: 1437,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 281,
    codPcia: 1,
    CP: 1439,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 282,
    codPcia: 1,
    CP: 1440,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 283,
    codPcia: 1,
    CP: 1513,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 8,
    codPcia: 1,
    CP: 1007,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 6,
    codPcia: 1,
    CP: 1004,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 7,
    codPcia: 1,
    CP: 1005,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 2,
    codPcia: 1,
    CP: 1000,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 4,
    codPcia: 1,
    CP: 1002,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 302,
    codPcia: 1,
    CP: 1633,
    letra: '',
    nombre: 'CAPITAL FEDERAL',
  },
  {
    codCiudad: 2844,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Capitan Juan Page',
  },
  {
    codCiudad: 2845,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Capitan Pages',
  },
  {
    codCiudad: 749,
    codPcia: 16,
    CP: 3515,
    letra: '',
    nombre: 'CAPITAN SOLARI',
  },
  {
    codCiudad: 3125,
    codPcia: 13,
    CP: 2311,
    letra: '',
    nombre: 'CAPIVARA',
  },
  {
    codCiudad: 2001,
    codPcia: 10,
    CP: 4405,
    letra: '',
    nombre: 'Carabajal',
  },
  {
    codCiudad: 3006,
    codPcia: 10,
    CP: 4644,
    letra: '',
    nombre: 'Caracara',
  },
  {
    codCiudad: 2301,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'Carahuasi',
  },
  {
    codCiudad: 286,
    codPcia: 2,
    CP: 1605,
    letra: '',
    nombre: 'CARAPACHAY',
  },
  {
    codCiudad: 2893,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'Carapari',
  },
  {
    codCiudad: 3039,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'Carayoc',
  },
  {
    codCiudad: 457,
    codPcia: 13,
    CP: 2138,
    letra: '',
    nombre: 'CARCARAÑA',
  },
  {
    codCiudad: 1099,
    codPcia: 2,
    CP: 6430,
    letra: '',
    nombre: 'CARHUE',
  },
  {
    codCiudad: 1590,
    codPcia: 2,
    CP: 6530,
    letra: '',
    nombre: 'CARLOS CASARES',
  },
  {
    codCiudad: 1130,
    codPcia: 2,
    CP: 6701,
    letra: '',
    nombre: 'CARLOS KEEN',
  },
  {
    codCiudad: 521,
    codPcia: 13,
    CP: 2453,
    letra: '',
    nombre: 'CARLOS PELLEGRINI',
  },
  {
    codCiudad: 372,
    codPcia: 2,
    CP: 1812,
    letra: '',
    nombre: 'CARLOS SPEGAZINI',
  },
  {
    codCiudad: 1274,
    codPcia: 2,
    CP: 6455,
    letra: '',
    nombre: 'CARLOS TEJEDOR',
  },
  {
    codCiudad: 568,
    codPcia: 13,
    CP: 2618,
    letra: '',
    nombre: 'CARMEN',
  },
  {
    codCiudad: 1138,
    codPcia: 2,
    CP: 6725,
    letra: '',
    nombre: 'CARMEN DE ARECO',
  },
  {
    codCiudad: 1481,
    codPcia: 2,
    CP: 8504,
    letra: '',
    nombre: 'CARMEN DE PATAGONES',
  },
  {
    codCiudad: 1474,
    codPcia: 17,
    CP: 9201,
    letra: '',
    nombre: 'Carreneufi',
  },
  {
    codCiudad: 1501,
    codPcia: 17,
    CP: 9201,
    letra: '',
    nombre: 'CARRENLEUFU - LANGUIÑEO',
  },
  {
    codCiudad: 609,
    codPcia: 13,
    CP: 2729,
    letra: '',
    nombre: 'CARRERAS',
  },
  {
    codCiudad: 2441,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'Carreras',
  },
  {
    codCiudad: 1668,
    codPcia: 9,
    CP: 5505,
    letra: '',
    nombre: 'CARRODILLA',
  },
  {
    codCiudad: 961,
    codPcia: 9,
    CP: 5503,
    letra: '',
    nombre: 'CARRODILLA',
  },
  {
    codCiudad: 1459,
    codPcia: 4,
    CP: 5162,
    letra: '',
    nombre: 'CASA GRANDE',
  },
  {
    codCiudad: 2996,
    codPcia: 10,
    CP: 4634,
    letra: '',
    nombre: 'Casa Grande',
  },
  {
    codCiudad: 2971,
    codPcia: 10,
    CP: 4633,
    letra: '',
    nombre: 'Casa Grande',
  },
  {
    codCiudad: 495,
    codPcia: 13,
    CP: 2248,
    letra: '',
    nombre: 'CASALEGNO',
  },
  {
    codCiudad: 3095,
    codPcia: 10,
    CP: 5236,
    letra: '',
    nombre: 'Casas Viejas',
  },
  {
    codCiudad: 328,
    codPcia: 2,
    CP: 1678,
    letra: '',
    nombre: 'CASEROS',
  },
  {
    codCiudad: 469,
    codPcia: 13,
    CP: 2170,
    letra: '',
    nombre: 'CASILDA',
  },
  {
    codCiudad: 338,
    codPcia: 2,
    CP: 1712,
    letra: '',
    nombre: 'CASTELAR',
  },
  {
    codCiudad: 1951,
    codPcia: 10,
    CP: 4401,
    letra: '',
    nombre: 'Castellanos',
  },
  {
    codCiudad: 1152,
    codPcia: 2,
    CP: 7114,
    letra: '',
    nombre: 'CASTELLI',
  },
  {
    codCiudad: 3030,
    codPcia: 10,
    CP: 4650,
    letra: '',
    nombre: 'Casti',
  },
  {
    codCiudad: 1119,
    codPcia: 2,
    CP: 6616,
    letra: '',
    nombre: 'CASTILLA',
  },
  {
    codCiudad: 925,
    codPcia: 8,
    CP: 5276,
    letra: '',
    nombre: 'CASTRO BARROS',
  },
  {
    codCiudad: 864,
    codPcia: 3,
    CP: 4700,
    letra: '',
    nombre: 'CATAMARCA',
  },
  {
    codCiudad: 1462,
    codPcia: 19,
    CP: 6330,
    letra: '',
    nombre: 'CATRILO',
  },
  {
    codCiudad: 2086,
    codPcia: 10,
    CP: 4413,
    letra: '',
    nombre: 'Catua',
  },
  {
    codCiudad: 958,
    codPcia: 11,
    CP: 5442,
    letra: '',
    nombre: 'CAUCETE',
  },
  {
    codCiudad: 2087,
    codPcia: 10,
    CP: 4413,
    letra: '',
    nombre: 'Cauchari',
  },
  {
    codCiudad: 571,
    codPcia: 13,
    CP: 2625,
    letra: '',
    nombre: 'CAVANAGH',
  },
  {
    codCiudad: 1514,
    codPcia: 21,
    CP: 8349,
    letra: '',
    nombre: 'CAVIAHUE-COPAHUE',
  },
  {
    codCiudad: 1308,
    codPcia: 13,
    CP: 3001,
    letra: '',
    nombre: 'CAYASTÁ',
  },
  {
    codCiudad: 3179,
    codPcia: 13,
    CP: 3038,
    letra: '',
    nombre: 'CAYASTACITO',
  },
  {
    codCiudad: 669,
    codPcia: 13,
    CP: 3038,
    letra: '',
    nombre: 'CAYASTASIO',
  },
  {
    codCiudad: 522,
    codPcia: 13,
    CP: 2454,
    letra: '',
    nombre: 'CDA ROSQUIN',
  },
  {
    codCiudad: 1973,
    codPcia: 10,
    CP: 4403,
    letra: '',
    nombre: 'Cebados',
  },
  {
    codCiudad: 1776,
    codPcia: 10,
    CP: 4126,
    letra: '',
    nombre: 'Ceibal',
  },
  {
    codCiudad: 2527,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'Ceibalito',
  },
  {
    codCiudad: 1597,
    codPcia: 6,
    CP: 2823,
    letra: '',
    nombre: 'CEIBAS',
  },
  {
    codCiudad: 1620,
    codPcia: 21,
    CP: 8309,
    letra: '',
    nombre: 'CENTENARIO',
  },
  {
    codCiudad: 465,
    codPcia: 13,
    CP: 2148,
    letra: '',
    nombre: 'CENTENO',
  },
  {
    codCiudad: 1497,
    codPcia: 13,
    CP: 2105,
    letra: '',
    nombre: 'CEPEDA',
  },
  {
    codCiudad: 509,
    codPcia: 13,
    CP: 2340,
    letra: '',
    nombre: 'CERES',
  },
  {
    codCiudad: 1974,
    codPcia: 10,
    CP: 4403,
    letra: '',
    nombre: 'Cerrillos',
  },
  {
    codCiudad: 1560,
    codPcia: 6,
    CP: 3122,
    letra: '',
    nombre: 'CERRITO',
  },
  {
    codCiudad: 3074,
    codPcia: 10,
    CP: 4653,
    letra: '',
    nombre: 'Cerrito',
  },
  {
    codCiudad: 2302,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'Cerro Alemania',
  },
  {
    codCiudad: 3138,
    codPcia: 20,
    CP: 3313,
    letra: '',
    nombre: 'CERRO AZUL',
  },
  {
    codCiudad: 2033,
    codPcia: 10,
    CP: 4409,
    letra: '',
    nombre: 'Cerro Bayo',
  },
  {
    codCiudad: 1000,
    codPcia: 12,
    CP: 5731,
    letra: '',
    nombre: 'CERRO BLANCO',
  },
  {
    codCiudad: 2187,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'Cerro Bravo',
  },
  {
    codCiudad: 1852,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'Cerro Colorado',
  },
  {
    codCiudad: 1014,
    codPcia: 4,
    CP: 5821,
    letra: '',
    nombre: 'CERRO COLORADO',
  },
  {
    codCiudad: 1352,
    codPcia: 4,
    CP: 5243,
    letra: '',
    nombre: 'CERRO COLORADO',
  },
  {
    codCiudad: 1423,
    codPcia: 4,
    CP: 5009,
    letra: '',
    nombre: 'CERRO DE LAS ROSAS',
  },
  {
    codCiudad: 2117,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Cerro Mal Canto',
  },
  {
    codCiudad: 1853,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'Cerro Negro',
  },
  {
    codCiudad: 1827,
    codPcia: 10,
    CP: 4190,
    letra: '',
    nombre: 'Cerro Negro',
  },
  {
    codCiudad: 1629,
    codPcia: 22,
    CP: 8333,
    letra: '',
    nombre: 'CERRO POLICIA',
  },
  {
    codCiudad: 1292,
    codPcia: 22,
    CP: 8326,
    letra: '',
    nombre: 'CERVANTES',
  },
  {
    codCiudad: 2303,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'Cevilar',
  },
  {
    codCiudad: 579,
    codPcia: 13,
    CP: 2643,
    letra: '',
    nombre: 'CHAÑAR LADEADO',
  },
  {
    codCiudad: 471,
    codPcia: 13,
    CP: 2173,
    letra: '',
    nombre: 'CHABAS',
  },
  {
    codCiudad: 1141,
    codPcia: 2,
    CP: 6740,
    letra: '',
    nombre: 'CHACABUCO',
  },
  {
    codCiudad: 1934,
    codPcia: 10,
    CP: 4400,
    letra: '',
    nombre: 'Chachapoyas',
  },
  {
    codCiudad: 1298,
    codPcia: 19,
    CP: 8201,
    letra: '',
    nombre: 'CHACHARRAMENDI',
  },
  {
    codCiudad: 2088,
    codPcia: 10,
    CP: 4413,
    letra: '',
    nombre: 'Chachas',
  },
  {
    codCiudad: 2377,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'Chacra Exp.',
  },
  {
    codCiudad: 962,
    codPcia: 9,
    CP: 5505,
    letra: '',
    nombre: 'CHACRAS DE CORIA',
  },
  {
    codCiudad: 2799,
    codPcia: 10,
    CP: 4537,
    letra: '',
    nombre: 'Chaguaral',
  },
  {
    codCiudad: 708,
    codPcia: 6,
    CP: 3228,
    letra: '',
    nombre: 'CHAJARI',
  },
  {
    codCiudad: 1935,
    codPcia: 10,
    CP: 4400,
    letra: '',
    nombre: 'Chamical',
  },
  {
    codCiudad: 1256,
    codPcia: 8,
    CP: 5380,
    letra: '',
    nombre: 'CHAMICAL',
  },
  {
    codCiudad: 1254,
    codPcia: 0,
    CP: 5380,
    letra: '',
    nombre: 'CHAMICAL',
  },
  {
    codCiudad: 1029,
    codPcia: 4,
    CP: 5871,
    letra: '',
    nombre: 'CHANCANI',
  },
  {
    codCiudad: 2672,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Chañar Aguada',
  },
  {
    codCiudad: 1903,
    codPcia: 10,
    CP: 4197,
    letra: '',
    nombre: 'Chañar Pozo',
  },
  {
    codCiudad: 1407,
    codPcia: 2,
    CP: 7601,
    letra: '',
    nombre: 'CHAPADMALAL',
  },
  {
    codCiudad: 561,
    codPcia: 13,
    CP: 2603,
    letra: '',
    nombre: 'CHAPUY',
  },
  {
    codCiudad: 2972,
    codPcia: 10,
    CP: 4633,
    letra: '',
    nombre: 'Chaqar',
  },
  {
    codCiudad: 2528,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'Chaqar Muyo',
  },
  {
    codCiudad: 747,
    codPcia: 16,
    CP: 3513,
    letra: '',
    nombre: 'CHARADAI',
  },
  {
    codCiudad: 783,
    codPcia: 16,
    CP: 3730,
    letra: '',
    nombre: 'CHARATA-CHACO',
  },
  {
    codCiudad: 1311,
    codPcia: 2,
    CP: 7130,
    letra: '',
    nombre: 'CHASCOMUS',
  },
  {
    codCiudad: 1391,
    codPcia: 5,
    CP: 3474,
    letra: '',
    nombre: 'CHAVARRIA',
  },
  {
    codCiudad: 1318,
    codPcia: 4,
    CP: 5925,
    letra: '',
    nombre: 'CHAZÓN',
  },
  {
    codCiudad: 1431,
    codPcia: 19,
    CP: 6323,
    letra: '',
    nombre: 'CHICAL CO',
  },
  {
    codCiudad: 2269,
    codPcia: 10,
    CP: 4423,
    letra: '',
    nombre: 'Chicoana',
  },
  {
    codCiudad: 2188,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'Chicoana',
  },
  {
    codCiudad: 2442,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'Chilcas',
  },
  {
    codCiudad: 947,
    codPcia: 8,
    CP: 5360,
    letra: '',
    nombre: 'CHILECITO',
  },
  {
    codCiudad: 1304,
    codPcia: 4,
    CP: 2561,
    letra: '',
    nombre: 'CHILIBROSTE',
  },
  {
    codCiudad: 1172,
    codPcia: 2,
    CP: 7311,
    letra: '',
    nombre: 'CHILLAR',
  },
  {
    codCiudad: 952,
    codPcia: 11,
    CP: 5413,
    letra: '',
    nombre: 'CHIMBAS',
  },
  {
    codCiudad: 1618,
    codPcia: 22,
    CP: 8364,
    letra: '',
    nombre: 'CHIMPAY',
  },
  {
    codCiudad: 2846,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Chirete',
  },
  {
    codCiudad: 1120,
    codPcia: 2,
    CP: 6620,
    letra: '',
    nombre: 'CHIVILCOY',
  },
  {
    codCiudad: 2270,
    codPcia: 10,
    CP: 4423,
    letra: '',
    nombre: 'Chivilme',
  },
  {
    codCiudad: 2973,
    codPcia: 10,
    CP: 4633,
    letra: '',
    nombre: 'Chiyayoc',
  },
  {
    codCiudad: 3007,
    codPcia: 10,
    CP: 4644,
    letra: '',
    nombre: 'Chocoite',
  },
  {
    codCiudad: 1205,
    codPcia: 22,
    CP: 8360,
    letra: '',
    nombre: 'CHOELE CHOEL',
  },
  {
    codCiudad: 1500,
    codPcia: 17,
    CP: 9217,
    letra: '',
    nombre: 'CHOLILA',
  },
  {
    codCiudad: 2034,
    codPcia: 10,
    CP: 4409,
    letra: '',
    nombre: 'Chorrillitos',
  },
  {
    codCiudad: 2002,
    codPcia: 10,
    CP: 4405,
    letra: '',
    nombre: 'Chorrillos',
  },
  {
    codCiudad: 2118,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Chorro Blanco',
  },
  {
    codCiudad: 2529,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'Chorroarin',
  },
  {
    codCiudad: 575,
    codPcia: 13,
    CP: 2633,
    letra: '',
    nombre: 'CHOVET',
  },
  {
    codCiudad: 2089,
    codPcia: 10,
    CP: 4413,
    letra: '',
    nombre: 'Chuculaqui',
  },
  {
    codCiudad: 935,
    codPcia: 8,
    CP: 5301,
    letra: '',
    nombre: 'CHUQUIS',
  },
  {
    codCiudad: 2760,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'Ciervo Cansado',
  },
  {
    codCiudad: 3168,
    codPcia: 16,
    CP: 3515,
    letra: '',
    nombre: 'CIERVO PETISO',
  },
  {
    codCiudad: 1200,
    codPcia: 22,
    CP: 8303,
    letra: '',
    nombre: 'CINCO SALTOS',
  },
  {
    codCiudad: 544,
    codPcia: 4,
    CP: 2559,
    letra: '',
    nombre: 'CINTRA',
  },
  {
    codCiudad: 1276,
    codPcia: 21,
    CP: 8324,
    letra: '',
    nombre: 'CIPOLLETTI',
  },
  {
    codCiudad: 1201,
    codPcia: 22,
    CP: 8324,
    letra: '',
    nombre: 'CIPOLLETTI',
  },
  {
    codCiudad: 410,
    codPcia: 2,
    CP: 1896,
    letra: '',
    nombre: 'CITY BELL',
  },
  {
    codCiudad: 333,
    codPcia: 2,
    CP: 1702,
    letra: '',
    nombre: 'CIUDADELA',
  },
  {
    codCiudad: 489,
    codPcia: 13,
    CP: 2218,
    letra: '',
    nombre: 'CLARKE',
  },
  {
    codCiudad: 462,
    codPcia: 13,
    CP: 2146,
    letra: '',
    nombre: 'CLASON',
  },
  {
    codCiudad: 389,
    codPcia: 2,
    CP: 1849,
    letra: '',
    nombre: 'CLAYPOLE',
  },
  {
    codCiudad: 846,
    codPcia: 14,
    CP: 4338,
    letra: '',
    nombre: 'CLODOMIRA',
  },
  {
    codCiudad: 771,
    codPcia: 18,
    CP: 3610,
    letra: '',
    nombre: 'CLORINDA',
  },
  {
    codCiudad: 3151,
    codPcia: 13,
    CP: 2407,
    letra: '',
    nombre: 'CLUSELLAS',
  },
  {
    codCiudad: 426,
    codPcia: 13,
    CP: 2103,
    letra: '',
    nombre: 'CNEL BOGADO',
  },
  {
    codCiudad: 420,
    codPcia: 2,
    CP: 1980,
    letra: '',
    nombre: 'CNEL BRANDSEN',
  },
  {
    codCiudad: 2847,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Cnel Juan Sola Est Morillo',
  },
  {
    codCiudad: 1723,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Cnel M Mez De Hoz',
  },
  {
    codCiudad: 1181,
    codPcia: 2,
    CP: 7530,
    letra: '',
    nombre: 'CNEL PRINGLES',
  },
  {
    codCiudad: 1121,
    codPcia: 2,
    CP: 6628,
    letra: '',
    nombre: 'CNEL SEGUI',
  },
  {
    codCiudad: 428,
    codPcia: 13,
    CP: 2105,
    letra: '',
    nombre: 'CNEL.DOMINGUEZ',
  },
  {
    codCiudad: 2443,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'Coba',
  },
  {
    codCiudad: 2419,
    codPcia: 10,
    CP: 4432,
    letra: '',
    nombre: 'Cobos',
  },
  {
    codCiudad: 1801,
    codPcia: 10,
    CP: 4141,
    letra: '',
    nombre: 'Colalao Del Valle',
  },
  {
    codCiudad: 1854,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'Colgadas',
  },
  {
    codCiudad: 2189,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'Colmenar',
  },
  {
    codCiudad: 2190,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'Colome',
  },
  {
    codCiudad: 1472,
    codPcia: 6,
    CP: 3280,
    letra: '',
    nombre: 'COLON',
  },
  {
    codCiudad: 1975,
    codPcia: 10,
    CP: 4403,
    letra: '',
    nombre: 'Colon',
  },
  {
    codCiudad: 602,
    codPcia: 2,
    CP: 2720,
    letra: '',
    nombre: 'COLON',
  },
  {
    codCiudad: 2693,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'Colonia A',
  },
  {
    codCiudad: 666,
    codPcia: 13,
    CP: 3029,
    letra: '',
    nombre: 'COLONIA ADOLFO ALSIN',
  },
  {
    codCiudad: 1626,
    codPcia: 13,
    CP: 2317,
    letra: '',
    nombre: 'COLONIA ALDAO',
  },
  {
    codCiudad: 3131,
    codPcia: 14,
    CP: 2341,
    letra: '',
    nombre: 'COLONIA ALPINA',
  },
  {
    codCiudad: 1773,
    codPcia: 10,
    CP: 3700,
    letra: '',
    nombre: 'Colonia Bajo Hondo',
  },
  {
    codCiudad: 3110,
    codPcia: 16,
    CP: 3733,
    letra: '',
    nombre: 'COLONIA BARANDA',
  },
  {
    codCiudad: 1239,
    codPcia: 16,
    CP: 3505,
    letra: '',
    nombre: 'COLONIA BENITEZ',
  },
  {
    codCiudad: 913,
    codPcia: 4,
    CP: 5223,
    letra: '',
    nombre: 'COLONIA CAROYA',
  },
  {
    codCiudad: 1546,
    codPcia: 13,
    CP: 2401,
    letra: '',
    nombre: 'COLONIA CASTELAR',
  },
  {
    codCiudad: 2694,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'Colonia D',
  },
  {
    codCiudad: 1680,
    codPcia: 14,
    CP: 4332,
    letra: '',
    nombre: 'COLONIA DORA',
  },
  {
    codCiudad: 2224,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'Colonia El Fuerte',
  },
  {
    codCiudad: 1604,
    codPcia: 18,
    CP: 3606,
    letra: '',
    nombre: 'COLONIA EL OLVIDO',
  },
  {
    codCiudad: 750,
    codPcia: 16,
    CP: 3515,
    letra: '',
    nombre: 'COLONIA ELISA',
  },
  {
    codCiudad: 503,
    codPcia: 13,
    CP: 2301,
    letra: '',
    nombre: 'COLONIA FIDELA',
  },
  {
    codCiudad: 1173,
    codPcia: 2,
    CP: 7318,
    letra: '',
    nombre: 'COLONIA HINOJO',
  },
  {
    codCiudad: 2599,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'Colonia Hurlingham',
  },
  {
    codCiudad: 3172,
    codPcia: 18,
    CP: 3613,
    letra: '',
    nombre: 'COLONIA LA FRONTERA',
  },
  {
    codCiudad: 717,
    codPcia: 5,
    CP: 3358,
    letra: '',
    nombre: "COLONIA LIEBIG'S",
  },
  {
    codCiudad: 3159,
    codPcia: 14,
    CP: 2354,
    letra: '',
    nombre: 'COLONIA MACKINLEY',
  },
  {
    codCiudad: 3139,
    codPcia: 13,
    CP: 2341,
    letra: '',
    nombre: 'COLONIA MONTEFIORE',
  },
  {
    codCiudad: 2818,
    codPcia: 10,
    CP: 4550,
    letra: '',
    nombre: 'Colonia Otomana',
  },
  {
    codCiudad: 3167,
    codPcia: 4,
    CP: 2423,
    letra: '',
    nombre: 'COLONIA PROSPERIDAD',
  },
  {
    codCiudad: 1682,
    codPcia: 13,
    CP: 2322,
    letra: '',
    nombre: 'COLONIA RAQUEL',
  },
  {
    codCiudad: 707,
    codPcia: 6,
    CP: 3218,
    letra: '',
    nombre: 'COLONIA SAN JOSE',
  },
  {
    codCiudad: 1371,
    codPcia: 6,
    CP: 3265,
    letra: '',
    nombre: 'COLONIA SAN MIGUEL',
  },
  {
    codCiudad: 1707,
    codPcia: 10,
    CP: 4531,
    letra: '',
    nombre: 'Colonia Santa Rosa',
  },
  {
    codCiudad: 860,
    codPcia: 7,
    CP: 4531,
    letra: '',
    nombre: 'COLONIA SANTA ROSA',
  },
  {
    codCiudad: 3135,
    codPcia: 13,
    CP: 3042,
    letra: '',
    nombre: 'COLONIA SILVA',
  },
  {
    codCiudad: 1664,
    codPcia: 13,
    CP: 3005,
    letra: '',
    nombre: 'COLONIA TERESA',
  },
  {
    codCiudad: 3175,
    codPcia: 16,
    CP: 3536,
    letra: '',
    nombre: 'COLONIA VEYTES',
  },
  {
    codCiudad: 1558,
    codPcia: 4,
    CP: 2420,
    letra: '',
    nombre: 'COLONIA VIGNAUD',
  },
  {
    codCiudad: 721,
    codPcia: 20,
    CP: 3376,
    letra: '',
    nombre: 'COLONIA WANDA',
  },
  {
    codCiudad: 3190,
    codPcia: 6,
    CP: 3201,
    letra: '',
    nombre: 'COLONIA YERUA',
  },
  {
    codCiudad: 1077,
    codPcia: 13,
    CP: 6103,
    letra: '',
    nombre: 'COLONIAS CERNADAS',
  },
  {
    codCiudad: 2974,
    codPcia: 10,
    CP: 4633,
    letra: '',
    nombre: 'Colorado',
  },
  {
    codCiudad: 2191,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'Colte',
  },
  {
    codCiudad: 1428,
    codPcia: 22,
    CP: 8416,
    letra: '',
    nombre: 'COMALLO',
  },
  {
    codCiudad: 1454,
    codPcia: 18,
    CP: 3620,
    letra: '',
    nombre: 'COMANDANTE FONTANA',
  },
  {
    codCiudad: 1375,
    codPcia: 2,
    CP: 7603,
    letra: '',
    nombre: 'COMANDANTE NICANOR OTAMENDI',
  },
  {
    codCiudad: 1212,
    codPcia: 17,
    CP: 9000,
    letra: '',
    nombre: 'COMODORO RIVADAVIA',
  },
  {
    codCiudad: 3108,
    codPcia: 13,
    CP: 3038,
    letra: '',
    nombre: 'COMUNA DE CAYASTACITO',
  },
  {
    codCiudad: 1005,
    codPcia: 12,
    CP: 5770,
    letra: '',
    nombre: 'CONCARAN',
  },
  {
    codCiudad: 810,
    codPcia: 15,
    CP: 4146,
    letra: '',
    nombre: 'CONCEPCION',
  },
  {
    codCiudad: 1333,
    codPcia: 5,
    CP: 3423,
    letra: '',
    nombre: 'CONCEPCION',
  },
  {
    codCiudad: 3174,
    codPcia: 20,
    CP: 3355,
    letra: '',
    nombre: 'CONCEPCION DE LA SIERRA',
  },
  {
    codCiudad: 778,
    codPcia: 16,
    CP: 3708,
    letra: '',
    nombre: 'CONCEPCION DEL BERME',
  },
  {
    codCiudad: 712,
    codPcia: 6,
    CP: 3260,
    letra: '',
    nombre: 'CONCEPCION DEL URUGUAY',
  },
  {
    codCiudad: 2485,
    codPcia: 10,
    CP: 4440,
    letra: '',
    nombre: 'Conchas',
  },
  {
    codCiudad: 706,
    codPcia: 6,
    CP: 3200,
    letra: '',
    nombre: 'CONCORDIA',
  },
  {
    codCiudad: 3040,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'Condado',
  },
  {
    codCiudad: 1828,
    codPcia: 10,
    CP: 4190,
    letra: '',
    nombre: 'Condor',
  },
  {
    codCiudad: 631,
    codPcia: 2,
    CP: 2907,
    letra: '',
    nombre: 'CONESA',
  },
  {
    codCiudad: 1414,
    codPcia: 21,
    CP: 8300,
    letra: '',
    nombre: 'CONFLUENCIA',
  },
  {
    codCiudad: 1502,
    codPcia: 6,
    CP: 3188,
    letra: '',
    nombre: 'CONSCRIPTO BERNARDI',
  },
  {
    codCiudad: 1644,
    codPcia: 13,
    CP: 2311,
    letra: '',
    nombre: 'CONSTANZA',
  },
  {
    codCiudad: 1855,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'Copo Quile',
  },
  {
    codCiudad: 2975,
    codPcia: 10,
    CP: 4633,
    letra: '',
    nombre: 'Coranzulli',
  },
  {
    codCiudad: 1602,
    codPcia: 17,
    CP: 9201,
    letra: '',
    nombre: 'CORCOVADO',
  },
  {
    codCiudad: 1296,
    codPcia: 4,
    CP: 5016,
    letra: '',
    nombre: 'CÓRDOBA',
  },
  {
    codCiudad: 1083,
    codPcia: 4,
    CP: 6123,
    letra: '',
    nombre: 'CORDOBA',
  },
  {
    codCiudad: 868,
    codPcia: 4,
    CP: 5001,
    letra: '',
    nombre: 'CORDOBA',
  },
  {
    codCiudad: 867,
    codPcia: 4,
    CP: 5000,
    letra: '',
    nombre: 'CORDOBA',
  },
  {
    codCiudad: 873,
    codPcia: 4,
    CP: 5014,
    letra: '',
    nombre: 'CORDOBA - BARRIO MAIPU',
  },
  {
    codCiudad: 424,
    codPcia: 13,
    CP: 2040,
    letra: '',
    nombre: 'CORONDA',
  },
  {
    codCiudad: 491,
    codPcia: 13,
    CP: 2240,
    letra: '',
    nombre: 'CORONDA',
  },
  {
    codCiudad: 1270,
    codPcia: 13,
    CP: 2123,
    letra: '',
    nombre: 'CORONEL ARNOLD',
  },
  {
    codCiudad: 1595,
    codPcia: 2,
    CP: 1980,
    letra: '',
    nombre: 'CORONEL BRANDSEN',
  },
  {
    codCiudad: 2833,
    codPcia: 10,
    CP: 4552,
    letra: '',
    nombre: 'Coronel Cornejo',
  },
  {
    codCiudad: 2741,
    codPcia: 10,
    CP: 4534,
    letra: '',
    nombre: 'Coronel Cornejo',
  },
  {
    codCiudad: 435,
    codPcia: 3,
    CP: 2114,
    letra: '',
    nombre: 'CORONEL DOMINGUEZ',
  },
  {
    codCiudad: 3202,
    codPcia: 13,
    CP: 2105,
    letra: '',
    nombre: 'CORONEL DOMINGUEZ',
  },
  {
    codCiudad: 1551,
    codPcia: 2,
    CP: 8150,
    letra: '',
    nombre: 'CORONEL DORREGO',
  },
  {
    codCiudad: 967,
    codPcia: 9,
    CP: 5519,
    letra: '',
    nombre: 'CORONEL DORREGO',
  },
  {
    codCiudad: 3141,
    codPcia: 16,
    CP: 3735,
    letra: '',
    nombre: 'CORONEL DU GRATY',
  },
  {
    codCiudad: 2806,
    codPcia: 10,
    CP: 4538,
    letra: '',
    nombre: 'Coronel Juan Sola',
  },
  {
    codCiudad: 1020,
    codPcia: 4,
    CP: 5847,
    letra: '',
    nombre: 'CORONEL MOLDES',
  },
  {
    codCiudad: 2225,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'Coronel Moldes',
  },
  {
    codCiudad: 2637,
    codPcia: 10,
    CP: 4451,
    letra: '',
    nombre: 'Coronel Mollinedo',
  },
  {
    codCiudad: 2530,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'Coronel Olleros',
  },
  {
    codCiudad: 1222,
    codPcia: 2,
    CP: 7530,
    letra: '',
    nombre: 'CORONEL PRINGLES',
  },
  {
    codCiudad: 1182,
    codPcia: 2,
    CP: 7540,
    letra: '',
    nombre: 'CORONEL SUAREZ',
  },
  {
    codCiudad: 1499,
    codPcia: 2,
    CP: 7174,
    letra: '',
    nombre: 'CORONEL VIDAL',
  },
  {
    codCiudad: 2558,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'Coronel Vidt',
  },
  {
    codCiudad: 2304,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'Coropampa',
  },
  {
    codCiudad: 3148,
    codPcia: 20,
    CP: 3327,
    letra: '',
    nombre: 'CORPUS CHRISTI',
  },
  {
    codCiudad: 1221,
    codPcia: 4,
    CP: 2645,
    letra: '',
    nombre: 'CORRAL DE BUSTOS',
  },
  {
    codCiudad: 580,
    codPcia: 13,
    CP: 2645,
    letra: '',
    nombre: 'CORRAL DE BUSTOS',
  },
  {
    codCiudad: 2531,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'Corral Quemado',
  },
  {
    codCiudad: 2834,
    codPcia: 10,
    CP: 4552,
    letra: '',
    nombre: 'Corralito',
  },
  {
    codCiudad: 3031,
    codPcia: 10,
    CP: 4650,
    letra: '',
    nombre: 'Corralito',
  },
  {
    codCiudad: 2341,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'Corralito',
  },
  {
    codCiudad: 924,
    codPcia: 3,
    CP: 5265,
    letra: '',
    nombre: 'CORRALITO',
  },
  {
    codCiudad: 528,
    codPcia: 13,
    CP: 2506,
    letra: '',
    nombre: 'CORREA',
  },
  {
    codCiudad: 2192,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'Corrida De Cori',
  },
  {
    codCiudad: 723,
    codPcia: 5,
    CP: 3400,
    letra: '',
    nombre: 'CORRIENTES',
  },
  {
    codCiudad: 1886,
    codPcia: 10,
    CP: 4195,
    letra: '',
    nombre: 'Cortaderas',
  },
  {
    codCiudad: 1135,
    codPcia: 2,
    CP: 6712,
    letra: '',
    nombre: 'CORTINES',
  },
  {
    codCiudad: 1282,
    codPcia: 16,
    CP: 3718,
    letra: '',
    nombre: 'CORZUELA',
  },
  {
    codCiudad: 2819,
    codPcia: 10,
    CP: 4550,
    letra: '',
    nombre: 'Corzuela',
  },
  {
    codCiudad: 1829,
    codPcia: 10,
    CP: 4190,
    letra: '',
    nombre: 'Cosme',
  },
  {
    codCiudad: 897,
    codPcia: 4,
    CP: 5166,
    letra: '',
    nombre: 'COSQUIN',
  },
  {
    codCiudad: 1053,
    codPcia: 4,
    CP: 5961,
    letra: '',
    nombre: 'COSTA SACATE',
  },
  {
    codCiudad: 1251,
    codPcia: 16,
    CP: 3513,
    letra: '',
    nombre: 'COTE LAI',
  },
  {
    codCiudad: 693,
    codPcia: 6,
    CP: 3116,
    letra: '',
    nombre: 'CRESPO',
  },
  {
    codCiudad: 1687,
    codPcia: 13,
    CP: 2441,
    letra: '',
    nombre: 'CRISPI',
  },
  {
    codCiudad: 1072,
    codPcia: 13,
    CP: 6039,
    letra: '',
    nombre: 'CRISTOPHERSEN',
  },
  {
    codCiudad: 826,
    codPcia: 3,
    CP: 4184,
    letra: '',
    nombre: 'CRUZ ALTA',
  },
  {
    codCiudad: 479,
    codPcia: 4,
    CP: 2189,
    letra: '',
    nombre: 'CRUZ ALTA',
  },
  {
    codCiudad: 2638,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Cruz Bajada',
  },
  {
    codCiudad: 926,
    codPcia: 4,
    CP: 5280,
    letra: '',
    nombre: 'CRUZ DEL EJE',
  },
  {
    codCiudad: 2444,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'Cruz Quemada',
  },
  {
    codCiudad: 1771,
    codPcia: 10,
    CP: 3642,
    letra: '',
    nombre: 'Ctro F Clorinda',
  },
  {
    codCiudad: 1142,
    codPcia: 2,
    CP: 6746,
    letra: '',
    nombre: 'CUCHA CUCHA',
  },
  {
    codCiudad: 2193,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'Cuchiyaco',
  },
  {
    codCiudad: 3041,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'Cuesta Azul',
  },
  {
    codCiudad: 2119,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Cuesta Chica',
  },
  {
    codCiudad: 2168,
    codPcia: 10,
    CP: 4417,
    letra: '',
    nombre: 'Cuesta Del Obispo',
  },
  {
    codCiudad: 1952,
    codPcia: 10,
    CP: 4401,
    letra: '',
    nombre: 'Curuzu',
  },
  {
    codCiudad: 737,
    codPcia: 5,
    CP: 3460,
    letra: '',
    nombre: 'CURUZU CUATIA',
  },
  {
    codCiudad: 1422,
    codPcia: 17,
    CP: 9211,
    letra: '',
    nombre: 'CUSHAMEN',
  },
  {
    codCiudad: 1395,
    codPcia: 21,
    CP: 8322,
    letra: '',
    nombre: 'CUTRAL CO',
  },
  {
    codCiudad: 2420,
    codPcia: 10,
    CP: 4432,
    letra: '',
    nombre: 'D Embalse C Alegre',
  },
  {
    codCiudad: 1400,
    codPcia: 2,
    CP: 6555,
    letra: '',
    nombre: 'DAIREAUX',
  },
  {
    codCiudad: 1042,
    codPcia: 4,
    CP: 5919,
    letra: '',
    nombre: 'DALMACIO VELEZ',
  },
  {
    codCiudad: 2035,
    codPcia: 10,
    CP: 4409,
    letra: '',
    nombre: 'Damian N Torino',
  },
  {
    codCiudad: 1436,
    codPcia: 2,
    CP: 8183,
    letra: '',
    nombre: 'DARRAGUEIRA',
  },
  {
    codCiudad: 907,
    codPcia: 4,
    CP: 5200,
    letra: '',
    nombre: 'DEAN FUNES',
  },
  {
    codCiudad: 1168,
    codPcia: 2,
    CP: 7265,
    letra: '',
    nombre: 'DEL CARRIL',
  },
  {
    codCiudad: 324,
    codPcia: 2,
    CP: 1669,
    letra: '',
    nombre: 'DEL VISO',
  },
  {
    codCiudad: 3129,
    codPcia: 2,
    CP: 6516,
    letra: '',
    nombre: 'DENNEHY',
  },
  {
    codCiudad: 884,
    codPcia: 4,
    CP: 5121,
    letra: '',
    nombre: 'DESPE',
  },
  {
    codCiudad: 492,
    codPcia: 13,
    CP: 2242,
    letra: '',
    nombre: 'DESVIO ARIJON',
  },
  {
    codCiudad: 3123,
    codPcia: 4,
    CP: 2424,
    letra: '',
    nombre: 'DEVOTO',
  },
  {
    codCiudad: 1910,
    codPcia: 10,
    CP: 4198,
    letra: '',
    nombre: 'Diamante',
  },
  {
    codCiudad: 691,
    codPcia: 6,
    CP: 3105,
    letra: '',
    nombre: 'DIAMANTE',
  },
  {
    codCiudad: 2194,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'Diamante',
  },
  {
    codCiudad: 3107,
    codPcia: 13,
    CP: 2222,
    letra: '',
    nombre: 'Diaz',
  },
  {
    codCiudad: 2036,
    codPcia: 10,
    CP: 4409,
    letra: '',
    nombre: 'Diego De Almagro',
  },
  {
    codCiudad: 1603,
    codPcia: 13,
    CP: 6036,
    letra: '',
    nombre: 'DIEGO DE ALVEAR',
  },
  {
    codCiudad: 2957,
    codPcia: 10,
    CP: 4568,
    letra: '',
    nombre: 'Dique Itiruyo',
  },
  {
    codCiudad: 905,
    codPcia: 4,
    CP: 5192,
    letra: '',
    nombre: 'DIQUE LOS MOLINAS',
  },
  {
    codCiudad: 2532,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'Divisadero',
  },
  {
    codCiudad: 1408,
    codPcia: 13,
    CP: 3569,
    letra: '',
    nombre: 'DOCTOR BARROS PAZOS',
  },
  {
    codCiudad: 1724,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Doctor Luis Agote',
  },
  {
    codCiudad: 1146,
    codPcia: 2,
    CP: 7100,
    letra: '',
    nombre: 'DOLORES',
  },
  {
    codCiudad: 3211,
    codPcia: 6,
    CP: 3164,
    letra: '',
    nombre: 'DON CRISTOBAL PRIMERO',
  },
  {
    codCiudad: 289,
    codPcia: 2,
    CP: 1611,
    letra: '',
    nombre: 'DON TORCUATO',
  },
  {
    codCiudad: 1517,
    codPcia: 19,
    CP: 6365,
    letra: '',
    nombre: 'DORILA',
  },
  {
    codCiudad: 2639,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Dos Arboles',
  },
  {
    codCiudad: 2848,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Dos Yuchanes',
  },
  {
    codCiudad: 2226,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'Dr Facundo Zuviria',
  },
  {
    codCiudad: 2271,
    codPcia: 10,
    CP: 4423,
    letra: '',
    nombre: 'Dr Facundo Zuviria',
  },
  {
    codCiudad: 1725,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Dr G Sayago',
  },
  {
    codCiudad: 2849,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Dragones',
  },
  {
    codCiudad: 1030,
    codPcia: 4,
    CP: 5875,
    letra: '',
    nombre: 'DTO SAN JAVIER',
  },
  {
    codCiudad: 1105,
    codPcia: 2,
    CP: 6505,
    letra: '',
    nombre: 'DUDIGNAC',
  },
  {
    codCiudad: 619,
    codPcia: 2,
    CP: 2764,
    letra: '',
    nombre: 'DUGGAN',
  },
  {
    codCiudad: 2305,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'Durazno',
  },
  {
    codCiudad: 2486,
    codPcia: 10,
    CP: 4440,
    letra: '',
    nombre: 'Durazno',
  },
  {
    codCiudad: 2487,
    codPcia: 10,
    CP: 4440,
    letra: '',
    nombre: 'E Embarc. Fcgb',
  },
  {
    codCiudad: 2445,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'Ebro',
  },
  {
    codCiudad: 2306,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'El Acheral',
  },
  {
    codCiudad: 2685,
    codPcia: 10,
    CP: 4500,
    letra: '',
    nombre: 'El Acheral',
  },
  {
    codCiudad: 2945,
    codPcia: 10,
    CP: 4563,
    letra: '',
    nombre: 'El Aguay',
  },
  {
    codCiudad: 1726,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'El Alambrado',
  },
  {
    codCiudad: 3189,
    codPcia: 20,
    CP: 3384,
    letra: '',
    nombre: 'EL ALCÁZAR',
  },
  {
    codCiudad: 2037,
    codPcia: 10,
    CP: 4409,
    letra: '',
    nombre: 'El Alfredito',
  },
  {
    codCiudad: 2559,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'El Algarrobal',
  },
  {
    codCiudad: 979,
    codPcia: 9,
    CP: 5541,
    letra: '',
    nombre: 'EL ALGARROBAL',
  },
  {
    codCiudad: 2446,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'El Algarrobo',
  },
  {
    codCiudad: 2038,
    codPcia: 10,
    CP: 4409,
    letra: '',
    nombre: 'El Alisal',
  },
  {
    codCiudad: 1452,
    codPcia: 4,
    CP: 5947,
    letra: '',
    nombre: 'EL ARAÑADO',
  },
  {
    codCiudad: 2560,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'El Arenal',
  },
  {
    codCiudad: 2686,
    codPcia: 10,
    CP: 4500,
    letra: '',
    nombre: 'El Arenal',
  },
  {
    codCiudad: 1727,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'El Azotado',
  },
  {
    codCiudad: 1652,
    codPcia: 14,
    CP: 4178,
    letra: '',
    nombre: 'EL BAGUAL',
  },
  {
    codCiudad: 1802,
    codPcia: 10,
    CP: 4141,
    letra: '',
    nombre: 'El Bañado',
  },
  {
    codCiudad: 1208,
    codPcia: 22,
    CP: 8430,
    letra: '',
    nombre: 'EL BOLSON',
  },
  {
    codCiudad: 2600,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'El Bordo',
  },
  {
    codCiudad: 1856,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'El Bordo',
  },
  {
    codCiudad: 2421,
    codPcia: 10,
    CP: 4432,
    letra: '',
    nombre: 'El Bordo',
  },
  {
    codCiudad: 2378,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'El Bordo',
  },
  {
    codCiudad: 2533,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'El Bordo Campo S',
  },
  {
    codCiudad: 2761,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'El Breal',
  },
  {
    codCiudad: 2195,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'El Brealito',
  },
  {
    codCiudad: 2682,
    codPcia: 10,
    CP: 4456,
    letra: '',
    nombre: 'El Brete',
  },
  {
    codCiudad: 1777,
    codPcia: 10,
    CP: 4126,
    letra: '',
    nombre: 'El Brete',
  },
  {
    codCiudad: 2120,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'El Candado',
  },
  {
    codCiudad: 2227,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'El Carancho',
  },
  {
    codCiudad: 1795,
    codPcia: 10,
    CP: 4128,
    letra: '',
    nombre: 'El Carmen',
  },
  {
    codCiudad: 2003,
    codPcia: 10,
    CP: 4405,
    letra: '',
    nombre: 'El Carmen',
  },
  {
    codCiudad: 2196,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'El Carmen',
  },
  {
    codCiudad: 2228,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'El Carmen',
  },
  {
    codCiudad: 2695,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'El Carmen',
  },
  {
    codCiudad: 2601,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'El Carmen',
  },
  {
    codCiudad: 1527,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'EL CARRIL',
  },
  {
    codCiudad: 1803,
    codPcia: 10,
    CP: 4141,
    letra: '',
    nombre: 'El Carrizal',
  },
  {
    codCiudad: 2534,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'El Carrizal',
  },
  {
    codCiudad: 1796,
    codPcia: 10,
    CP: 4128,
    letra: '',
    nombre: 'El Ceibal',
  },
  {
    codCiudad: 2379,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'El Ceibal',
  },
  {
    codCiudad: 1857,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'El Ceibal',
  },
  {
    codCiudad: 1821,
    codPcia: 10,
    CP: 4142,
    letra: '',
    nombre: 'El Cercado',
  },
  {
    codCiudad: 1420,
    codPcia: 23,
    CP: 9301,
    letra: '',
    nombre: 'EL CHALTÉN',
  },
  {
    codCiudad: 2894,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'El Chorro',
  },
  {
    codCiudad: 2197,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'El Churcal',
  },
  {
    codCiudad: 2850,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'El Cienego',
  },
  {
    codCiudad: 1976,
    codPcia: 10,
    CP: 4403,
    letra: '',
    nombre: 'El Colegio',
  },
  {
    codCiudad: 2380,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'El Colgado',
  },
  {
    codCiudad: 1858,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'El Condor',
  },
  {
    codCiudad: 3008,
    codPcia: 10,
    CP: 4644,
    letra: '',
    nombre: 'El Condor',
  },
  {
    codCiudad: 1911,
    codPcia: 10,
    CP: 4198,
    letra: '',
    nombre: 'El Corral Viejo',
  },
  {
    codCiudad: 2004,
    codPcia: 10,
    CP: 4405,
    letra: '',
    nombre: 'El Corralito',
  },
  {
    codCiudad: 3096,
    codPcia: 10,
    CP: 5236,
    letra: '',
    nombre: 'El Cres De Piedra',
  },
  {
    codCiudad: 2307,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'El Creston',
  },
  {
    codCiudad: 3130,
    codPcia: 14,
    CP: 3765,
    letra: '',
    nombre: 'EL CUADRADO',
  },
  {
    codCiudad: 2820,
    codPcia: 10,
    CP: 4550,
    letra: '',
    nombre: 'El Cuchillo',
  },
  {
    codCiudad: 2964,
    codPcia: 10,
    CP: 4600,
    letra: '',
    nombre: 'El Cucho',
  },
  {
    codCiudad: 2811,
    codPcia: 10,
    CP: 4542,
    letra: '',
    nombre: 'El Cuinco Pozo Del',
  },
  {
    codCiudad: 1655,
    codPcia: 22,
    CP: 8333,
    letra: '',
    nombre: 'EL CUY',
  },
  {
    codCiudad: 1728,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'El Desmonte',
  },
  {
    codCiudad: 2807,
    codPcia: 10,
    CP: 4538,
    letra: '',
    nombre: 'El Desmonte',
  },
  {
    codCiudad: 2762,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'El Destierro',
  },
  {
    codCiudad: 2005,
    codPcia: 10,
    CP: 4405,
    letra: '',
    nombre: 'El Dorado',
  },
  {
    codCiudad: 1447,
    codPcia: 20,
    CP: 3380,
    letra: '',
    nombre: 'EL DORADO',
  },
  {
    codCiudad: 1325,
    codPcia: 4,
    CP: 5155,
    letra: '',
    nombre: 'EL DURAZNO',
  },
  {
    codCiudad: 2025,
    codPcia: 10,
    CP: 4407,
    letra: '',
    nombre: 'El Encon',
  },
  {
    codCiudad: 2851,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'El Espinillo',
  },
  {
    codCiudad: 2381,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'El Espinillo',
  },
  {
    codCiudad: 2447,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'El Estanque',
  },
  {
    codCiudad: 1673,
    codPcia: 4,
    CP: 5951,
    letra: '',
    nombre: 'EL FORTIN',
  },
  {
    codCiudad: 2308,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'El Fraile',
  },
  {
    codCiudad: 1953,
    codPcia: 10,
    CP: 4401,
    letra: '',
    nombre: 'El Gallinato',
  },
  {
    codCiudad: 2512,
    codPcia: 10,
    CP: 4444,
    letra: '',
    nombre: 'El Galpon',
  },
  {
    codCiudad: 2039,
    codPcia: 10,
    CP: 4409,
    letra: '',
    nombre: 'El Golgota',
  },
  {
    codCiudad: 2488,
    codPcia: 10,
    CP: 4440,
    letra: '',
    nombre: 'El Guanaco',
  },
  {
    codCiudad: 1977,
    codPcia: 10,
    CP: 4403,
    letra: '',
    nombre: 'El Huaico',
  },
  {
    codCiudad: 1615,
    codPcia: 21,
    CP: 8349,
    letra: '',
    nombre: 'EL HUECU',
  },
  {
    codCiudad: 1822,
    codPcia: 10,
    CP: 4142,
    letra: '',
    nombre: 'El Indio',
  },
  {
    codCiudad: 2535,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'El Jaravi',
  },
  {
    codCiudad: 1778,
    codPcia: 10,
    CP: 4126,
    letra: '',
    nombre: 'El Jardin',
  },
  {
    codCiudad: 2229,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'El Leoncito',
  },
  {
    codCiudad: 2448,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'El Libano',
  },
  {
    codCiudad: 2602,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'El Manantial',
  },
  {
    codCiudad: 2006,
    codPcia: 10,
    CP: 4405,
    letra: '',
    nombre: 'El Manzano',
  },
  {
    codCiudad: 2121,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'El Maray',
  },
  {
    codCiudad: 2763,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'El Mirador',
  },
  {
    codCiudad: 2742,
    codPcia: 10,
    CP: 4534,
    letra: '',
    nombre: 'El Mistol',
  },
  {
    codCiudad: 1729,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'El Mistolar',
  },
  {
    codCiudad: 1575,
    codPcia: 3,
    CP: 4750,
    letra: '',
    nombre: 'EL MOLINO',
  },
  {
    codCiudad: 2122,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'El Molino',
  },
  {
    codCiudad: 2007,
    codPcia: 10,
    CP: 4405,
    letra: '',
    nombre: 'El Mollar',
  },
  {
    codCiudad: 2230,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'El Mollar',
  },
  {
    codCiudad: 2696,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'El Molle',
  },
  {
    codCiudad: 3032,
    codPcia: 10,
    CP: 4650,
    letra: '',
    nombre: 'El Monumento',
  },
  {
    codCiudad: 2382,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'El Moranillo',
  },
  {
    codCiudad: 2272,
    codPcia: 10,
    CP: 4423,
    letra: '',
    nombre: 'El Moyar',
  },
  {
    codCiudad: 1842,
    codPcia: 10,
    CP: 4191,
    letra: '',
    nombre: 'El Naranjo',
  },
  {
    codCiudad: 2437,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'El Naranjo',
  },
  {
    codCiudad: 1779,
    codPcia: 10,
    CP: 4126,
    letra: '',
    nombre: 'El Naranjo',
  },
  {
    codCiudad: 2123,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'El Nogalar',
  },
  {
    codCiudad: 2309,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'El Obelisco',
  },
  {
    codCiudad: 1912,
    codPcia: 10,
    CP: 4198,
    letra: '',
    nombre: 'El Ojito',
  },
  {
    codCiudad: 1859,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'El Ojo',
  },
  {
    codCiudad: 2449,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'El Oso',
  },
  {
    codCiudad: 2536,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'El Pacara',
  },
  {
    codCiudad: 695,
    codPcia: 6,
    CP: 3118,
    letra: '',
    nombre: 'EL PALENQUE',
  },
  {
    codCiudad: 331,
    codPcia: 2,
    CP: 1684,
    letra: '',
    nombre: 'EL PALOMAR',
  },
  {
    codCiudad: 635,
    codPcia: 2,
    CP: 2916,
    letra: '',
    nombre: 'EL PARAISO',
  },
  {
    codCiudad: 2513,
    codPcia: 10,
    CP: 4444,
    letra: '',
    nombre: 'El Parque',
  },
  {
    codCiudad: 1804,
    codPcia: 10,
    CP: 4141,
    letra: '',
    nombre: 'El Paso',
  },
  {
    codCiudad: 3097,
    codPcia: 10,
    CP: 5236,
    letra: '',
    nombre: 'El Pedacito',
  },
  {
    codCiudad: 2603,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'El Pericote',
  },
  {
    codCiudad: 2852,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'El Pertigo',
  },
  {
    codCiudad: 3116,
    codPcia: 6,
    CP: 3132,
    letra: '',
    nombre: 'EL PINGO',
  },
  {
    codCiudad: 1830,
    codPcia: 10,
    CP: 4190,
    letra: '',
    nombre: 'El Portezuelo',
  },
  {
    codCiudad: 2008,
    codPcia: 10,
    CP: 4405,
    letra: '',
    nombre: 'El Porvenir',
  },
  {
    codCiudad: 2640,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'El Porvenir',
  },
  {
    codCiudad: 1730,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'El Potrerito',
  },
  {
    codCiudad: 2009,
    codPcia: 10,
    CP: 4405,
    letra: '',
    nombre: 'El Potrero',
  },
  {
    codCiudad: 1860,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'El Potrero',
  },
  {
    codCiudad: 2124,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'El Potrero',
  },
  {
    codCiudad: 2231,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'El Potrero De Diaz',
  },
  {
    codCiudad: 3085,
    codPcia: 10,
    CP: 5233,
    letra: '',
    nombre: 'El Pozo',
  },
  {
    codCiudad: 2422,
    codPcia: 10,
    CP: 4432,
    letra: '',
    nombre: 'El Prado',
  },
  {
    codCiudad: 1936,
    codPcia: 10,
    CP: 4400,
    letra: '',
    nombre: 'El Prado',
  },
  {
    codCiudad: 3091,
    codPcia: 10,
    CP: 5235,
    letra: '',
    nombre: 'El Progreso',
  },
  {
    codCiudad: 2010,
    codPcia: 10,
    CP: 4405,
    letra: '',
    nombre: 'El Pucara',
  },
  {
    codCiudad: 1913,
    codPcia: 10,
    CP: 4198,
    letra: '',
    nombre: 'El Puestito',
  },
  {
    codCiudad: 2011,
    codPcia: 10,
    CP: 4405,
    letra: '',
    nombre: 'El Puyil',
  },
  {
    codCiudad: 2743,
    codPcia: 10,
    CP: 4534,
    letra: '',
    nombre: 'El Q. Carboncito',
  },
  {
    codCiudad: 2925,
    codPcia: 10,
    CP: 4561,
    letra: '',
    nombre: 'El Qato',
  },
  {
    codCiudad: 2681,
    codPcia: 10,
    CP: 4453,
    letra: '',
    nombre: 'El Quebrachal',
  },
  {
    codCiudad: 2273,
    codPcia: 10,
    CP: 4423,
    letra: '',
    nombre: 'El Quemado',
  },
  {
    codCiudad: 1731,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'El Quemado',
  },
  {
    codCiudad: 2342,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'El Recreo',
  },
  {
    codCiudad: 1078,
    codPcia: 13,
    CP: 6103,
    letra: '',
    nombre: 'EL REFUGIO',
  },
  {
    codCiudad: 1887,
    codPcia: 10,
    CP: 4195,
    letra: '',
    nombre: 'El Remate',
  },
  {
    codCiudad: 2821,
    codPcia: 10,
    CP: 4550,
    letra: '',
    nombre: 'El Retiro',
  },
  {
    codCiudad: 992,
    codPcia: 9,
    CP: 5632,
    letra: '',
    nombre: 'EL RETIRO (ALVEAR)',
  },
  {
    codCiudad: 983,
    codPcia: 9,
    CP: 5579,
    letra: '',
    nombre: 'EL RETIRO (RIVADAVIA',
  },
  {
    codCiudad: 987,
    codPcia: 9,
    CP: 5594,
    letra: '',
    nombre: 'EL RETIRO (SANTA ROS',
  },
  {
    codCiudad: 975,
    codPcia: 9,
    CP: 5533,
    letra: '',
    nombre: 'EL RETIRO(DTO. LAVAL',
  },
  {
    codCiudad: 2450,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'El Rey',
  },
  {
    codCiudad: 2125,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'El Rodeo',
  },
  {
    codCiudad: 1732,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'El Rosado',
  },
  {
    codCiudad: 2012,
    codPcia: 10,
    CP: 4405,
    letra: '',
    nombre: 'El Rosal',
  },
  {
    codCiudad: 2451,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'El Salto',
  },
  {
    codCiudad: 2310,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'El Sapo',
  },
  {
    codCiudad: 2423,
    codPcia: 10,
    CP: 4432,
    letra: '',
    nombre: 'El Sauce',
  },
  {
    codCiudad: 2489,
    codPcia: 10,
    CP: 4440,
    letra: '',
    nombre: 'El Sauzal',
  },
  {
    codCiudad: 2232,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'El Simbolar',
  },
  {
    codCiudad: 2274,
    codPcia: 10,
    CP: 4423,
    letra: '',
    nombre: 'El Simbolar',
  },
  {
    codCiudad: 599,
    codPcia: 2,
    CP: 2715,
    letra: '',
    nombre: 'EL SOCORRO',
  },
  {
    codCiudad: 2764,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'El Soldadito',
  },
  {
    codCiudad: 2383,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'El Sunchal',
  },
  {
    codCiudad: 2126,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'El Sunchal',
  },
  {
    codCiudad: 1780,
    codPcia: 10,
    CP: 4126,
    letra: '',
    nombre: 'El Sunchal',
  },
  {
    codCiudad: 3098,
    codPcia: 10,
    CP: 5236,
    letra: '',
    nombre: 'El T V Gral Mitre',
  },
  {
    codCiudad: 2733,
    codPcia: 10,
    CP: 4533,
    letra: '',
    nombre: 'El Tabacal',
  },
  {
    codCiudad: 2853,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'El Talar',
  },
  {
    codCiudad: 1230,
    codPcia: 2,
    CP: 1618,
    letra: '',
    nombre: 'EL TALAR',
  },
  {
    codCiudad: 1914,
    codPcia: 10,
    CP: 4198,
    letra: '',
    nombre: 'El Tandil',
  },
  {
    codCiudad: 2976,
    codPcia: 10,
    CP: 4633,
    letra: '',
    nombre: 'El Tapial',
  },
  {
    codCiudad: 2854,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'El Tartagal',
  },
  {
    codCiudad: 2013,
    codPcia: 10,
    CP: 4405,
    letra: '',
    nombre: 'El Timbo',
  },
  {
    codCiudad: 2275,
    codPcia: 10,
    CP: 4423,
    letra: '',
    nombre: 'El Tipal',
  },
  {
    codCiudad: 2040,
    codPcia: 10,
    CP: 4409,
    letra: '',
    nombre: 'El Toro',
  },
  {
    codCiudad: 1733,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'El Totoral',
  },
  {
    codCiudad: 539,
    codPcia: 13,
    CP: 2535,
    letra: '',
    nombre: 'EL TREBOL',
  },
  {
    codCiudad: 2127,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'El Trigal',
  },
  {
    codCiudad: 2537,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'El Tunal',
  },
  {
    codCiudad: 2765,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'El Tunalito',
  },
  {
    codCiudad: 2490,
    codPcia: 10,
    CP: 4440,
    letra: '',
    nombre: 'El Vallecito',
  },
  {
    codCiudad: 2641,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'El Vencido',
  },
  {
    codCiudad: 3086,
    codPcia: 10,
    CP: 5233,
    letra: '',
    nombre: 'El Vismal',
  },
  {
    codCiudad: 2766,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'El Yacon',
  },
  {
    codCiudad: 2604,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'El Yeso',
  },
  {
    codCiudad: 2452,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'El Zanjon',
  },
  {
    codCiudad: 2384,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'El Zapallar',
  },
  {
    codCiudad: 3087,
    codPcia: 10,
    CP: 5233,
    letra: '',
    nombre: 'El Zapallar',
  },
  {
    codCiudad: 2744,
    codPcia: 10,
    CP: 4534,
    letra: '',
    nombre: 'El Zapallo',
  },
  {
    codCiudad: 1734,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'El Zorro',
  },
  {
    codCiudad: 1253,
    codPcia: 4,
    CP: 5815,
    letra: '',
    nombre: 'ELENA',
  },
  {
    codCiudad: 3180,
    codPcia: 13,
    CP: 3029,
    letra: '',
    nombre: 'ELISA',
  },
  {
    codCiudad: 610,
    codPcia: 13,
    CP: 2732,
    letra: '',
    nombre: 'ELORTONDO',
  },
  {
    codCiudad: 2026,
    codPcia: 10,
    CP: 4407,
    letra: '',
    nombre: 'Eltunal',
  },
  {
    codCiudad: 1584,
    codPcia: 19,
    CP: 6203,
    letra: '',
    nombre: 'EMBAJADOR MARTINI',
  },
  {
    codCiudad: 1024,
    codPcia: 4,
    CP: 5856,
    letra: '',
    nombre: 'EMBALSE',
  },
  {
    codCiudad: 862,
    codPcia: 10,
    CP: 4550,
    letra: '',
    nombre: 'EMBARCACION',
  },
  {
    codCiudad: 2855,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Emboscada',
  },
  {
    codCiudad: 668,
    codPcia: 13,
    CP: 3036,
    letra: '',
    nombre: 'EMILIA',
  },
  {
    codCiudad: 1025,
    codPcia: 4,
    CP: 5857,
    letra: '',
    nombre: 'EMLBALSE',
  },
  {
    codCiudad: 3155,
    codPcia: 13,
    CP: 3007,
    letra: '',
    nombre: 'EMPALME SAN CARLOS',
  },
  {
    codCiudad: 637,
    codPcia: 13,
    CP: 2918,
    letra: '',
    nombre: 'EMPALME VILLA CONSTI',
  },
  {
    codCiudad: 731,
    codPcia: 5,
    CP: 3418,
    letra: '',
    nombre: 'EMPEDRADO',
  },
  {
    codCiudad: 728,
    codPcia: 5,
    CP: 3414,
    letra: '',
    nombre: 'EMPEDRADO',
  },
  {
    codCiudad: 2041,
    codPcia: 10,
    CP: 4409,
    letra: '',
    nombre: 'Enc. De Tastil',
  },
  {
    codCiudad: 3082,
    codPcia: 10,
    CP: 5231,
    letra: '',
    nombre: 'Encrucijada',
  },
  {
    codCiudad: 1353,
    codPcia: 16,
    CP: 3543,
    letra: '',
    nombre: 'ENRIQUE URIEN',
  },
  {
    codCiudad: 419,
    codPcia: 2,
    CP: 1925,
    letra: '',
    nombre: 'ENSENADA',
  },
  {
    codCiudad: 2385,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'Entre Rios',
  },
  {
    codCiudad: 2169,
    codPcia: 10,
    CP: 4417,
    letra: '',
    nombre: 'Escalchi',
  },
  {
    codCiudad: 298,
    codPcia: 2,
    CP: 1625,
    letra: '',
    nombre: 'ESCOBAR',
  },
  {
    codCiudad: 2233,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'Escoipe',
  },
  {
    codCiudad: 1797,
    codPcia: 10,
    CP: 4128,
    letra: '',
    nombre: 'Escuela 243',
  },
  {
    codCiudad: 3188,
    codPcia: 13,
    CP: 2456,
    letra: '',
    nombre: 'ESMERALDA',
  },
  {
    codCiudad: 685,
    codPcia: 13,
    CP: 3080,
    letra: '',
    nombre: 'ESPERANZA',
  },
  {
    codCiudad: 2605,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'Espinillo',
  },
  {
    codCiudad: 1246,
    codPcia: 17,
    CP: 9200,
    letra: '',
    nombre: 'ESQUEL',
  },
  {
    codCiudad: 705,
    codPcia: 5,
    CP: 3196,
    letra: '',
    nombre: 'ESQUINA',
  },
  {
    codCiudad: 2606,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'Esquina',
  },
  {
    codCiudad: 2198,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'Esquina',
  },
  {
    codCiudad: 2687,
    codPcia: 10,
    CP: 4500,
    letra: '',
    nombre: 'Esquina De Quisto',
  },
  {
    codCiudad: 1735,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Esquinitas',
  },
  {
    codCiudad: 2514,
    codPcia: 10,
    CP: 4444,
    letra: '',
    nombre: 'Est Foguista J F',
  },
  {
    codCiudad: 842,
    codPcia: 14,
    CP: 4315,
    letra: '',
    nombre: 'ESTACION ATAMISQUI',
  },
  {
    codCiudad: 547,
    codPcia: 4,
    CP: 2564,
    letra: '',
    nombre: 'ESTACION BELL VILLE',
  },
  {
    codCiudad: 1605,
    codPcia: 13,
    CP: 2407,
    letra: '',
    nombre: 'ESTACIÓN CLUSELLAS',
  },
  {
    codCiudad: 1290,
    codPcia: 4,
    CP: 5145,
    letra: '',
    nombre: 'ESTACION GRAL PAZ',
  },
  {
    codCiudad: 2234,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'Estacion Zuviria',
  },
  {
    codCiudad: 3142,
    codPcia: 6,
    CP: 3201,
    letra: '',
    nombre: 'ESTANCIA GRANDE',
  },
  {
    codCiudad: 2453,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'Estancia Vieja',
  },
  {
    codCiudad: 1705,
    codPcia: 18,
    CP: 3626,
    letra: '',
    nombre: 'ESTANISLAO DEL CAMPO',
  },
  {
    codCiudad: 2800,
    codPcia: 10,
    CP: 4537,
    letra: '',
    nombre: 'Esteban De Urizar',
  },
  {
    codCiudad: 368,
    codPcia: 2,
    CP: 1802,
    letra: '',
    nombre: 'ESTEBAN ECHEVERRIA',
  },
  {
    codCiudad: 682,
    codPcia: 13,
    CP: 3066,
    letra: '',
    nombre: 'ESTEBAN RAMS',
  },
  {
    codCiudad: 590,
    codPcia: 4,
    CP: 2681,
    letra: '',
    nombre: 'ETRURIA',
  },
  {
    codCiudad: 1690,
    codPcia: 13,
    CP: 2317,
    letra: '',
    nombre: 'EUSEBIA',
  },
  {
    codCiudad: 1522,
    codPcia: 2,
    CP: 2812,
    letra: '',
    nombre: 'EXALTACIÓN DE LA CRUZ',
  },
  {
    codCiudad: 1218,
    codPcia: 13,
    CP: 9999,
    letra: '',
    nombre: 'EXTERIOR',
  },
  {
    codCiudad: 369,
    codPcia: 2,
    CP: 1804,
    letra: '',
    nombre: 'EZEIZA',
  },
  {
    codCiudad: 404,
    codPcia: 2,
    CP: 1882,
    letra: '',
    nombre: 'EZPELETA',
  },
  {
    codCiudad: 1978,
    codPcia: 10,
    CP: 4403,
    letra: '',
    nombre: 'F Cno A Colon',
  },
  {
    codCiudad: 1979,
    codPcia: 10,
    CP: 4403,
    letra: '',
    nombre: 'F Cno Vallisios',
  },
  {
    codCiudad: 1736,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'F N De Laprida',
  },
  {
    codCiudad: 407,
    codPcia: 2,
    CP: 1888,
    letra: '',
    nombre: 'F VARELA',
  },
  {
    codCiudad: 2515,
    codPcia: 10,
    CP: 4444,
    letra: '',
    nombre: 'F. J F Juarez',
  },
  {
    codCiudad: 1278,
    codPcia: 20,
    CP: 3304,
    letra: '',
    nombre: 'FACHINAL',
  },
  {
    codCiudad: 1293,
    codPcia: 17,
    CP: 9031,
    letra: '',
    nombre: 'FACUNDO',
  },
  {
    codCiudad: 1463,
    codPcia: 19,
    CP: 6212,
    letra: '',
    nombre: 'FALUCHO',
  },
  {
    codCiudad: 803,
    codPcia: 3,
    CP: 4132,
    letra: '',
    nombre: 'FAMAILLA',
  },
  {
    codCiudad: 1257,
    codPcia: 6,
    CP: 3206,
    letra: '',
    nombre: 'FEDERACION',
  },
  {
    codCiudad: 1915,
    codPcia: 10,
    CP: 4198,
    letra: '',
    nombre: 'Federacion',
  },
  {
    codCiudad: 702,
    codPcia: 6,
    CP: 3180,
    letra: '',
    nombre: 'FEDERAL',
  },
  {
    codCiudad: 1619,
    codPcia: 6,
    CP: 3187,
    letra: '',
    nombre: 'FELICIANO',
  },
  {
    codCiudad: 1661,
    codPcia: 2,
    CP: 8129,
    letra: '',
    nombre: 'FELIPE SOLÁ',
  },
  {
    codCiudad: 448,
    codPcia: 13,
    CP: 2126,
    letra: '',
    nombre: 'FIGHIERA',
  },
  {
    codCiudad: 2516,
    codPcia: 10,
    CP: 4444,
    letra: '',
    nombre: 'Finca Armonia',
  },
  {
    codCiudad: 2128,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Finca Belgrano',
  },
  {
    codCiudad: 1980,
    codPcia: 10,
    CP: 4403,
    letra: '',
    nombre: 'Finca Colon',
  },
  {
    codCiudad: 2311,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'Finca El Carmen',
  },
  {
    codCiudad: 1981,
    codPcia: 10,
    CP: 4403,
    letra: '',
    nombre: 'Finca El Colegio',
  },
  {
    codCiudad: 2454,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'Finca La China',
  },
  {
    codCiudad: 2343,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'Finca La Rosa',
  },
  {
    codCiudad: 2808,
    codPcia: 10,
    CP: 4538,
    letra: '',
    nombre: 'Finca La Toma',
  },
  {
    codCiudad: 2697,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'Finca Mision Zenta',
  },
  {
    codCiudad: 2561,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'Finca Mision Zenta',
  },
  {
    codCiudad: 2517,
    codPcia: 10,
    CP: 4444,
    letra: '',
    nombre: 'Finca Rocca',
  },
  {
    codCiudad: 573,
    codPcia: 13,
    CP: 2630,
    letra: '',
    nombre: 'FIRMAT',
  },
  {
    codCiudad: 1737,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Florencio Sanchez',
  },
  {
    codCiudad: 1346,
    codPcia: 2,
    CP: 1888,
    letra: '',
    nombre: 'FLORENCIO VARELA',
  },
  {
    codCiudad: 1429,
    codPcia: 17,
    CP: 9100,
    letra: '',
    nombre: 'FLORENTINO AMEGHINO',
  },
  {
    codCiudad: 2673,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Floresta',
  },
  {
    codCiudad: 284,
    codPcia: 2,
    CP: 1602,
    letra: '',
    nombre: 'FLORIDA',
  },
  {
    codCiudad: 1355,
    codPcia: 16,
    CP: 3514,
    letra: '',
    nombre: 'FONTANA',
  },
  {
    codCiudad: 1234,
    codPcia: 18,
    CP: 3621,
    letra: '',
    nombre: 'FORMOSA',
  },
  {
    codCiudad: 769,
    codPcia: 18,
    CP: 3600,
    letra: '',
    nombre: 'FORMOSA',
  },
  {
    codCiudad: 2698,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'Fortin Belgrano',
  },
  {
    codCiudad: 2767,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'Fortin Frias',
  },
  {
    codCiudad: 1550,
    codPcia: 14,
    CP: 3062,
    letra: '',
    nombre: 'FORTIN INCA',
  },
  {
    codCiudad: 758,
    codPcia: 13,
    CP: 3553,
    letra: '',
    nombre: 'FORTIN OLMOS',
  },
  {
    codCiudad: 1088,
    codPcia: 12,
    CP: 6216,
    letra: '',
    nombre: 'FORTUNA',
  },
  {
    codCiudad: 856,
    codPcia: 7,
    CP: 4506,
    letra: '',
    nombre: 'FRAILE PINTADO',
  },
  {
    codCiudad: 655,
    codPcia: 13,
    CP: 3009,
    letra: '',
    nombre: 'FRANCK',
  },
  {
    codCiudad: 974,
    codPcia: 9,
    CP: 5531,
    letra: '',
    nombre: 'FRAY LUIS BELTRAN',
  },
  {
    codCiudad: 468,
    codPcia: 13,
    CP: 2156,
    letra: '',
    nombre: 'FRAY LUIS BELTRAN.',
  },
  {
    codCiudad: 834,
    codPcia: 14,
    CP: 4230,
    letra: '',
    nombre: 'FRIAS',
  },
  {
    codCiudad: 2895,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'Frontera 4',
  },
  {
    codCiudad: 2896,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'Frontera 5',
  },
  {
    codCiudad: 2897,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'Frontera Tres',
  },
  {
    codCiudad: 445,
    codPcia: 13,
    CP: 2123,
    letra: '',
    nombre: 'FUENTES',
  },
  {
    codCiudad: 2170,
    codPcia: 10,
    CP: 4417,
    letra: '',
    nombre: 'Fuerte Alto',
  },
  {
    codCiudad: 2674,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Fuerte El Pito',
  },
  {
    codCiudad: 2386,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'Fuerte Quemado',
  },
  {
    codCiudad: 454,
    codPcia: 13,
    CP: 2132,
    letra: '',
    nombre: 'FUNES',
  },
  {
    codCiudad: 1475,
    codPcia: 17,
    CP: 9203,
    letra: '',
    nombre: 'Futaleufu',
  },
  {
    codCiudad: 2935,
    codPcia: 10,
    CP: 4562,
    letra: '',
    nombre: 'G Enrique Mosconi',
  },
  {
    codCiudad: 2042,
    codPcia: 10,
    CP: 4409,
    letra: '',
    nombre: 'G Manuel Sola',
  },
  {
    codCiudad: 614,
    codPcia: 2,
    CP: 2745,
    letra: '',
    nombre: 'GAHAM',
  },
  {
    codCiudad: 1457,
    codPcia: 17,
    CP: 9105,
    letra: '',
    nombre: 'GAIMAN',
  },
  {
    codCiudad: 2424,
    codPcia: 10,
    CP: 4432,
    letra: '',
    nombre: 'Gallinato',
  },
  {
    codCiudad: 496,
    codPcia: 13,
    CP: 2252,
    letra: '',
    nombre: 'GALVEZ',
  },
  {
    codCiudad: 2675,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Gaona',
  },
  {
    codCiudad: 295,
    codPcia: 2,
    CP: 1619,
    letra: '',
    nombre: 'GARIN',
  },
  {
    codCiudad: 845,
    codPcia: 14,
    CP: 4324,
    letra: '',
    nombre: 'GARZA',
  },
  {
    codCiudad: 812,
    codPcia: 3,
    CP: 4149,
    letra: '',
    nombre: 'GASTONA',
  },
  {
    codCiudad: 755,
    codPcia: 13,
    CP: 3541,
    letra: '',
    nombre: 'GATO COLORADO',
  },
  {
    codCiudad: 672,
    codPcia: 13,
    CP: 3044,
    letra: '',
    nombre: 'GDOR CRESPO',
  },
  {
    codCiudad: 649,
    codPcia: 2,
    CP: 2946,
    letra: '',
    nombre: 'GDOR. CASTRO',
  },
  {
    codCiudad: 1954,
    codPcia: 10,
    CP: 4401,
    letra: '',
    nombre: 'General Alvarado',
  },
  {
    codCiudad: 3156,
    codPcia: 2,
    CP: 7263,
    letra: '',
    nombre: 'GENERAL ALVEAR',
  },
  {
    codCiudad: 1330,
    codPcia: 2,
    CP: 6005,
    letra: '',
    nombre: 'GENERAL ARENALES',
  },
  {
    codCiudad: 2835,
    codPcia: 10,
    CP: 4552,
    letra: '',
    nombre: 'General Ballivian',
  },
  {
    codCiudad: 1600,
    codPcia: 22,
    CP: 8503,
    letra: '',
    nombre: 'GENERAL CONESA',
  },
  {
    codCiudad: 1192,
    codPcia: 2,
    CP: 8105,
    letra: '',
    nombre: 'GENERAL DANIEL CERRI',
  },
  {
    codCiudad: 2936,
    codPcia: 10,
    CP: 4562,
    letra: '',
    nombre: 'General Enrique Mosconi',
  },
  {
    codCiudad: 1386,
    codPcia: 13,
    CP: 2701,
    letra: '',
    nombre: 'GENERAL GELLY',
  },
  {
    codCiudad: 1244,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'GENERAL GUEMES',
  },
  {
    codCiudad: 1154,
    codPcia: 2,
    CP: 7118,
    letra: '',
    nombre: 'GENERAL GUIDO',
  },
  {
    codCiudad: 449,
    codPcia: 13,
    CP: 2126,
    letra: '',
    nombre: 'GENERAL LAGOS',
  },
  {
    codCiudad: 1647,
    codPcia: 2,
    CP: 7406,
    letra: '',
    nombre: 'GENERAL LAMADRID',
  },
  {
    codCiudad: 1419,
    codPcia: 2,
    CP: 7103,
    letra: '',
    nombre: 'GENERAL LAVALLE',
  },
  {
    codCiudad: 1084,
    codPcia: 4,
    CP: 6132,
    letra: '',
    nombre: 'GENERAL LEVALLE',
  },
  {
    codCiudad: 1358,
    codPcia: 2,
    CP: 7163,
    letra: '',
    nombre: 'GENERAL MADARIAGA',
  },
  {
    codCiudad: 2961,
    codPcia: 10,
    CP: 4582,
    letra: '',
    nombre: 'General Mosconi',
  },
  {
    codCiudad: 1402,
    codPcia: 2,
    CP: 7172,
    letra: '',
    nombre: 'GENERAL PIRAN',
  },
  {
    codCiudad: 2607,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'General Pizarro',
  },
  {
    codCiudad: 1202,
    codPcia: 22,
    CP: 8332,
    letra: '',
    nombre: 'GENERAL ROCA',
  },
  {
    codCiudad: 1345,
    codPcia: 4,
    CP: 5900,
    letra: '',
    nombre: 'GENERAL SAN MARTIN',
  },
  {
    codCiudad: 1649,
    codPcia: 9,
    CP: 5570,
    letra: '',
    nombre: 'GENERAL SAN MARTIN',
  },
  {
    codCiudad: 1331,
    codPcia: 2,
    CP: 6015,
    letra: '',
    nombre: 'GENERAL VIAMONTE',
  },
  {
    codCiudad: 1498,
    codPcia: 2,
    CP: 6230,
    letra: '',
    nombre: 'GENERAL VILLEGAS',
  },
  {
    codCiudad: 1528,
    codPcia: 2,
    CP: 6053,
    letra: '',
    nombre: 'GERMANIA - GENERAL PINTO',
  },
  {
    codCiudad: 1012,
    codPcia: 4,
    CP: 5813,
    letra: '',
    nombre: 'GIGENA',
  },
  {
    codCiudad: 392,
    codPcia: 2,
    CP: 1856,
    letra: '',
    nombre: 'GLEW',
  },
  {
    codCiudad: 3209,
    codPcia: 13,
    CP: 3044,
    letra: '',
    nombre: 'GOBERNADOR CRESPO',
  },
  {
    codCiudad: 1263,
    codPcia: 23,
    CP: 0,
    letra: '',
    nombre: 'GOBERNADOR GREGORES',
  },
  {
    codCiudad: 2043,
    codPcia: 10,
    CP: 4409,
    letra: '',
    nombre: 'Gobernador Saravia',
  },
  {
    codCiudad: 1536,
    codPcia: 5,
    CP: 3342,
    letra: '',
    nombre: 'GOBERNADOR VIRASORO',
  },
  {
    codCiudad: 1738,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Gobernador Yalur',
  },
  {
    codCiudad: 578,
    codPcia: 13,
    CP: 2639,
    letra: '',
    nombre: 'GODEKEN',
  },
  {
    codCiudad: 639,
    codPcia: 13,
    CP: 2921,
    letra: '',
    nombre: 'GODOY',
  },
  {
    codCiudad: 960,
    codPcia: 9,
    CP: 5501,
    letra: '',
    nombre: 'GODOY CRUZ',
  },
  {
    codCiudad: 1118,
    codPcia: 2,
    CP: 6614,
    letra: '',
    nombre: 'GOLDNEY - PDO MERCED',
  },
  {
    codCiudad: 411,
    codPcia: 2,
    CP: 1897,
    letra: '',
    nombre: 'GONNET',
  },
  {
    codCiudad: 2455,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'Gonzalez',
  },
  {
    codCiudad: 357,
    codPcia: 2,
    CP: 1759,
    letra: '',
    nombre: 'GONZALEZ CATAN',
  },
  {
    codCiudad: 1122,
    codPcia: 2,
    CP: 6632,
    letra: '',
    nombre: 'GOROSTIAGA',
  },
  {
    codCiudad: 736,
    codPcia: 5,
    CP: 3450,
    letra: '',
    nombre: 'GOYA',
  },
  {
    codCiudad: 1511,
    codPcia: 19,
    CP: 8200,
    letra: '',
    nombre: 'GRAL ACHA',
  },
  {
    codCiudad: 1167,
    codPcia: 2,
    CP: 7263,
    letra: '',
    nombre: 'GRAL ALVEAR',
  },
  {
    codCiudad: 553,
    codPcia: 4,
    CP: 2583,
    letra: '',
    nombre: 'GRAL BALDISERA',
  },
  {
    codCiudad: 1011,
    codPcia: 4,
    CP: 5809,
    letra: '',
    nombre: 'GRAL CABRERA',
  },
  {
    codCiudad: 1044,
    codPcia: 4,
    CP: 5923,
    letra: '',
    nombre: 'GRAL DEHEZA',
  },
  {
    codCiudad: 626,
    codPcia: 6,
    CP: 2843,
    letra: '',
    nombre: 'GRAL GALARZA',
  },
  {
    codCiudad: 964,
    codPcia: 9,
    CP: 5511,
    letra: '',
    nombre: 'GRAL GUTIERREZ',
  },
  {
    codCiudad: 452,
    codPcia: 13,
    CP: 2127,
    letra: '',
    nombre: 'GRAL LAGOS',
  },
  {
    codCiudad: 346,
    codPcia: 2,
    CP: 1741,
    letra: '',
    nombre: 'GRAL LAS HERAS',
  },
  {
    codCiudad: 3186,
    codPcia: 18,
    CP: 3615,
    letra: '',
    nombre: 'GRAL MANUEL BELGRANO',
  },
  {
    codCiudad: 293,
    codPcia: 2,
    CP: 1617,
    letra: '',
    nombre: 'GRAL PACHECO',
  },
  {
    codCiudad: 1097,
    codPcia: 19,
    CP: 6360,
    letra: '',
    nombre: 'GRAL PICO',
  },
  {
    codCiudad: 1073,
    codPcia: 2,
    CP: 6050,
    letra: '',
    nombre: 'GRAL PINTO',
  },
  {
    codCiudad: 630,
    codPcia: 2,
    CP: 2905,
    letra: '',
    nombre: 'GRAL ROJO',
  },
  {
    codCiudad: 1198,
    codPcia: 19,
    CP: 8206,
    letra: '',
    nombre: 'GRAL SAN MARTIN',
  },
  {
    codCiudad: 1069,
    codPcia: 2,
    CP: 6015,
    letra: '',
    nombre: 'GRAL VIAMONTE',
  },
  {
    codCiudad: 1383,
    codPcia: 9,
    CP: 5620,
    letra: '',
    nombre: 'GRAL. ALVEAR',
  },
  {
    codCiudad: 1694,
    codPcia: 6,
    CP: 3216,
    letra: '',
    nombre: 'GRAL. CAMPOS',
  },
  {
    codCiudad: 746,
    codPcia: 16,
    CP: 3509,
    letra: '',
    nombre: 'GRAL. JOSE DE SAN MA',
  },
  {
    codCiudad: 557,
    codPcia: 4,
    CP: 2592,
    letra: '',
    nombre: 'GRAL. ROCA',
  },
  {
    codCiudad: 785,
    codPcia: 16,
    CP: 3732,
    letra: '',
    nombre: 'GRAL.PINEDO',
  },
  {
    codCiudad: 349,
    codPcia: 2,
    CP: 1748,
    letra: '',
    nombre: 'GRAL.RODRIGUEZ',
  },
  {
    codCiudad: 3144,
    codPcia: 18,
    CP: 3604,
    letra: '',
    nombre: 'GRAN GUARDIA',
  },
  {
    codCiudad: 466,
    codPcia: 13,
    CP: 2152,
    letra: '',
    nombre: 'GRANADERO BAIGORRIA',
  },
  {
    codCiudad: 292,
    codPcia: 2,
    CP: 1615,
    letra: '',
    nombre: 'GRAND BOURG',
  },
  {
    codCiudad: 294,
    codPcia: 2,
    CP: 1618,
    letra: '',
    nombre: 'GRAND BOURG',
  },
  {
    codCiudad: 2064,
    codPcia: 10,
    CP: 4411,
    letra: '',
    nombre: 'Grandes Pastos',
  },
  {
    codCiudad: 818,
    codPcia: 3,
    CP: 4159,
    letra: '',
    nombre: 'GRANEROS',
  },
  {
    codCiudad: 525,
    codPcia: 13,
    CP: 2501,
    letra: '',
    nombre: 'GRANJA SAN MANUEL',
  },
  {
    codCiudad: 3176,
    codPcia: 13,
    CP: 3061,
    letra: '',
    nombre: 'GREGORIA PEREZ DE DENIS',
  },
  {
    codCiudad: 499,
    codPcia: 13,
    CP: 2257,
    letra: '',
    nombre: 'GRO BASILIO BUSTOS',
  },
  {
    codCiudad: 1688,
    codPcia: 13,
    CP: 3083,
    letra: '',
    nombre: 'GRUTLY',
  },
  {
    codCiudad: 1523,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'GUACHIPAS',
  },
  {
    codCiudad: 1739,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Guadalcazar',
  },
  {
    codCiudad: 625,
    codPcia: 6,
    CP: 2840,
    letra: '',
    nombre: 'GUALEGUAY',
  },
  {
    codCiudad: 1458,
    codPcia: 6,
    CP: 2820,
    letra: '',
    nombre: 'GUALEGUAYCHU',
  },
  {
    codCiudad: 2199,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'Gualfin',
  },
  {
    codCiudad: 2235,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'Gualiana',
  },
  {
    codCiudad: 1476,
    codPcia: 17,
    CP: 9201,
    letra: '',
    nombre: 'Gualjaina',
  },
  {
    codCiudad: 2898,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'Guamachi',
  },
  {
    codCiudad: 1102,
    codPcia: 2,
    CP: 6476,
    letra: '',
    nombre: 'GUANACO',
  },
  {
    codCiudad: 572,
    codPcia: 4,
    CP: 2627,
    letra: '',
    nombre: 'GUATIMOZIN',
  },
  {
    codCiudad: 1648,
    codPcia: 19,
    CP: 6311,
    letra: '',
    nombre: 'GUATRACHE',
  },
  {
    codCiudad: 1606,
    codPcia: 5,
    CP: 3232,
    letra: '',
    nombre: 'GUAVIRARI',
  },
  {
    codCiudad: 2642,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Guayacan',
  },
  {
    codCiudad: 1387,
    codPcia: 9,
    CP: 5521,
    letra: '',
    nombre: 'GUAYMALLEN',
  },
  {
    codCiudad: 837,
    codPcia: 14,
    CP: 4234,
    letra: '',
    nombre: 'GUAZAYAN',
  },
  {
    codCiudad: 393,
    codPcia: 2,
    CP: 1862,
    letra: '',
    nombre: 'GUERNICA',
  },
  {
    codCiudad: 600,
    codPcia: 2,
    CP: 2717,
    letra: '',
    nombre: 'GUERRICO',
  },
  {
    codCiudad: 891,
    codPcia: 4,
    CP: 5145,
    letra: '',
    nombre: 'GUI',
  },
  {
    codCiudad: 2200,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'H Muerto Salar',
  },
  {
    codCiudad: 336,
    codPcia: 2,
    CP: 1706,
    letra: '',
    nombre: 'HAEDO',
  },
  {
    codCiudad: 3099,
    codPcia: 10,
    CP: 5236,
    letra: '',
    nombre: 'Haras San Antonio',
  },
  {
    codCiudad: 696,
    codPcia: 6,
    CP: 3134,
    letra: '',
    nombre: 'HASENKAMP',
  },
  {
    codCiudad: 653,
    codPcia: 13,
    CP: 3003,
    letra: '',
    nombre: 'HELVECIA',
  },
  {
    codCiudad: 786,
    codPcia: 16,
    CP: 3733,
    letra: '',
    nombre: 'HERMOSO CAMPO',
  },
  {
    codCiudad: 3208,
    codPcia: 6,
    CP: 3127,
    letra: '',
    nombre: 'HERNANDARIAS',
  },
  {
    codCiudad: 1601,
    codPcia: 6,
    CP: 3156,
    letra: '',
    nombre: 'HERNANDEZ',
  },
  {
    codCiudad: 1046,
    codPcia: 4,
    CP: 5929,
    letra: '',
    nombre: 'HERNANDO',
  },
  {
    codCiudad: 3150,
    codPcia: 18,
    CP: 3601,
    letra: '',
    nombre: 'HERRADURA',
  },
  {
    codCiudad: 3128,
    codPcia: 14,
    CP: 4326,
    letra: '',
    nombre: 'HERRERA',
  },
  {
    codCiudad: 1654,
    codPcia: 13,
    CP: 2352,
    letra: '',
    nombre: 'HERSILIA',
  },
  {
    codCiudad: 2856,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Hickman',
  },
  {
    codCiudad: 2977,
    codPcia: 10,
    CP: 4633,
    letra: '',
    nombre: 'Higueras',
  },
  {
    codCiudad: 1409,
    codPcia: 4,
    CP: 6225,
    letra: '',
    nombre: 'HIPOLITO BOUCHARD',
  },
  {
    codCiudad: 2730,
    codPcia: 10,
    CP: 4532,
    letra: '',
    nombre: 'Hipolito Yrigoyen',
  },
  {
    codCiudad: 2926,
    codPcia: 10,
    CP: 4561,
    letra: '',
    nombre: 'Hito 1',
  },
  {
    codCiudad: 1016,
    codPcia: 4,
    CP: 5825,
    letra: '',
    nombre: 'HOLMBERG',
  },
  {
    codCiudad: 3042,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'Hornillos',
  },
  {
    codCiudad: 2491,
    codPcia: 10,
    CP: 4440,
    letra: '',
    nombre: 'Hosteria Juramento',
  },
  {
    codCiudad: 1515,
    codPcia: 14,
    CP: 4200,
    letra: '',
    nombre: 'HUAICO HONDO',
  },
  {
    codCiudad: 2044,
    codPcia: 10,
    CP: 4409,
    letra: '',
    nombre: 'Huaicondo',
  },
  {
    codCiudad: 3075,
    codPcia: 10,
    CP: 4653,
    letra: '',
    nombre: 'Huallatayoc',
  },
  {
    codCiudad: 684,
    codPcia: 13,
    CP: 3076,
    letra: '',
    nombre: 'HUANQUEROS',
  },
  {
    codCiudad: 2129,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Huayra Huasy',
  },
  {
    codCiudad: 899,
    codPcia: 4,
    CP: 5174,
    letra: '',
    nombre: 'HUERTA GRANDE',
  },
  {
    codCiudad: 606,
    codPcia: 13,
    CP: 2725,
    letra: '',
    nombre: 'HUGHES',
  },
  {
    codCiudad: 1937,
    codPcia: 10,
    CP: 4400,
    letra: '',
    nombre: 'Huguerillas',
  },
  {
    codCiudad: 1090,
    codPcia: 4,
    CP: 6270,
    letra: '',
    nombre: 'HUINCA RENANCO',
  },
  {
    codCiudad: 1955,
    codPcia: 10,
    CP: 4401,
    letra: '',
    nombre: 'Humaita',
  },
  {
    codCiudad: 2201,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'Humanas',
  },
  {
    codCiudad: 506,
    codPcia: 13,
    CP: 2309,
    letra: '',
    nombre: 'HUMBERTO PRIMO',
  },
  {
    codCiudad: 686,
    codPcia: 13,
    CP: 3081,
    letra: '',
    nombre: 'HUMBOLDT',
  },
  {
    codCiudad: 1417,
    codPcia: 21,
    CP: 8351,
    letra: '',
    nombre: 'HUNCAL',
  },
  {
    codCiudad: 595,
    codPcia: 2,
    CP: 2707,
    letra: '',
    nombre: 'HUNTER',
  },
  {
    codCiudad: 332,
    codPcia: 2,
    CP: 1686,
    letra: '',
    nombre: 'HURLINGHAM',
  },
  {
    codCiudad: 1982,
    codPcia: 10,
    CP: 4403,
    letra: '',
    nombre: 'I De La Candelaria',
  },
  {
    codCiudad: 460,
    codPcia: 13,
    CP: 2142,
    letra: '',
    nombre: 'IBARLUCEA',
  },
  {
    codCiudad: 774,
    codPcia: 18,
    CP: 3624,
    letra: '',
    nombre: 'IBARRETA',
  },
  {
    codCiudad: 3161,
    codPcia: 6,
    CP: 2846,
    letra: '',
    nombre: 'IBICUY',
  },
  {
    codCiudad: 3113,
    codPcia: 14,
    CP: 4334,
    letra: '',
    nombre: 'ICAÑO',
  },
  {
    codCiudad: 543,
    codPcia: 4,
    CP: 2557,
    letra: '',
    nombre: 'IDIAZABAL',
  },
  {
    codCiudad: 1396,
    codPcia: 11,
    CP: 5467,
    letra: '',
    nombre: 'IGLESIA',
  },
  {
    codCiudad: 1062,
    codPcia: 4,
    CP: 5987,
    letra: '',
    nombre: 'IMPIRA',
  },
  {
    codCiudad: 2090,
    codPcia: 10,
    CP: 4413,
    letra: '',
    nombre: 'Incachuli',
  },
  {
    codCiudad: 2045,
    codPcia: 10,
    CP: 4409,
    letra: '',
    nombre: 'Incahuasi',
  },
  {
    codCiudad: 2046,
    codPcia: 10,
    CP: 4409,
    letra: '',
    nombre: 'Incamayo',
  },
  {
    codCiudad: 1637,
    codPcia: 2,
    CP: 7501,
    letra: '',
    nombre: 'INDIO RICO',
  },
  {
    codCiudad: 615,
    codPcia: 2,
    CP: 2747,
    letra: '',
    nombre: 'INES INDART',
  },
  {
    codCiudad: 365,
    codPcia: 2,
    CP: 1773,
    letra: '',
    nombre: 'ING BUDGE',
  },
  {
    codCiudad: 1740,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Ing E H Faure',
  },
  {
    codCiudad: 1741,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Ing G. N Juarez',
  },
  {
    codCiudad: 1742,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Ing Guillermo N Juarez',
  },
  {
    codCiudad: 297,
    codPcia: 2,
    CP: 1623,
    letra: '',
    nombre: 'ING MASCHWITZ',
  },
  {
    codCiudad: 1191,
    codPcia: 2,
    CP: 8103,
    letra: '',
    nombre: 'ING WHITE',
  },
  {
    codCiudad: 1094,
    codPcia: 2,
    CP: 6337,
    letra: '',
    nombre: 'ING. THOMPSON',
  },
  {
    codCiudad: 1743,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Ingeniero Juarez',
  },
  {
    codCiudad: 1467,
    codPcia: 19,
    CP: 6205,
    letra: '',
    nombre: 'INGENIERO LUIGGI - REALICO',
  },
  {
    codCiudad: 2047,
    codPcia: 10,
    CP: 4409,
    letra: '',
    nombre: 'Ingeniero Maury',
  },
  {
    codCiudad: 2812,
    codPcia: 10,
    CP: 4542,
    letra: '',
    nombre: 'Ingenio La Esperanza',
  },
  {
    codCiudad: 2813,
    codPcia: 10,
    CP: 4542,
    letra: '',
    nombre: 'Ingenio La Espza',
  },
  {
    codCiudad: 2425,
    codPcia: 10,
    CP: 4432,
    letra: '',
    nombre: 'Ingenio San Isidro',
  },
  {
    codCiudad: 2734,
    codPcia: 10,
    CP: 4533,
    letra: '',
    nombre: 'Ingenio San Martin',
  },
  {
    codCiudad: 1351,
    codPcia: 4,
    CP: 2587,
    letra: '',
    nombre: 'INRIVILLE',
  },
  {
    codCiudad: 1634,
    codPcia: 19,
    CP: 6221,
    letra: '',
    nombre: 'INTENDENTE ALVEAR',
  },
  {
    codCiudad: 3043,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'Inticancho',
  },
  {
    codCiudad: 757,
    codPcia: 13,
    CP: 3551,
    letra: '',
    nombre: 'INTIYACO',
  },
  {
    codCiudad: 1700,
    codPcia: 13,
    CP: 2248,
    letra: '',
    nombre: 'IRIGOYEN',
  },
  {
    codCiudad: 647,
    codPcia: 2,
    CP: 2943,
    letra: '',
    nombre: 'IRINEO PORTELA',
  },
  {
    codCiudad: 2978,
    codPcia: 10,
    CP: 4633,
    letra: '',
    nombre: 'Iruya',
  },
  {
    codCiudad: 360,
    codPcia: 2,
    CP: 1765,
    letra: '',
    nombre: 'ISIDRO CASANOVA',
  },
  {
    codCiudad: 1708,
    codPcia: 10,
    CP: 4531,
    letra: '',
    nombre: 'Isla de Cañas',
  },
  {
    codCiudad: 2729,
    codPcia: 10,
    CP: 4531,
    letra: '',
    nombre: 'Isla De Caqas',
  },
  {
    codCiudad: 726,
    codPcia: 16,
    CP: 3409,
    letra: '',
    nombre: 'ISLA DE CERRITO',
  },
  {
    codCiudad: 1035,
    codPcia: 4,
    CP: 5893,
    letra: '',
    nombre: 'ISLA VERDE',
  },
  {
    codCiudad: 586,
    codPcia: 4,
    CP: 2661,
    letra: '',
    nombre: 'ISLA VERDE',
  },
  {
    codCiudad: 2344,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'Isonza',
  },
  {
    codCiudad: 740,
    codPcia: 5,
    CP: 3480,
    letra: '',
    nombre: 'ITA IBATE',
  },
  {
    codCiudad: 729,
    codPcia: 5,
    CP: 3414,
    letra: '',
    nombre: 'ITATI',
  },
  {
    codCiudad: 1110,
    codPcia: 2,
    CP: 6557,
    letra: '',
    nombre: 'ITURREGUI',
  },
  {
    codCiudad: 2953,
    codPcia: 10,
    CP: 4566,
    letra: '',
    nombre: 'Ituyuro',
  },
  {
    codCiudad: 1309,
    codPcia: 5,
    CP: 3302,
    letra: '',
    nombre: 'ITUZAINGO',
  },
  {
    codCiudad: 339,
    codPcia: 2,
    CP: 1714,
    letra: '',
    nombre: 'ITUZAINGO',
  },
  {
    codCiudad: 1001,
    codPcia: 12,
    CP: 5735,
    letra: '',
    nombre: 'J. LLERENA',
  },
  {
    codCiudad: 317,
    codPcia: 2,
    CP: 1655,
    letra: '',
    nombre: 'J.L.SUAREZ',
  },
  {
    codCiudad: 1329,
    codPcia: 11,
    CP: 5460,
    letra: '',
    nombre: 'JACHAL',
  },
  {
    codCiudad: 2345,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'Jacimana',
  },
  {
    codCiudad: 1060,
    codPcia: 4,
    CP: 5984,
    letra: '',
    nombre: 'JAMES CRAIK',
  },
  {
    codCiudad: 2801,
    codPcia: 10,
    CP: 4537,
    letra: '',
    nombre: 'Jeronimo Matorras',
  },
  {
    codCiudad: 912,
    codPcia: 4,
    CP: 5220,
    letra: '',
    nombre: 'JESUS MARIA',
  },
  {
    codCiudad: 2562,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'Joaquin V Gonzalez',
  },
  {
    codCiudad: 1556,
    codPcia: 2,
    CP: 8156,
    letra: '',
    nombre: 'JOSE A. GUISASOLA',
  },
  {
    codCiudad: 322,
    codPcia: 2,
    CP: 1665,
    letra: '',
    nombre: 'JOSE C PAZ',
  },
  {
    codCiudad: 1433,
    codPcia: 17,
    CP: 9220,
    letra: '',
    nombre: 'JOSE DE SAN MARTIN',
  },
  {
    codCiudad: 367,
    codPcia: 2,
    CP: 1778,
    letra: '',
    nombre: 'JOSE INGENIEROS',
  },
  {
    codCiudad: 1660,
    codPcia: 2,
    CP: 1846,
    letra: '',
    nombre: 'JOSE MARMOL',
  },
  {
    codCiudad: 1319,
    codPcia: 4,
    CP: 6127,
    letra: '',
    nombre: 'JOVITA',
  },
  {
    codCiudad: 817,
    codPcia: 3,
    CP: 4158,
    letra: '',
    nombre: 'JUAN B ALBERDI',
  },
  {
    codCiudad: 1582,
    codPcia: 2,
    CP: 8136,
    letra: '',
    nombre: 'JUAN COUSTE',
  },
  {
    codCiudad: 1699,
    codPcia: 16,
    CP: 3705,
    letra: '',
    nombre: 'JUAN JOSE CASTELLI',
  },
  {
    codCiudad: 777,
    codPcia: 16,
    CP: 3705,
    letra: '',
    nombre: 'JUAN JOSE CASTELLI',
  },
  {
    codCiudad: 1145,
    codPcia: 2,
    CP: 7020,
    letra: '',
    nombre: 'JUAREZ',
  },
  {
    codCiudad: 1373,
    codPcia: 4,
    CP: 5145,
    letra: '',
    nombre: 'JUAREZ CELMAN',
  },
  {
    codCiudad: 1805,
    codPcia: 10,
    CP: 4141,
    letra: '',
    nombre: 'Julipao',
  },
  {
    codCiudad: 605,
    codPcia: 13,
    CP: 2723,
    letra: '',
    nombre: 'JUNCAL',
  },
  {
    codCiudad: 2065,
    codPcia: 10,
    CP: 4411,
    letra: '',
    nombre: 'Juncal',
  },
  {
    codCiudad: 2091,
    codPcia: 10,
    CP: 4413,
    letra: '',
    nombre: 'Juncalito',
  },
  {
    codCiudad: 1666,
    codPcia: 9,
    CP: 5573,
    letra: '',
    nombre: 'JUNIN',
  },
  {
    codCiudad: 1063,
    codPcia: 2,
    CP: 6000,
    letra: '',
    nombre: 'JUNIN',
  },
  {
    codCiudad: 1494,
    codPcia: 21,
    CP: 8371,
    letra: '',
    nombre: 'JUNIN DE LOS ANDES',
  },
  {
    codCiudad: 2699,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'Juntas De S Ant',
  },
  {
    codCiudad: 2456,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'Juramento',
  },
  {
    codCiudad: 541,
    codPcia: 4,
    CP: 2553,
    letra: '',
    nombre: 'JUSTINIANO POSSE',
  },
  {
    codCiudad: 1002,
    codPcia: 12,
    CP: 5738,
    letra: '',
    nombre: 'JUSTO DARACT',
  },
  {
    codCiudad: 2563,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'Kilometro 1088',
  },
  {
    codCiudad: 2387,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'Kilometro 1094',
  },
  {
    codCiudad: 2426,
    codPcia: 10,
    CP: 4432,
    letra: '',
    nombre: 'Kilometro 1102',
  },
  {
    codCiudad: 2608,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'Kilometro 1104',
  },
  {
    codCiudad: 1956,
    codPcia: 10,
    CP: 4401,
    letra: '',
    nombre: 'Kilometro 1125',
  },
  {
    codCiudad: 2643,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Kilometro 1152',
  },
  {
    codCiudad: 1983,
    codPcia: 10,
    CP: 4403,
    letra: '',
    nombre: 'Kilometro 1156',
  },
  {
    codCiudad: 2027,
    codPcia: 10,
    CP: 4407,
    letra: '',
    nombre: 'Kilometro 1172',
  },
  {
    codCiudad: 2236,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'Kilometro 1176 300',
  },
  {
    codCiudad: 2745,
    codPcia: 10,
    CP: 4534,
    letra: '',
    nombre: 'Kilometro 1280',
  },
  {
    codCiudad: 2746,
    codPcia: 10,
    CP: 4534,
    letra: '',
    nombre: 'Kilometro 1281',
  },
  {
    codCiudad: 2747,
    codPcia: 10,
    CP: 4534,
    letra: '',
    nombre: 'Kilometro 1291',
  },
  {
    codCiudad: 2735,
    codPcia: 10,
    CP: 4533,
    letra: '',
    nombre: 'Kilometro 1298',
  },
  {
    codCiudad: 2997,
    codPcia: 10,
    CP: 4634,
    letra: '',
    nombre: 'Kilometro 1321',
  },
  {
    codCiudad: 2092,
    codPcia: 10,
    CP: 4413,
    letra: '',
    nombre: 'Kilometro 1369',
  },
  {
    codCiudad: 2093,
    codPcia: 10,
    CP: 4413,
    letra: '',
    nombre: 'Kilometro 1373',
  },
  {
    codCiudad: 3009,
    codPcia: 10,
    CP: 4644,
    letra: '',
    nombre: 'Kilometro 1397',
  },
  {
    codCiudad: 2937,
    codPcia: 10,
    CP: 4562,
    letra: '',
    nombre: 'Kilometro 1398',
  },
  {
    codCiudad: 2094,
    codPcia: 10,
    CP: 4413,
    letra: '',
    nombre: 'Kilometro 1424',
  },
  {
    codCiudad: 2947,
    codPcia: 10,
    CP: 4564,
    letra: '',
    nombre: 'Kilometro 1448',
  },
  {
    codCiudad: 768,
    codPcia: 13,
    CP: 3589,
    letra: '',
    nombre: 'KILOMETRO 23',
  },
  {
    codCiudad: 2822,
    codPcia: 10,
    CP: 4550,
    letra: '',
    nombre: 'Km 1306 Fcgb',
  },
  {
    codCiudad: 290,
    codPcia: 2,
    CP: 1612,
    letra: '',
    nombre: 'KM 30',
  },
  {
    codCiudad: 1079,
    codPcia: 13,
    CP: 6103,
    letra: '',
    nombre: 'LA ADELAIDA',
  },
  {
    codCiudad: 2492,
    codPcia: 10,
    CP: 4440,
    letra: '',
    nombre: 'La Aguadita',
  },
  {
    codCiudad: 2965,
    codPcia: 10,
    CP: 4600,
    letra: '',
    nombre: 'La Almona',
  },
  {
    codCiudad: 1064,
    codPcia: 2,
    CP: 6003,
    letra: '',
    nombre: 'LA ANGELITA',
  },
  {
    codCiudad: 2346,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'La Arcadia',
  },
  {
    codCiudad: 2237,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'La Argentina',
  },
  {
    codCiudad: 2238,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'La Armonia',
  },
  {
    codCiudad: 2518,
    codPcia: 10,
    CP: 4444,
    letra: '',
    nombre: 'La Armonia',
  },
  {
    codCiudad: 2347,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'La Armonia',
  },
  {
    codCiudad: 2388,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'La Asuncion',
  },
  {
    codCiudad: 1781,
    codPcia: 10,
    CP: 4126,
    letra: '',
    nombre: 'La Asuncion',
  },
  {
    codCiudad: 2348,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'La Banda',
  },
  {
    codCiudad: 839,
    codPcia: 14,
    CP: 4300,
    letra: '',
    nombre: 'LA BANDA',
  },
  {
    codCiudad: 2239,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'La Bodega',
  },
  {
    codCiudad: 2240,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'La Bodeguita',
  },
  {
    codCiudad: 1684,
    codPcia: 13,
    CP: 3045,
    letra: '',
    nombre: 'LA BRAVA',
  },
  {
    codCiudad: 1702,
    codPcia: 13,
    CP: 3074,
    letra: '',
    nombre: 'LA CABRAL',
  },
  {
    codCiudad: 2276,
    codPcia: 10,
    CP: 4423,
    letra: '',
    nombre: 'La Calavera',
  },
  {
    codCiudad: 1267,
    codPcia: 10,
    CP: 4401,
    letra: '',
    nombre: 'LA CALDERA',
  },
  {
    codCiudad: 894,
    codPcia: 4,
    CP: 5151,
    letra: '',
    nombre: 'LA CALERA',
  },
  {
    codCiudad: 2768,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'La Cancha',
  },
  {
    codCiudad: 1782,
    codPcia: 10,
    CP: 4126,
    letra: '',
    nombre: 'La Candelaria',
  },
  {
    codCiudad: 588,
    codPcia: 4,
    CP: 2670,
    letra: '',
    nombre: 'LA CARLOTA',
  },
  {
    codCiudad: 179,
    codPcia: 13,
    CP: 1205,
    letra: '',
    nombre: 'LA CAROLINA',
  },
  {
    codCiudad: 2538,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'La Carretera',
  },
  {
    codCiudad: 2095,
    codPcia: 10,
    CP: 4413,
    letra: '',
    nombre: 'La Casualidad Mina',
  },
  {
    codCiudad: 1438,
    codPcia: 4,
    CP: 5142,
    letra: '',
    nombre: 'LA CAUTIVA',
  },
  {
    codCiudad: 1306,
    codPcia: 4,
    CP: 6101,
    letra: '',
    nombre: 'LA CESIRA',
  },
  {
    codCiudad: 2927,
    codPcia: 10,
    CP: 4561,
    letra: '',
    nombre: 'La China',
  },
  {
    codCiudad: 3044,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'La Chinaca',
  },
  {
    codCiudad: 1774,
    codPcia: 10,
    CP: 3700,
    letra: '',
    nombre: 'La Chiquita',
  },
  {
    codCiudad: 1861,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'La Cienaga Capital',
  },
  {
    codCiudad: 1806,
    codPcia: 10,
    CP: 4141,
    letra: '',
    nombre: 'La Cieneguita',
  },
  {
    codCiudad: 819,
    codPcia: 3,
    CP: 4162,
    letra: '',
    nombre: 'LA COCHA',
  },
  {
    codCiudad: 1080,
    codPcia: 13,
    CP: 6103,
    letra: '',
    nombre: 'LA CONSTANCIA',
  },
  {
    codCiudad: 3136,
    codPcia: 20,
    CP: 3355,
    letra: '',
    nombre: 'LA CORITA DE SANTA MARIA',
  },
  {
    codCiudad: 2312,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'La Costa',
  },
  {
    codCiudad: 2241,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'La Costa',
  },
  {
    codCiudad: 2493,
    codPcia: 10,
    CP: 4440,
    letra: '',
    nombre: 'La Costosa',
  },
  {
    codCiudad: 678,
    codPcia: 13,
    CP: 3052,
    letra: '',
    nombre: 'LA CRIOLLA',
  },
  {
    codCiudad: 922,
    codPcia: 4,
    CP: 5249,
    letra: '',
    nombre: 'LA CRUZ',
  },
  {
    codCiudad: 1938,
    codPcia: 10,
    CP: 4400,
    letra: '',
    nombre: 'La Cruz',
  },
  {
    codCiudad: 1862,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'La Cruz',
  },
  {
    codCiudad: 1783,
    codPcia: 10,
    CP: 4126,
    letra: '',
    nombre: 'La Cuesta',
  },
  {
    codCiudad: 2457,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'La Cuestita Anta',
  },
  {
    codCiudad: 2458,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'La Cuestita Metan',
  },
  {
    codCiudad: 1784,
    codPcia: 10,
    CP: 4126,
    letra: '',
    nombre: 'La Cueva',
  },
  {
    codCiudad: 901,
    codPcia: 4,
    CP: 5178,
    letra: '',
    nombre: 'LA CUMBRE',
  },
  {
    codCiudad: 1323,
    codPcia: 4,
    CP: 5194,
    letra: '',
    nombre: 'LA CUMBRECITA',
  },
  {
    codCiudad: 2857,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'La Curva',
  },
  {
    codCiudad: 2389,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'La Defensa',
  },
  {
    codCiudad: 628,
    codPcia: 2,
    CP: 2901,
    letra: '',
    nombre: 'LA EMILIA',
  },
  {
    codCiudad: 2858,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'La Entrada',
  },
  {
    codCiudad: 748,
    codPcia: 16,
    CP: 3514,
    letra: '',
    nombre: 'LA ESCONDIDA',
  },
  {
    codCiudad: 2277,
    codPcia: 10,
    CP: 4423,
    letra: '',
    nombre: 'La Esperanza',
  },
  {
    codCiudad: 2564,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'La Esperanza',
  },
  {
    codCiudad: 2769,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'La Esperanza',
  },
  {
    codCiudad: 2130,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'La Esperanza',
  },
  {
    codCiudad: 2770,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'La Esquinita',
  },
  {
    codCiudad: 2014,
    codPcia: 10,
    CP: 4405,
    letra: '',
    nombre: 'La Estela',
  },
  {
    codCiudad: 2802,
    codPcia: 10,
    CP: 4537,
    letra: '',
    nombre: 'La Estrella',
  },
  {
    codCiudad: 929,
    codPcia: 4,
    CP: 5285,
    letra: '',
    nombre: 'LA FALDA',
  },
  {
    codCiudad: 1984,
    codPcia: 10,
    CP: 4403,
    letra: '',
    nombre: 'La Falda',
  },
  {
    codCiudad: 898,
    codPcia: 4,
    CP: 5172,
    letra: '',
    nombre: 'LA FALDA',
  },
  {
    codCiudad: 3045,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'La Falda',
  },
  {
    codCiudad: 1985,
    codPcia: 10,
    CP: 4403,
    letra: '',
    nombre: 'La Fama',
  },
  {
    codCiudad: 1863,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'La Firmeza',
  },
  {
    codCiudad: 1744,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'La Florencia',
  },
  {
    codCiudad: 1888,
    codPcia: 10,
    CP: 4195,
    letra: '',
    nombre: 'La Florida',
  },
  {
    codCiudad: 2313,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'La Florida',
  },
  {
    codCiudad: 2823,
    codPcia: 10,
    CP: 4550,
    letra: '',
    nombre: 'La Fortuna',
  },
  {
    codCiudad: 1448,
    codPcia: 13,
    CP: 3057,
    letra: '',
    nombre: 'LA GALLARETA',
  },
  {
    codCiudad: 881,
    codPcia: 4,
    CP: 5115,
    letra: '',
    nombre: 'LA GRANJA',
  },
  {
    codCiudad: 680,
    codPcia: 13,
    CP: 3056,
    letra: '',
    nombre: 'LA GUAMPITA',
  },
  {
    codCiudad: 2278,
    codPcia: 10,
    CP: 4423,
    letra: '',
    nombre: 'La Guardia',
  },
  {
    codCiudad: 3124,
    codPcia: 13,
    CP: 3001,
    letra: '',
    nombre: 'LA GUARDIA',
  },
  {
    codCiudad: 2131,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'La Herradura',
  },
  {
    codCiudad: 2816,
    codPcia: 10,
    CP: 4547,
    letra: '',
    nombre: 'La Higuera',
  },
  {
    codCiudad: 1916,
    codPcia: 10,
    CP: 4198,
    letra: '',
    nombre: 'La Hoyada',
  },
  {
    codCiudad: 2979,
    codPcia: 10,
    CP: 4633,
    letra: '',
    nombre: 'La Huerta',
  },
  {
    codCiudad: 1491,
    codPcia: 19,
    CP: 6323,
    letra: '',
    nombre: 'LA HUMADA',
  },
  {
    codCiudad: 3092,
    codPcia: 10,
    CP: 5235,
    letra: '',
    nombre: 'La Isla',
  },
  {
    codCiudad: 1939,
    codPcia: 10,
    CP: 4400,
    letra: '',
    nombre: 'La Isla',
  },
  {
    codCiudad: 1957,
    codPcia: 10,
    CP: 4401,
    letra: '',
    nombre: 'La Isla',
  },
  {
    codCiudad: 1745,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'La Junta',
  },
  {
    codCiudad: 1478,
    codPcia: 4,
    CP: 5901,
    letra: '',
    nombre: 'LA LAGUNA',
  },
  {
    codCiudad: 1940,
    codPcia: 10,
    CP: 4400,
    letra: '',
    nombre: 'La Lagunilla',
  },
  {
    codCiudad: 751,
    codPcia: 16,
    CP: 3522,
    letra: '',
    nombre: 'LA LEONESA',
  },
  {
    codCiudad: 742,
    codPcia: 16,
    CP: 3501,
    letra: '',
    nombre: 'LA LIGURIA',
  },
  {
    codCiudad: 2565,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'La Lomita',
  },
  {
    codCiudad: 3173,
    codPcia: 13,
    CP: 3050,
    letra: '',
    nombre: 'LA LUCILA',
  },
  {
    codCiudad: 1342,
    codPcia: 2,
    CP: 1636,
    letra: '',
    nombre: 'LA LUCILA - VICENTE LOPEZ',
  },
  {
    codCiudad: 2539,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'La Manga',
  },
  {
    codCiudad: 2390,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'La Maravilla',
  },
  {
    codCiudad: 1785,
    codPcia: 10,
    CP: 4126,
    letra: '',
    nombre: 'La Maravilla',
  },
  {
    codCiudad: 2279,
    codPcia: 10,
    CP: 4423,
    letra: '',
    nombre: 'La Margarita',
  },
  {
    codCiudad: 2280,
    codPcia: 10,
    CP: 4423,
    letra: '',
    nombre: 'La Maroma',
  },
  {
    codCiudad: 352,
    codPcia: 2,
    CP: 1753,
    letra: '',
    nombre: 'LA MATANZA',
  },
  {
    codCiudad: 359,
    codPcia: 2,
    CP: 1763,
    letra: '',
    nombre: 'LA MATANZA',
  },
  {
    codCiudad: 2242,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'La Merced',
  },
  {
    codCiudad: 2349,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'La Merced',
  },
  {
    codCiudad: 2771,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'La Montaqa',
  },
  {
    codCiudad: 2859,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'La Mora',
  },
  {
    codCiudad: 1106,
    codPcia: 2,
    CP: 6513,
    letra: '',
    nombre: 'LA NI',
  },
  {
    codCiudad: 2427,
    codPcia: 10,
    CP: 4432,
    letra: '',
    nombre: 'La Ofelia',
  },
  {
    codCiudad: 2428,
    codPcia: 10,
    CP: 4432,
    letra: '',
    nombre: 'La Oliva',
  },
  {
    codCiudad: 1864,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'La Pajita',
  },
  {
    codCiudad: 1917,
    codPcia: 10,
    CP: 4198,
    letra: '',
    nombre: 'La Palata',
  },
  {
    codCiudad: 1045,
    codPcia: 4,
    CP: 5925,
    letra: '',
    nombre: 'LA PALESTINA',
  },
  {
    codCiudad: 1746,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'La Palma Sola',
  },
  {
    codCiudad: 2314,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'La Pampa',
  },
  {
    codCiudad: 1307,
    codPcia: 4,
    CP: 5117,
    letra: '',
    nombre: 'LA PAMPA ASCOCHINGA',
  },
  {
    codCiudad: 1599,
    codPcia: 4,
    CP: 2417,
    letra: '',
    nombre: 'LA PAQUITA',
  },
  {
    codCiudad: 2202,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'La Paya',
  },
  {
    codCiudad: 1243,
    codPcia: 6,
    CP: 3190,
    letra: '',
    nombre: 'LA PAZ',
  },
  {
    codCiudad: 986,
    codPcia: 9,
    CP: 5590,
    letra: '',
    nombre: 'LA PAZ',
  },
  {
    codCiudad: 1697,
    codPcia: 13,
    CP: 3027,
    letra: '',
    nombre: 'LA PELADA',
  },
  {
    codCiudad: 1625,
    codPcia: 6,
    CP: 3216,
    letra: '',
    nombre: 'LA PERLA',
  },
  {
    codCiudad: 1640,
    codPcia: 6,
    CP: 3118,
    letra: '',
    nombre: 'LA PICADA',
  },
  {
    codCiudad: 412,
    codPcia: 2,
    CP: 1900,
    letra: '',
    nombre: 'LA PLATA',
  },
  {
    codCiudad: 1041,
    codPcia: 4,
    CP: 5911,
    letra: '',
    nombre: 'LA PLAYOSA',
  },
  {
    codCiudad: 1786,
    codPcia: 10,
    CP: 4126,
    letra: '',
    nombre: 'La Poblacion',
  },
  {
    codCiudad: 2315,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'La Poblacion',
  },
  {
    codCiudad: 2519,
    codPcia: 10,
    CP: 4444,
    letra: '',
    nombre: 'La Poblacion',
  },
  {
    codCiudad: 2165,
    codPcia: 10,
    CP: 4416,
    letra: '',
    nombre: 'La Poma',
  },
  {
    codCiudad: 2899,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'La Porcelana',
  },
  {
    codCiudad: 2459,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'La Posta',
  },
  {
    codCiudad: 972,
    codPcia: 9,
    CP: 5527,
    letra: '',
    nombre: 'LA PRIMAVERA-GUAYMAL',
  },
  {
    codCiudad: 890,
    codPcia: 4,
    CP: 5137,
    letra: '',
    nombre: 'LA PUERTA',
  },
  {
    codCiudad: 2203,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'La Puerta',
  },
  {
    codCiudad: 2350,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'La Punilla',
  },
  {
    codCiudad: 1646,
    codPcia: 12,
    CP: 5831,
    letra: '',
    nombre: 'LA PUNILLA',
  },
  {
    codCiudad: 1324,
    codPcia: 12,
    CP: 5710,
    letra: '',
    nombre: 'LA PUNTA',
  },
  {
    codCiudad: 2460,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'La Puntilla',
  },
  {
    codCiudad: 2824,
    codPcia: 10,
    CP: 4550,
    letra: '',
    nombre: 'La Quena',
  },
  {
    codCiudad: 1228,
    codPcia: 2,
    CP: 2912,
    letra: '',
    nombre: 'LA QUERENCIA',
  },
  {
    codCiudad: 1941,
    codPcia: 10,
    CP: 4400,
    letra: '',
    nombre: 'La Quesera',
  },
  {
    codCiudad: 1284,
    codPcia: 19,
    CP: 8201,
    letra: '',
    nombre: 'LA REFORMA VIEJA',
  },
  {
    codCiudad: 2316,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'La Represa',
  },
  {
    codCiudad: 932,
    codPcia: 8,
    CP: 5300,
    letra: '',
    nombre: 'LA RIOJA',
  },
  {
    codCiudad: 1692,
    codPcia: 13,
    CP: 2342,
    letra: '',
    nombre: 'LA RUBIA',
  },
  {
    codCiudad: 3181,
    codPcia: 13,
    CP: 3563,
    letra: '',
    nombre: 'LA SARITA',
  },
  {
    codCiudad: 2436,
    codPcia: 10,
    CP: 4433,
    letra: '',
    nombre: 'La Silleta',
  },
  {
    codCiudad: 2900,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'La Soledad',
  },
  {
    codCiudad: 861,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'LA TABLADA',
  },
  {
    codCiudad: 355,
    codPcia: 2,
    CP: 1756,
    letra: '',
    nombre: 'LA TABLADA',
  },
  {
    codCiudad: 816,
    codPcia: 3,
    CP: 4157,
    letra: '',
    nombre: 'LA TIPA (LOS SARMIEN',
  },
  {
    codCiudad: 2243,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'La Toma',
  },
  {
    codCiudad: 1003,
    codPcia: 12,
    CP: 5750,
    letra: '',
    nombre: 'LA TOMA SAN LUIS',
  },
  {
    codCiudad: 2461,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'La Trampa',
  },
  {
    codCiudad: 1942,
    codPcia: 10,
    CP: 4400,
    letra: '',
    nombre: 'La Troja',
  },
  {
    codCiudad: 1958,
    codPcia: 10,
    CP: 4401,
    letra: '',
    nombre: 'La Union',
  },
  {
    codCiudad: 2772,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'La Union',
  },
  {
    codCiudad: 3134,
    codPcia: 16,
    CP: 3527,
    letra: '',
    nombre: 'LA VERDE',
  },
  {
    codCiudad: 2998,
    codPcia: 10,
    CP: 4634,
    letra: '',
    nombre: 'La Veta',
  },
  {
    codCiudad: 2295,
    codPcia: 10,
    CP: 4424,
    letra: '',
    nombre: 'La Viña',
  },
  {
    codCiudad: 2429,
    codPcia: 10,
    CP: 4432,
    letra: '',
    nombre: 'La Viqa',
  },
  {
    codCiudad: 2351,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'La Viqa',
  },
  {
    codCiudad: 2132,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'La Yesera',
  },
  {
    codCiudad: 3212,
    codPcia: 2,
    CP: 7161,
    letra: '',
    nombre: 'LABARDEN',
  },
  {
    codCiudad: 583,
    codPcia: 4,
    CP: 2657,
    letra: '',
    nombre: 'LABORDE',
  },
  {
    codCiudad: 607,
    codPcia: 13,
    CP: 2726,
    letra: '',
    nombre: 'LABORDEROY',
  },
  {
    codCiudad: 1087,
    codPcia: 4,
    CP: 6183,
    letra: '',
    nombre: 'LABOULAYE',
  },
  {
    codCiudad: 1082,
    codPcia: 4,
    CP: 6120,
    letra: '',
    nombre: 'LABOULAYE',
  },
  {
    codCiudad: 1382,
    codPcia: 4,
    CP: 6120,
    letra: '',
    nombre: 'LABOULAYE',
  },
  {
    codCiudad: 356,
    codPcia: 2,
    CP: 1757,
    letra: '',
    nombre: 'LAFERRERE',
  },
  {
    codCiudad: 2540,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'Lag. N Poblacion',
  },
  {
    codCiudad: 1574,
    codPcia: 17,
    CP: 9037,
    letra: '',
    nombre: 'LAGO BLANCO',
  },
  {
    codCiudad: 1479,
    codPcia: 17,
    CP: 9203,
    letra: '',
    nombre: 'LAGO ROSARIO FUTULEUFU',
  },
  {
    codCiudad: 1466,
    codPcia: 18,
    CP: 3613,
    letra: '',
    nombre: 'LAGUNA BLANCA',
  },
  {
    codCiudad: 2566,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'Laguna Blanca',
  },
  {
    codCiudad: 1058,
    codPcia: 4,
    CP: 5974,
    letra: '',
    nombre: 'LAGUNA LARGA',
  },
  {
    codCiudad: 663,
    codPcia: 13,
    CP: 3020,
    letra: '',
    nombre: 'LAGUNA PAIVA',
  },
  {
    codCiudad: 2096,
    codPcia: 10,
    CP: 4413,
    letra: '',
    nombre: 'Laguna Seca',
  },
  {
    codCiudad: 2609,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'Laguna Verde',
  },
  {
    codCiudad: 2541,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'Lagunita',
  },
  {
    codCiudad: 823,
    codPcia: 15,
    CP: 4176,
    letra: '',
    nombre: 'LAMADRID',
  },
  {
    codCiudad: 1468,
    codPcia: 22,
    CP: 8363,
    letra: '',
    nombre: 'LAMARQUE',
  },
  {
    codCiudad: 537,
    codPcia: 13,
    CP: 2531,
    letra: '',
    nombre: 'LANDETA',
  },
  {
    codCiudad: 378,
    codPcia: 2,
    CP: 1824,
    letra: '',
    nombre: 'LANUS',
  },
  {
    codCiudad: 1178,
    codPcia: 2,
    CP: 7414,
    letra: '',
    nombre: 'LAPRIDA',
  },
  {
    codCiudad: 3119,
    codPcia: 6,
    CP: 2854,
    letra: '',
    nombre: 'LARROQUE',
  },
  {
    codCiudad: 1565,
    codPcia: 4,
    CP: 5848,
    letra: '',
    nombre: 'LAS ACEQUIAS',
  },
  {
    codCiudad: 2462,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'Las Acheras',
  },
  {
    codCiudad: 1633,
    codPcia: 4,
    CP: 5801,
    letra: '',
    nombre: 'LAS ALBAHACAS',
  },
  {
    codCiudad: 2133,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Las Animas',
  },
  {
    codCiudad: 2028,
    codPcia: 10,
    CP: 4407,
    letra: '',
    nombre: 'Las Arcas',
  },
  {
    codCiudad: 2171,
    codPcia: 10,
    CP: 4417,
    letra: '',
    nombre: 'Las Arcas',
  },
  {
    codCiudad: 2015,
    codPcia: 10,
    CP: 4405,
    letra: '',
    nombre: 'Las Arenas',
  },
  {
    codCiudad: 1657,
    codPcia: 13,
    CP: 2148,
    letra: '',
    nombre: 'LAS BANDURRIAS',
  },
  {
    codCiudad: 3100,
    codPcia: 10,
    CP: 5236,
    letra: '',
    nombre: 'Las Bandurrias',
  },
  {
    codCiudad: 2610,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'Las Bateas',
  },
  {
    codCiudad: 2567,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'Las Blancas',
  },
  {
    codCiudad: 1986,
    codPcia: 10,
    CP: 4403,
    letra: '',
    nombre: 'Las Blancas',
  },
  {
    codCiudad: 2773,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'Las Bolsas',
  },
  {
    codCiudad: 782,
    codPcia: 16,
    CP: 3722,
    letra: '',
    nombre: 'LAS BREÑAS',
  },
  {
    codCiudad: 1747,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Las Cañitas',
  },
  {
    codCiudad: 2048,
    codPcia: 10,
    CP: 4409,
    letra: '',
    nombre: 'Las Capillas',
  },
  {
    codCiudad: 2980,
    codPcia: 10,
    CP: 4633,
    letra: '',
    nombre: 'Las Caqas',
  },
  {
    codCiudad: 2463,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'Las Caqas',
  },
  {
    codCiudad: 2928,
    codPcia: 10,
    CP: 4561,
    letra: '',
    nombre: 'Las Caqitas',
  },
  {
    codCiudad: 1865,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'Las Catitas',
  },
  {
    codCiudad: 2049,
    codPcia: 10,
    CP: 4409,
    letra: '',
    nombre: 'Las Cebadas',
  },
  {
    codCiudad: 827,
    codPcia: 3,
    CP: 4186,
    letra: '',
    nombre: 'LAS CEJAS (CRUZ ALTA',
  },
  {
    codCiudad: 3115,
    codPcia: 12,
    CP: 5753,
    letra: '',
    nombre: 'LAS CHACRAS',
  },
  {
    codCiudad: 1889,
    codPcia: 10,
    CP: 4195,
    letra: '',
    nombre: 'Las Colas',
  },
  {
    codCiudad: 1562,
    codPcia: 21,
    CP: 8341,
    letra: '',
    nombre: 'LAS COLORADAS',
  },
  {
    codCiudad: 2352,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'Las Conchas',
  },
  {
    codCiudad: 2774,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'Las Conchas',
  },
  {
    codCiudad: 2134,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Las Cortderas',
  },
  {
    codCiudad: 1959,
    codPcia: 10,
    CP: 4401,
    letra: '',
    nombre: 'Las Costas',
  },
  {
    codCiudad: 2464,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'Las Cuestitas',
  },
  {
    codCiudad: 2050,
    codPcia: 10,
    CP: 4409,
    letra: '',
    nombre: 'Las Cuevas',
  },
  {
    codCiudad: 1650,
    codPcia: 6,
    CP: 3101,
    letra: '',
    nombre: 'LAS CUEVAS',
  },
  {
    codCiudad: 2317,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'Las Curtiembres',
  },
  {
    codCiudad: 2520,
    codPcia: 10,
    CP: 4444,
    letra: '',
    nombre: 'Las Delicias',
  },
  {
    codCiudad: 1636,
    codPcia: 13,
    CP: 2349,
    letra: '',
    nombre: 'LAS DOS ROSAS - SUARDI',
  },
  {
    codCiudad: 2465,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'Las Flacas',
  },
  {
    codCiudad: 2568,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'Las Flechas',
  },
  {
    codCiudad: 2611,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'Las Flores',
  },
  {
    codCiudad: 1159,
    codPcia: 2,
    CP: 7200,
    letra: '',
    nombre: 'LAS FLORES',
  },
  {
    codCiudad: 1449,
    codPcia: 16,
    CP: 3515,
    letra: '',
    nombre: 'LAS GARCITAS',
  },
  {
    codCiudad: 2244,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'Las Garzas',
  },
  {
    codCiudad: 765,
    codPcia: 13,
    CP: 3574,
    letra: '',
    nombre: 'LAS GARZAS',
  },
  {
    codCiudad: 2466,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'Las Hecheras',
  },
  {
    codCiudad: 978,
    codPcia: 9,
    CP: 5539,
    letra: '',
    nombre: 'LAS HERAS',
  },
  {
    codCiudad: 1264,
    codPcia: 23,
    CP: 9017,
    letra: '',
    nombre: 'LAS HERAS',
  },
  {
    codCiudad: 1010,
    codPcia: 4,
    CP: 5805,
    letra: '',
    nombre: 'LAS HIGUERAS',
  },
  {
    codCiudad: 882,
    codPcia: 4,
    CP: 5117,
    letra: '',
    nombre: 'LAS HIGUERAS',
  },
  {
    codCiudad: 2860,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Las Horquetas',
  },
  {
    codCiudad: 2318,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'Las J De Alemania',
  },
  {
    codCiudad: 2494,
    codPcia: 10,
    CP: 4440,
    letra: '',
    nombre: 'Las Juntas',
  },
  {
    codCiudad: 1055,
    codPcia: 4,
    CP: 5965,
    letra: '',
    nombre: 'LAS JUNTURAS',
  },
  {
    codCiudad: 2636,
    codPcia: 10,
    CP: 4450,
    letra: '',
    nombre: 'Las Lajitas',
  },
  {
    codCiudad: 2612,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'Las Lajitas',
  },
  {
    codCiudad: 2319,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'Las Lechuzas',
  },
  {
    codCiudad: 2775,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'Las Llaves',
  },
  {
    codCiudad: 2938,
    codPcia: 10,
    CP: 4562,
    letra: '',
    nombre: 'Las Lomitas',
  },
  {
    codCiudad: 2809,
    codPcia: 10,
    CP: 4538,
    letra: '',
    nombre: 'Las Maravillas',
  },
  {
    codCiudad: 1115,
    codPcia: 2,
    CP: 6607,
    letra: '',
    nombre: 'LAS MARIANAS',
  },
  {
    codCiudad: 2245,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'Las Mercedes',
  },
  {
    codCiudad: 2016,
    codPcia: 10,
    CP: 4405,
    letra: '',
    nombre: 'Las Mesadas',
  },
  {
    codCiudad: 2467,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'Las Mesitas',
  },
  {
    codCiudad: 1040,
    codPcia: 4,
    CP: 5909,
    letra: '',
    nombre: 'LAS MOJARRAS',
  },
  {
    codCiudad: 1890,
    codPcia: 10,
    CP: 4195,
    letra: '',
    nombre: 'Las Mojarritas',
  },
  {
    codCiudad: 2281,
    codPcia: 10,
    CP: 4423,
    letra: '',
    nombre: 'Las Moras',
  },
  {
    codCiudad: 2172,
    codPcia: 10,
    CP: 4417,
    letra: '',
    nombre: 'Las Pailas',
  },
  {
    codCiudad: 931,
    codPcia: 4,
    CP: 5299,
    letra: '',
    nombre: 'LAS PALMAS',
  },
  {
    codCiudad: 1238,
    codPcia: 16,
    CP: 3518,
    letra: '',
    nombre: 'LAS PALMAS',
  },
  {
    codCiudad: 1987,
    codPcia: 10,
    CP: 4403,
    letra: '',
    nombre: 'Las Palmas',
  },
  {
    codCiudad: 2613,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'Las Palmas',
  },
  {
    codCiudad: 2569,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'Las Palmas',
  },
  {
    codCiudad: 1544,
    codPcia: 13,
    CP: 2326,
    letra: '',
    nombre: 'LAS PALMERAS',
  },
  {
    codCiudad: 527,
    codPcia: 13,
    CP: 2505,
    letra: '',
    nombre: 'LAS PAREJAS',
  },
  {
    codCiudad: 917,
    codPcia: 4,
    CP: 5238,
    letra: '',
    nombre: 'LAS PE',
  },
  {
    codCiudad: 1043,
    codPcia: 4,
    CP: 5921,
    letra: '',
    nombre: 'LAS PERDICES',
  },
  {
    codCiudad: 1513,
    codPcia: 4,
    CP: 5921,
    letra: '',
    nombre: 'LAS PERDICES',
  },
  {
    codCiudad: 940,
    codPcia: 8,
    CP: 5301,
    letra: '',
    nombre: 'LAS PEÑAS',
  },
  {
    codCiudad: 1831,
    codPcia: 10,
    CP: 4190,
    letra: '',
    nombre: 'Las Piedritas',
  },
  {
    codCiudad: 2246,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'Las Pircas',
  },
  {
    codCiudad: 2644,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Las Puertas',
  },
  {
    codCiudad: 2017,
    codPcia: 10,
    CP: 4405,
    letra: '',
    nombre: 'Las Rosas',
  },
  {
    codCiudad: 888,
    codPcia: 4,
    CP: 5131,
    letra: '',
    nombre: 'LAS ROSAS',
  },
  {
    codCiudad: 531,
    codPcia: 13,
    CP: 2520,
    letra: '',
    nombre: 'LAS ROSAS',
  },
  {
    codCiudad: 1866,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'Las Saladas',
  },
  {
    codCiudad: 927,
    codPcia: 4,
    CP: 5281,
    letra: '',
    nombre: 'LAS TAPIAS',
  },
  {
    codCiudad: 1376,
    codPcia: 4,
    CP: 5885,
    letra: '',
    nombre: 'LAS TAPIAS - SAN JAVIER',
  },
  {
    codCiudad: 2247,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'Las Tienditas',
  },
  {
    codCiudad: 2614,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'Las Tortugas',
  },
  {
    codCiudad: 1320,
    codPcia: 2,
    CP: 6453,
    letra: '',
    nombre: 'LAS TOSCAS',
  },
  {
    codCiudad: 767,
    codPcia: 13,
    CP: 3586,
    letra: '',
    nombre: 'LAS TOSCAS',
  },
  {
    codCiudad: 2173,
    codPcia: 10,
    CP: 4417,
    letra: '',
    nombre: 'Las Trancas',
  },
  {
    codCiudad: 1748,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Las Tres Marias',
  },
  {
    codCiudad: 3132,
    codPcia: 13,
    CP: 3009,
    letra: '',
    nombre: 'LAS TUNAS',
  },
  {
    codCiudad: 1867,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'Las Tunillas',
  },
  {
    codCiudad: 1051,
    codPcia: 4,
    CP: 5941,
    letra: '',
    nombre: 'LAS VARAS',
  },
  {
    codCiudad: 2748,
    codPcia: 10,
    CP: 4534,
    letra: '',
    nombre: 'Las Varas',
  },
  {
    codCiudad: 1050,
    codPcia: 4,
    CP: 5940,
    letra: '',
    nombre: 'LAS VARILLAS',
  },
  {
    codCiudad: 1269,
    codPcia: 4,
    CP: 4912,
    letra: '',
    nombre: 'LAS VARILLAS',
  },
  {
    codCiudad: 2615,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'Las Vateas',
  },
  {
    codCiudad: 2468,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'Las Viboras',
  },
  {
    codCiudad: 2353,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'Las Viqas',
  },
  {
    codCiudad: 2135,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Las Zanjas',
  },
  {
    codCiudad: 797,
    codPcia: 3,
    CP: 4111,
    letra: '',
    nombre: 'LASTENIA',
  },
  {
    codCiudad: 1338,
    codPcia: 9,
    CP: 5533,
    letra: '',
    nombre: 'LAVALLE',
  },
  {
    codCiudad: 3195,
    codPcia: 5,
    CP: 3777,
    letra: '',
    nombre: 'LAVALLE',
  },
  {
    codCiudad: 1678,
    codPcia: 13,
    CP: 6103,
    letra: '',
    nombre: 'LAZZARINO',
  },
  {
    codCiudad: 798,
    codPcia: 3,
    CP: 4113,
    letra: '',
    nombre: 'LEALES',
  },
  {
    codCiudad: 1070,
    codPcia: 2,
    CP: 6032,
    letra: '',
    nombre: 'LEANDRO N ALEM',
  },
  {
    codCiudad: 2469,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'Lechiguana',
  },
  {
    codCiudad: 558,
    codPcia: 4,
    CP: 2594,
    letra: '',
    nombre: 'LEONES',
  },
  {
    codCiudad: 1960,
    codPcia: 10,
    CP: 4401,
    letra: '',
    nombre: 'Lesser',
  },
  {
    codCiudad: 857,
    codPcia: 7,
    CP: 4512,
    letra: '',
    nombre: 'LIB GRAL SAN MARTIN',
  },
  {
    codCiudad: 1313,
    codPcia: 2,
    CP: 7407,
    letra: '',
    nombre: 'LÍBANO',
  },
  {
    codCiudad: 340,
    codPcia: 2,
    CP: 1716,
    letra: '',
    nombre: 'LIBERTAD',
  },
  {
    codCiudad: 1681,
    codPcia: 5,
    CP: 3197,
    letra: '',
    nombre: 'LIBERTADOR',
  },
  {
    codCiudad: 622,
    codPcia: 2,
    CP: 2806,
    letra: '',
    nombre: 'LIMA',
  },
  {
    codCiudad: 1943,
    codPcia: 10,
    CP: 4400,
    letra: '',
    nombre: 'Limache',
  },
  {
    codCiudad: 2570,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'Limoncito',
  },
  {
    codCiudad: 1074,
    codPcia: 2,
    CP: 6070,
    letra: '',
    nombre: 'LINCOLN',
  },
  {
    codCiudad: 3046,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'Lipeo',
  },
  {
    codCiudad: 3164,
    codPcia: 13,
    CP: 3036,
    letra: '',
    nombre: 'LLAMBI CAMPBELL',
  },
  {
    codCiudad: 3010,
    codPcia: 10,
    CP: 4644,
    letra: '',
    nombre: 'Llameria',
  },
  {
    codCiudad: 384,
    codPcia: 2,
    CP: 1836,
    letra: '',
    nombre: 'LLAVALLOL',
  },
  {
    codCiudad: 2645,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Llucha',
  },
  {
    codCiudad: 3011,
    codPcia: 10,
    CP: 4644,
    letra: '',
    nombre: 'Llulluchayoc',
  },
  {
    codCiudad: 1189,
    codPcia: 2,
    CP: 7635,
    letra: '',
    nombre: 'LOBERIA',
  },
  {
    codCiudad: 1163,
    codPcia: 2,
    CP: 7240,
    letra: '',
    nombre: 'LOBOS',
  },
  {
    codCiudad: 1493,
    codPcia: 8,
    CP: 5381,
    letra: '',
    nombre: 'LOMA BLANCA - GENERAL BELGRANO',
  },
  {
    codCiudad: 1807,
    codPcia: 10,
    CP: 4141,
    letra: '',
    nombre: 'Loma Colorada',
  },
  {
    codCiudad: 2136,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Loma De Burro',
  },
  {
    codCiudad: 1180,
    codPcia: 2,
    CP: 7521,
    letra: '',
    nombre: 'LOMA DEL INDIO',
  },
  {
    codCiudad: 1426,
    codPcia: 2,
    CP: 1657,
    letra: '',
    nombre: 'Loma Hermosa',
  },
  {
    codCiudad: 1679,
    codPcia: 2,
    CP: 1628,
    letra: '',
    nombre: 'LOMA VERDE',
  },
  {
    codCiudad: 1904,
    codPcia: 10,
    CP: 4197,
    letra: '',
    nombre: 'Lomas Blancas',
  },
  {
    codCiudad: 2700,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'Lomas De Olmedo',
  },
  {
    codCiudad: 382,
    codPcia: 2,
    CP: 1832,
    letra: '',
    nombre: 'LOMAS DE ZAMORA',
  },
  {
    codCiudad: 351,
    codPcia: 1,
    CP: 1752,
    letra: '',
    nombre: 'LOMAS DEL MIRADOR',
  },
  {
    codCiudad: 732,
    codPcia: 5,
    CP: 3420,
    letra: '',
    nombre: 'LOMAS SALADAS',
  },
  {
    codCiudad: 1504,
    codPcia: 21,
    CP: 8349,
    letra: '',
    nombre: 'LONCOPUE',
  },
  {
    codCiudad: 391,
    codPcia: 2,
    CP: 1854,
    letra: '',
    nombre: 'LONGCHAMPS',
  },
  {
    codCiudad: 498,
    codPcia: 13,
    CP: 2255,
    letra: '',
    nombre: 'LOPEZ',
  },
  {
    codCiudad: 1299,
    codPcia: 5,
    CP: 3483,
    letra: '',
    nombre: 'LORETO',
  },
  {
    codCiudad: 1310,
    codPcia: 0,
    CP: 0,
    letra: '',
    nombre: 'LORETO',
  },
  {
    codCiudad: 3178,
    codPcia: 14,
    CP: 4208,
    letra: '',
    nombre: 'LORETO',
  },
  {
    codCiudad: 2337,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'Lorohuasi',
  },
  {
    codCiudad: 2354,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'Los Alamos',
  },
  {
    codCiudad: 1961,
    codPcia: 10,
    CP: 4401,
    letra: '',
    nombre: 'Los Alamos',
  },
  {
    codCiudad: 1988,
    codPcia: 10,
    CP: 4403,
    letra: '',
    nombre: 'Los Alamos',
  },
  {
    codCiudad: 1503,
    codPcia: 23,
    CP: 9041,
    letra: '',
    nombre: 'LOS ANTIGUOS',
  },
  {
    codCiudad: 2825,
    codPcia: 10,
    CP: 4550,
    letra: '',
    nombre: 'Los Baldes',
  },
  {
    codCiudad: 1868,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'Los Baños',
  },
  {
    codCiudad: 2495,
    codPcia: 10,
    CP: 4440,
    letra: '',
    nombre: 'Los Baqados',
  },
  {
    codCiudad: 2885,
    codPcia: 10,
    CP: 4555,
    letra: '',
    nombre: 'Los Blancos',
  },
  {
    codCiudad: 2966,
    codPcia: 10,
    CP: 4600,
    letra: '',
    nombre: 'Los Blancos',
  },
  {
    codCiudad: 1891,
    codPcia: 10,
    CP: 4195,
    letra: '',
    nombre: 'Los Canteros',
  },
  {
    codCiudad: 624,
    codPcia: 2,
    CP: 2814,
    letra: '',
    nombre: 'LOS CARDALES',
  },
  {
    codCiudad: 538,
    codPcia: 13,
    CP: 2533,
    letra: '',
    nombre: 'LOS CARDOS',
  },
  {
    codCiudad: 2320,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'Los Castillos',
  },
  {
    codCiudad: 1749,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Los Chaguancos',
  },
  {
    codCiudad: 3122,
    codPcia: 6,
    CP: 3212,
    letra: '',
    nombre: 'LOS CHARRUAS',
  },
  {
    codCiudad: 2616,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'Los Chifles',
  },
  {
    codCiudad: 2321,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'Los Churquis',
  },
  {
    codCiudad: 1918,
    codPcia: 10,
    CP: 4198,
    letra: '',
    nombre: 'Los Churquis',
  },
  {
    codCiudad: 1456,
    codPcia: 4,
    CP: 2684,
    letra: '',
    nombre: 'LOS CISNES',
  },
  {
    codCiudad: 1250,
    codPcia: 4,
    CP: 5182,
    letra: '',
    nombre: 'LOS COCOS',
  },
  {
    codCiudad: 2097,
    codPcia: 10,
    CP: 4413,
    letra: '',
    nombre: 'Los Colorados',
  },
  {
    codCiudad: 2646,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Los Colorados',
  },
  {
    codCiudad: 1015,
    codPcia: 4,
    CP: 5823,
    letra: '',
    nombre: 'LOS CONDORES',
  },
  {
    codCiudad: 1718,
    codPcia: 6,
    CP: 3183,
    letra: '',
    nombre: 'LOS CONQUISTADORES',
  },
  {
    codCiudad: 2470,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'Los Corrales',
  },
  {
    codCiudad: 1450,
    codPcia: 16,
    CP: 3712,
    letra: '',
    nombre: 'LOS FRENTONES',
  },
  {
    codCiudad: 596,
    codPcia: 2,
    CP: 2709,
    letra: '',
    nombre: 'LOS INDIOS',
  },
  {
    codCiudad: 790,
    codPcia: 14,
    CP: 3773,
    letra: '',
    nombre: 'LOS JURIES',
  },
  {
    codCiudad: 2137,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Los Laureles',
  },
  {
    codCiudad: 2282,
    codPcia: 10,
    CP: 4423,
    letra: '',
    nombre: 'Los Los',
  },
  {
    codCiudad: 1642,
    codPcia: 22,
    CP: 8424,
    letra: '',
    nombre: 'LOS MENUCOS',
  },
  {
    codCiudad: 1962,
    codPcia: 10,
    CP: 4401,
    letra: '',
    nombre: 'Los Mercados',
  },
  {
    codCiudad: 914,
    codPcia: 4,
    CP: 5229,
    letra: '',
    nombre: 'LOS MISTOLES',
  },
  {
    codCiudad: 939,
    codPcia: 8,
    CP: 5301,
    letra: '',
    nombre: 'LOS MOLINOS',
  },
  {
    codCiudad: 475,
    codPcia: 13,
    CP: 2181,
    letra: '',
    nombre: 'LOS MOLINOS',
  },
  {
    codCiudad: 1691,
    codPcia: 12,
    CP: 5883,
    letra: '',
    nombre: 'LOS MOLLES',
  },
  {
    codCiudad: 2571,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'Los Mollinedos',
  },
  {
    codCiudad: 2471,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'Los Nogales',
  },
  {
    codCiudad: 1944,
    codPcia: 10,
    CP: 4400,
    letra: '',
    nombre: 'Los Noques',
  },
  {
    codCiudad: 2066,
    codPcia: 10,
    CP: 4411,
    letra: '',
    nombre: 'Los Patos',
  },
  {
    codCiudad: 291,
    codPcia: 2,
    CP: 1613,
    letra: '',
    nombre: 'LOS POLVORINES',
  },
  {
    codCiudad: 831,
    codPcia: 14,
    CP: 4201,
    letra: '',
    nombre: 'LOS QUIROGA',
  },
  {
    codCiudad: 577,
    codPcia: 13,
    CP: 2637,
    letra: '',
    nombre: 'LOS QUIRQUINCHOS',
  },
  {
    codCiudad: 825,
    codPcia: 3,
    CP: 4182,
    letra: '',
    nombre: 'LOS RALOS',
  },
  {
    codCiudad: 2861,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Los Ranchillos',
  },
  {
    codCiudad: 1869,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'Los Rosales',
  },
  {
    codCiudad: 2542,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'Los Rosales',
  },
  {
    codCiudad: 2355,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'Los Sauces',
  },
  {
    codCiudad: 2322,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'Los Sauces',
  },
  {
    codCiudad: 1963,
    codPcia: 10,
    CP: 4401,
    letra: '',
    nombre: 'Los Sauces',
  },
  {
    codCiudad: 552,
    codPcia: 4,
    CP: 2581,
    letra: '',
    nombre: 'LOS SURGENTES',
  },
  {
    codCiudad: 3088,
    codPcia: 10,
    CP: 5233,
    letra: '',
    nombre: 'Los Tajamares',
  },
  {
    codCiudad: 1709,
    codPcia: 10,
    CP: 4531,
    letra: '',
    nombre: 'Los Toldos',
  },
  {
    codCiudad: 1332,
    codPcia: 2,
    CP: 6015,
    letra: '',
    nombre: 'LOS TOLDOS',
  },
  {
    codCiudad: 1919,
    codPcia: 10,
    CP: 4198,
    letra: '',
    nombre: 'Los Zanjones',
  },
  {
    codCiudad: 2901,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'Lote 27',
  },
  {
    codCiudad: 2736,
    codPcia: 10,
    CP: 4533,
    letra: '',
    nombre: 'Lote Estela',
  },
  {
    codCiudad: 2701,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'Lote Josefina',
  },
  {
    codCiudad: 2702,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'Lote Lucrecia',
  },
  {
    codCiudad: 2703,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'Lote Marcela',
  },
  {
    codCiudad: 1750,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Lote Nro 8',
  },
  {
    codCiudad: 2704,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'Lote Sarita',
  },
  {
    codCiudad: 1273,
    codPcia: 6,
    CP: 3158,
    letra: '',
    nombre: 'LUCAS GONZALEZ',
  },
  {
    codCiudad: 458,
    codPcia: 13,
    CP: 2142,
    letra: '',
    nombre: 'LUCIO V LOPEZ',
  },
  {
    codCiudad: 1356,
    codPcia: 18,
    CP: 3526,
    letra: '',
    nombre: 'LUCIO V. MANSILLA',
  },
  {
    codCiudad: 1460,
    codPcia: 22,
    CP: 8361,
    letra: '',
    nombre: 'LUIS BELTRAN',
  },
  {
    codCiudad: 2617,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'Luis Burela',
  },
  {
    codCiudad: 385,
    codPcia: 2,
    CP: 1838,
    letra: '',
    nombre: 'LUIS GUILLON',
  },
  {
    codCiudad: 508,
    codPcia: 13,
    CP: 2326,
    letra: '',
    nombre: 'LUIS PALACIOS',
  },
  {
    codCiudad: 1129,
    codPcia: 2,
    CP: 6700,
    letra: '',
    nombre: 'LUJAN',
  },
  {
    codCiudad: 1693,
    codPcia: 14,
    CP: 4328,
    letra: '',
    nombre: 'LUJAN',
  },
  {
    codCiudad: 963,
    codPcia: 9,
    CP: 5507,
    letra: '',
    nombre: 'LUJAN DE CUYO',
  },
  {
    codCiudad: 802,
    codPcia: 3,
    CP: 4128,
    letra: '',
    nombre: 'LULES',
  },
  {
    codCiudad: 2472,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'Lumbreras',
  },
  {
    codCiudad: 2862,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Luna Muerta',
  },
  {
    codCiudad: 1056,
    codPcia: 4,
    CP: 5967,
    letra: '',
    nombre: 'LUQUE',
  },
  {
    codCiudad: 2204,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'Luracatao',
  },
  {
    codCiudad: 965,
    codPcia: 9,
    CP: 5513,
    letra: '',
    nombre: 'LUZURIAGA',
  },
  {
    codCiudad: 642,
    codPcia: 2,
    CP: 2931,
    letra: '',
    nombre: 'M. M. GUEMES - LA MA',
  },
  {
    codCiudad: 1093,
    codPcia: 19,
    CP: 6307,
    letra: '',
    nombre: 'MACACHIN',
  },
  {
    codCiudad: 2647,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Macapillo',
  },
  {
    codCiudad: 1334,
    codPcia: 16,
    CP: 3534,
    letra: '',
    nombre: 'MACHAGAI',
  },
  {
    codCiudad: 945,
    codPcia: 8,
    CP: 5311,
    letra: '',
    nombre: 'MACHIGASTA',
  },
  {
    codCiudad: 1808,
    codPcia: 10,
    CP: 4141,
    letra: '',
    nombre: 'Macho Rastrojo',
  },
  {
    codCiudad: 1516,
    codPcia: 6,
    CP: 3177,
    letra: '',
    nombre: 'MACIA',
  },
  {
    codCiudad: 485,
    codPcia: 13,
    CP: 2208,
    letra: '',
    nombre: 'MACIEL',
  },
  {
    codCiudad: 1085,
    codPcia: 4,
    CP: 6140,
    letra: '',
    nombre: 'MACKENA',
  },
  {
    codCiudad: 2954,
    codPcia: 10,
    CP: 4566,
    letra: '',
    nombre: 'Macueta',
  },
  {
    codCiudad: 1870,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'Madariaga',
  },
  {
    codCiudad: 2391,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'Madre Vieja',
  },
  {
    codCiudad: 2863,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Madrejon',
  },
  {
    codCiudad: 415,
    codPcia: 2,
    CP: 1913,
    letra: '',
    nombre: 'MAGDALENA',
  },
  {
    codCiudad: 569,
    codPcia: 13,
    CP: 2622,
    letra: '',
    nombre: 'MAGGIOLO',
  },
  {
    codCiudad: 3197,
    codPcia: 7,
    CP: 4622,
    letra: '',
    nombre: 'MAIMARA',
  },
  {
    codCiudad: 1535,
    codPcia: 22,
    CP: 8326,
    letra: '',
    nombre: 'MAINQUE',
  },
  {
    codCiudad: 1719,
    codPcia: 2,
    CP: 7160,
    letra: '',
    nombre: 'MAIPU',
  },
  {
    codCiudad: 966,
    codPcia: 9,
    CP: 5515,
    letra: '',
    nombre: 'MAIPU',
  },
  {
    codCiudad: 1231,
    codPcia: 16,
    CP: 3514,
    letra: '',
    nombre: 'MAKALLE',
  },
  {
    codCiudad: 2138,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Mal Cante',
  },
  {
    codCiudad: 2139,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Mal Paso',
  },
  {
    codCiudad: 764,
    codPcia: 13,
    CP: 3572,
    letra: '',
    nombre: 'MALABRIGO',
  },
  {
    codCiudad: 875,
    codPcia: 4,
    CP: 5101,
    letra: '',
    nombre: 'MALAGUE',
  },
  {
    codCiudad: 1367,
    codPcia: 4,
    CP: 5101,
    letra: '',
    nombre: 'MALAGUEÑO',
  },
  {
    codCiudad: 989,
    codPcia: 9,
    CP: 5613,
    letra: '',
    nombre: 'MALARGUE',
  },
  {
    codCiudad: 510,
    codPcia: 14,
    CP: 2354,
    letra: '',
    nombre: 'MALBRAN',
  },
  {
    codCiudad: 1279,
    codPcia: 4,
    CP: 5125,
    letra: '',
    nombre: 'MALVINAS ARGENTINAS',
  },
  {
    codCiudad: 1809,
    codPcia: 10,
    CP: 4141,
    letra: '',
    nombre: 'Managua',
  },
  {
    codCiudad: 794,
    codPcia: 3,
    CP: 4105,
    letra: '',
    nombre: 'MANANTIAL',
  },
  {
    codCiudad: 3206,
    codPcia: 4,
    CP: 5988,
    letra: '',
    nombre: 'MANFREDI',
  },
  {
    codCiudad: 2648,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Manga Vieja',
  },
  {
    codCiudad: 2826,
    codPcia: 10,
    CP: 4550,
    letra: '',
    nombre: 'Manuel Elordi',
  },
  {
    codCiudad: 1406,
    codPcia: 2,
    CP: 7116,
    letra: '',
    nombre: 'MANUEL JOSE COBO',
  },
  {
    codCiudad: 598,
    codPcia: 2,
    CP: 2713,
    letra: '',
    nombre: 'MANUEL OCAMPO',
  },
  {
    codCiudad: 2902,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'Manuela Pedraza',
  },
  {
    codCiudad: 1610,
    codPcia: 22,
    CP: 8422,
    letra: '',
    nombre: 'MAQUINCHAO',
  },
  {
    codCiudad: 1405,
    codPcia: 2,
    CP: 7609,
    letra: '',
    nombre: 'MAR CHIQUITA',
  },
  {
    codCiudad: 1150,
    codPcia: 2,
    CP: 7109,
    letra: '',
    nombre: 'MAR DE AJO',
  },
  {
    codCiudad: 1183,
    codPcia: 2,
    CP: 7600,
    letra: '',
    nombre: 'MAR DEL PLATA',
  },
  {
    codCiudad: 1149,
    codPcia: 2,
    CP: 7108,
    letra: '',
    nombre: 'MAR DEL TUYU',
  },
  {
    codCiudad: 551,
    codPcia: 4,
    CP: 2580,
    letra: '',
    nombre: 'MARCOS JUAREZ',
  },
  {
    codCiudad: 344,
    codPcia: 2,
    CP: 1727,
    letra: '',
    nombre: 'MARCOS PAZ',
  },
  {
    codCiudad: 1354,
    codPcia: 16,
    CP: 3505,
    letra: '',
    nombre: 'MARGARITA BELEN',
  },
  {
    codCiudad: 1751,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Maria Cristina',
  },
  {
    codCiudad: 1577,
    codPcia: 6,
    CP: 3133,
    letra: '',
    nombre: 'MARÍA GRANDE',
  },
  {
    codCiudad: 1614,
    codPcia: 2,
    CP: 7003,
    letra: '',
    nombre: 'MARIA IGNACIA',
  },
  {
    codCiudad: 2705,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'Maria Jose',
  },
  {
    codCiudad: 517,
    codPcia: 13,
    CP: 2445,
    letra: '',
    nombre: 'MARIA JUANA',
  },
  {
    codCiudad: 2737,
    codPcia: 10,
    CP: 4533,
    letra: '',
    nombre: 'Maria Luisa',
  },
  {
    codCiudad: 535,
    codPcia: 13,
    CP: 2527,
    letra: '',
    nombre: 'MARIA SUSANA',
  },
  {
    codCiudad: 564,
    codPcia: 13,
    CP: 2609,
    letra: '',
    nombre: 'MARIA TERESA',
  },
  {
    codCiudad: 343,
    codPcia: 2,
    CP: 1723,
    letra: '',
    nombre: 'MARIANO ACOSTA',
  },
  {
    codCiudad: 592,
    codPcia: 4,
    CP: 2701,
    letra: '',
    nombre: 'MARIANO BENITEZ',
  },
  {
    codCiudad: 1359,
    codPcia: 2,
    CP: 2718,
    letra: '',
    nombre: 'MARIANO H. ALFONZO',
  },
  {
    codCiudad: 1390,
    codPcia: 11,
    CP: 5407,
    letra: '',
    nombre: 'MARQUESADO',
  },
  {
    codCiudad: 1439,
    codPcia: 2,
    CP: 3260,
    letra: '',
    nombre: 'MARTIN CORONADO',
  },
  {
    codCiudad: 1443,
    codPcia: 2,
    CP: 1682,
    letra: '',
    nombre: 'MARTIN CORONADO',
  },
  {
    codCiudad: 329,
    codPcia: 2,
    CP: 1682,
    letra: '',
    nombre: 'MARTIN CORONADO',
  },
  {
    codCiudad: 2776,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'Martin Garcia',
  },
  {
    codCiudad: 306,
    codPcia: 2,
    CP: 1640,
    letra: '',
    nombre: 'MARTINEZ',
  },
  {
    codCiudad: 2803,
    codPcia: 10,
    CP: 4537,
    letra: '',
    nombre: 'Martinez Del Tinco',
  },
  {
    codCiudad: 2804,
    codPcia: 10,
    CP: 4537,
    letra: '',
    nombre: 'Martinez Del Tineo',
  },
  {
    codCiudad: 1607,
    codPcia: 19,
    CP: 2335,
    letra: '',
    nombre: 'MARUJA',
  },
  {
    codCiudad: 1905,
    codPcia: 10,
    CP: 4197,
    letra: '',
    nombre: 'Masumpa',
  },
  {
    codCiudad: 2981,
    codPcia: 10,
    CP: 4633,
    letra: '',
    nombre: 'Matansillas',
  },
  {
    codCiudad: 299,
    codPcia: 2,
    CP: 1627,
    letra: '',
    nombre: 'MATHEU',
  },
  {
    codCiudad: 3201,
    codPcia: 4,
    CP: 5965,
    letra: '',
    nombre: 'MATORRALES',
  },
  {
    codCiudad: 1357,
    codPcia: 4,
    CP: 6271,
    letra: '',
    nombre: 'MATTALDI',
  },
  {
    codCiudad: 436,
    codPcia: 13,
    CP: 2115,
    letra: '',
    nombre: 'MAXIMO PAZ',
  },
  {
    codCiudad: 3012,
    codPcia: 10,
    CP: 4644,
    letra: '',
    nombre: 'Mayilte',
  },
  {
    codCiudad: 1964,
    codPcia: 10,
    CP: 4401,
    letra: '',
    nombre: 'Mayo Torito',
  },
  {
    codCiudad: 1195,
    codPcia: 2,
    CP: 8146,
    letra: '',
    nombre: 'MAYOR BURATOVICH',
  },
  {
    codCiudad: 1488,
    codPcia: 2,
    CP: 8146,
    letra: '',
    nombre: 'MAYOR BURATOVICH',
  },
  {
    codCiudad: 733,
    codPcia: 5,
    CP: 3427,
    letra: '',
    nombre: 'MBURUCUYA',
  },
  {
    codCiudad: 1126,
    codPcia: 2,
    CP: 6648,
    letra: '',
    nombre: 'MECHITA',
  },
  {
    codCiudad: 3047,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'Mecoyita',
  },
  {
    codCiudad: 3121,
    codPcia: 6,
    CP: 2848,
    letra: '',
    nombre: 'MEDANOS',
  },
  {
    codCiudad: 2018,
    codPcia: 10,
    CP: 4405,
    letra: '',
    nombre: 'Media Luna',
  },
  {
    codCiudad: 1752,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Media Luna',
  },
  {
    codCiudad: 2618,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'Media Luna',
  },
  {
    codCiudad: 2777,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'Media Luna',
  },
  {
    codCiudad: 1229,
    codPcia: 4,
    CP: 5107,
    letra: '',
    nombre: 'MEDIOLAZA',
  },
  {
    codCiudad: 608,
    codPcia: 13,
    CP: 2728,
    letra: '',
    nombre: 'MELINCUE',
  },
  {
    codCiudad: 1388,
    codPcia: 4,
    CP: 6123,
    letra: '',
    nombre: 'MELO',
  },
  {
    codCiudad: 959,
    codPcia: 9,
    CP: 5500,
    letra: '',
    nombre: 'MENDOZA',
  },
  {
    codCiudad: 2019,
    codPcia: 10,
    CP: 4405,
    letra: '',
    nombre: 'Merced De Arriba',
  },
  {
    codCiudad: 1113,
    codPcia: 2,
    CP: 6600,
    letra: '',
    nombre: 'MERCEDES',
  },
  {
    codCiudad: 739,
    codPcia: 5,
    CP: 3470,
    letra: '',
    nombre: 'MERCEDES',
  },
  {
    codCiudad: 1927,
    codPcia: 10,
    CP: 4200,
    letra: '',
    nombre: 'Mercedes',
  },
  {
    codCiudad: 2649,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Mercedes',
  },
  {
    codCiudad: 1032,
    codPcia: 12,
    CP: 5881,
    letra: '',
    nombre: 'MERLO',
  },
  {
    codCiudad: 1272,
    codPcia: 2,
    CP: 1722,
    letra: '',
    nombre: 'MERLO',
  },
  {
    codCiudad: 342,
    codPcia: 2,
    CP: 1722,
    letra: '',
    nombre: 'MERLO',
  },
  {
    codCiudad: 2051,
    codPcia: 10,
    CP: 4409,
    letra: '',
    nombre: 'Meseta',
  },
  {
    codCiudad: 3048,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'Meson',
  },
  {
    codCiudad: 853,
    codPcia: 10,
    CP: 4440,
    letra: '',
    nombre: 'METAN',
  },
  {
    codCiudad: 2509,
    codPcia: 10,
    CP: 4441,
    letra: '',
    nombre: 'Metan Viejo',
  },
  {
    codCiudad: 784,
    codPcia: 16,
    CP: 3731,
    letra: '',
    nombre: 'MEZON DE FIERRO',
  },
  {
    codCiudad: 3013,
    codPcia: 10,
    CP: 4644,
    letra: '',
    nombre: 'Mina Belgica',
  },
  {
    codCiudad: 2052,
    codPcia: 10,
    CP: 4409,
    letra: '',
    nombre: 'Mina Carolina',
  },
  {
    codCiudad: 1034,
    codPcia: 4,
    CP: 5889,
    letra: '',
    nombre: 'MINA CLAVERO',
  },
  {
    codCiudad: 2323,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'Mina Don Otto',
  },
  {
    codCiudad: 2067,
    codPcia: 10,
    CP: 4411,
    letra: '',
    nombre: 'Mina Julio',
  },
  {
    codCiudad: 2140,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Mina San Esteban',
  },
  {
    codCiudad: 2141,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Mina San Guillermo',
  },
  {
    codCiudad: 2142,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Mina San Walterio',
  },
  {
    codCiudad: 3014,
    codPcia: 10,
    CP: 4644,
    letra: '',
    nombre: 'Mina Sol De Mayo',
  },
  {
    codCiudad: 2098,
    codPcia: 10,
    CP: 4413,
    letra: '',
    nombre: 'Mina Tincalaya',
  },
  {
    codCiudad: 2143,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Minas Victoria',
  },
  {
    codCiudad: 2706,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'Minas Ypf',
  },
  {
    codCiudad: 2572,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'Minas Ypf',
  },
  {
    codCiudad: 2473,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'Miraflores',
  },
  {
    codCiudad: 2573,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'Miraflores',
  },
  {
    codCiudad: 1563,
    codPcia: 16,
    CP: 3705,
    letra: '',
    nombre: 'MIRAFLORES',
  },
  {
    codCiudad: 1787,
    codPcia: 10,
    CP: 4126,
    letra: '',
    nombre: 'Miraflores',
  },
  {
    codCiudad: 2521,
    codPcia: 10,
    CP: 4444,
    letra: '',
    nombre: 'Miraflores M',
  },
  {
    codCiudad: 1185,
    codPcia: 2,
    CP: 7607,
    letra: '',
    nombre: 'MIRAMAR',
  },
  {
    codCiudad: 2864,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Mision Chaqueqa',
  },
  {
    codCiudad: 2707,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'Mision Franciscana',
  },
  {
    codCiudad: 2903,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'Mision Franciscana',
  },
  {
    codCiudad: 2929,
    codPcia: 10,
    CP: 4561,
    letra: '',
    nombre: 'Mision La Paz',
  },
  {
    codCiudad: 1696,
    codPcia: 18,
    CP: 3601,
    letra: '',
    nombre: 'MISION LAISHI',
  },
  {
    codCiudad: 2930,
    codPcia: 10,
    CP: 4561,
    letra: '',
    nombre: 'Mision Santa Lucia',
  },
  {
    codCiudad: 2865,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Misiones',
  },
  {
    codCiudad: 1753,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Mistol Marcado',
  },
  {
    codCiudad: 2866,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Mistol Mareado',
  },
  {
    codCiudad: 2867,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Mistolar',
  },
  {
    codCiudad: 2650,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Mistolito',
  },
  {
    codCiudad: 1336,
    codPcia: 5,
    CP: 3226,
    letra: '',
    nombre: 'MOCORETA',
  },
  {
    codCiudad: 507,
    codPcia: 13,
    CP: 2313,
    letra: '',
    nombre: 'MOISESVILLE',
  },
  {
    codCiudad: 3183,
    codPcia: 6,
    CP: 3241,
    letra: '',
    nombre: 'MOJONES NORTE',
  },
  {
    codCiudad: 3200,
    codPcia: 6,
    CP: 3241,
    letra: '',
    nombre: 'MOJONES SUR',
  },
  {
    codCiudad: 2430,
    codPcia: 10,
    CP: 4432,
    letra: '',
    nombre: 'Mojotoro',
  },
  {
    codCiudad: 2283,
    codPcia: 10,
    CP: 4423,
    letra: '',
    nombre: 'Molino',
  },
  {
    codCiudad: 3015,
    codPcia: 10,
    CP: 4644,
    letra: '',
    nombre: 'Molino',
  },
  {
    codCiudad: 2144,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Molino De Gongora',
  },
  {
    codCiudad: 2216,
    codPcia: 10,
    CP: 4420,
    letra: '',
    nombre: 'Molinos',
  },
  {
    codCiudad: 1507,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'MOLINOS',
  },
  {
    codCiudad: 3016,
    codPcia: 10,
    CP: 4644,
    letra: '',
    nombre: 'Mollar',
  },
  {
    codCiudad: 2543,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'Molle Pozo',
  },
  {
    codCiudad: 2778,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'Mollinedo',
  },
  {
    codCiudad: 2619,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'Monasterios',
  },
  {
    codCiudad: 1101,
    codPcia: 2,
    CP: 6469,
    letra: '',
    nombre: 'MONES CAZON',
  },
  {
    codCiudad: 486,
    codPcia: 13,
    CP: 2212,
    letra: '',
    nombre: 'MONJE',
  },
  {
    codCiudad: 1162,
    codPcia: 2,
    CP: 7220,
    letra: '',
    nombre: 'MONTE',
  },
  {
    codCiudad: 1965,
    codPcia: 10,
    CP: 4401,
    letra: '',
    nombre: 'Monte',
  },
  {
    codCiudad: 870,
    codPcia: 4,
    CP: 5008,
    letra: '',
    nombre: 'MONTE * CORDOBA',
  },
  {
    codCiudad: 556,
    codPcia: 4,
    CP: 2589,
    letra: '',
    nombre: 'MONTE BUEY',
  },
  {
    codCiudad: 2868,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Monte Carmelo',
  },
  {
    codCiudad: 1305,
    codPcia: 5,
    CP: 3220,
    letra: '',
    nombre: 'MONTE CASEROS',
  },
  {
    codCiudad: 379,
    codPcia: 2,
    CP: 1825,
    letra: '',
    nombre: 'MONTE CHINGOLO',
  },
  {
    codCiudad: 3185,
    codPcia: 4,
    CP: 5839,
    letra: '',
    nombre: 'MONTE DE LOS GAUCHOS',
  },
  {
    codCiudad: 386,
    codPcia: 2,
    CP: 1842,
    letra: '',
    nombre: 'MONTE GRANDE',
  },
  {
    codCiudad: 2205,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'Monte Grande',
  },
  {
    codCiudad: 1196,
    codPcia: 2,
    CP: 8153,
    letra: '',
    nombre: 'MONTE HERMOSO',
  },
  {
    codCiudad: 1370,
    codPcia: 4,
    CP: 2564,
    letra: '',
    nombre: 'MONTE LEÑA',
  },
  {
    codCiudad: 3163,
    codPcia: 18,
    CP: 3600,
    letra: '',
    nombre: 'MONTE LINDO',
  },
  {
    codCiudad: 585,
    codPcia: 4,
    CP: 2659,
    letra: '',
    nombre: 'MONTE MAIZ',
  },
  {
    codCiudad: 780,
    codPcia: 14,
    CP: 3714,
    letra: '',
    nombre: 'Monte Quemado',
  },
  {
    codCiudad: 1892,
    codPcia: 10,
    CP: 4195,
    letra: '',
    nombre: 'Monte Quemado',
  },
  {
    codCiudad: 1288,
    codPcia: 4,
    CP: 5118,
    letra: '',
    nombre: 'MONTE RALO',
  },
  {
    codCiudad: 1592,
    codPcia: 13,
    CP: 3014,
    letra: '',
    nombre: 'MONTE VERA',
  },
  {
    codCiudad: 2356,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'Monte Viejo',
  },
  {
    codCiudad: 886,
    codPcia: 4,
    CP: 5125,
    letra: '',
    nombre: 'MONTECRISTO',
  },
  {
    codCiudad: 806,
    codPcia: 3,
    CP: 4142,
    letra: '',
    nombre: 'MONTEROS',
  },
  {
    codCiudad: 3145,
    codPcia: 4,
    CP: 2421,
    letra: '',
    nombre: 'MONTEROS',
  },
  {
    codCiudad: 532,
    codPcia: 13,
    CP: 2521,
    letra: '',
    nombre: 'MONTES DE OCA',
  },
  {
    codCiudad: 2324,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'Morales',
  },
  {
    codCiudad: 2688,
    codPcia: 10,
    CP: 4500,
    letra: '',
    nombre: 'Moralito',
  },
  {
    codCiudad: 1401,
    codPcia: 2,
    CP: 6507,
    letra: '',
    nombre: 'MOREA',
  },
  {
    codCiudad: 1871,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'Morenillo',
  },
  {
    codCiudad: 348,
    codPcia: 2,
    CP: 1744,
    letra: '',
    nombre: 'MORENO',
  },
  {
    codCiudad: 2869,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Morillo',
  },
  {
    codCiudad: 337,
    codPcia: 2,
    CP: 1708,
    letra: '',
    nombre: 'MORON',
  },
  {
    codCiudad: 584,
    codPcia: 4,
    CP: 2658,
    letra: '',
    nombre: 'MORRISON',
  },
  {
    codCiudad: 549,
    codPcia: 4,
    CP: 2568,
    letra: '',
    nombre: 'MORRISON',
  },
  {
    codCiudad: 1335,
    codPcia: 2,
    CP: 6013,
    letra: '',
    nombre: 'MORSE',
  },
  {
    codCiudad: 516,
    codPcia: 4,
    CP: 2421,
    letra: '',
    nombre: 'MORTEROS',
  },
  {
    codCiudad: 3111,
    codPcia: 6,
    CP: 3191,
    letra: '',
    nombre: 'MUNICIPIO DE SAN GUSTAVO',
  },
  {
    codCiudad: 560,
    codPcia: 13,
    CP: 2601,
    letra: '',
    nombre: 'MURPHY',
  },
  {
    codCiudad: 2651,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'N Sra De Talavera',
  },
  {
    codCiudad: 1477,
    codPcia: 17,
    CP: 9200,
    letra: '',
    nombre: 'NAHUELPAN',
  },
  {
    codCiudad: 1578,
    codPcia: 13,
    CP: 3046,
    letra: '',
    nombre: 'NARÉ',
  },
  {
    codCiudad: 1114,
    codPcia: 2,
    CP: 6605,
    letra: '',
    nombre: 'NAVARRO',
  },
  {
    codCiudad: 3049,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'Nazareno',
  },
  {
    codCiudad: 1188,
    codPcia: 2,
    CP: 7630,
    letra: '',
    nombre: 'NECOCHEA',
  },
  {
    codCiudad: 667,
    codPcia: 13,
    CP: 3032,
    letra: '',
    nombre: 'NELSON',
  },
  {
    codCiudad: 1199,
    codPcia: 21,
    CP: 8300,
    letra: '',
    nombre: 'NEUQUEN',
  },
  {
    codCiudad: 1570,
    codPcia: 4,
    CP: 6271,
    letra: '',
    nombre: 'NICOLAS BRUZONE',
  },
  {
    codCiudad: 546,
    codPcia: 4,
    CP: 2563,
    letra: '',
    nombre: 'NOETINGER',
  },
  {
    codCiudad: 2496,
    codPcia: 10,
    CP: 4440,
    letra: '',
    nombre: 'Nogalito',
  },
  {
    codCiudad: 698,
    codPcia: 6,
    CP: 3150,
    letra: '',
    nombre: 'NOGOYA',
  },
  {
    codCiudad: 2676,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Nuestra Señora De Talavera',
  },
  {
    codCiudad: 977,
    codPcia: 9,
    CP: 5535,
    letra: '',
    nombre: 'NUEVA CALIFORNIA',
  },
  {
    codCiudad: 1103,
    codPcia: 2,
    CP: 6500,
    letra: '',
    nombre: 'NUEVE DE JULIO',
  },
  {
    codCiudad: 2827,
    codPcia: 10,
    CP: 4550,
    letra: '',
    nombre: 'Nuevo Porvenir',
  },
  {
    codCiudad: 1143,
    codPcia: 2,
    CP: 6748,
    letra: '',
    nombre: "O'HIGGINS",
  },
  {
    codCiudad: 718,
    codPcia: 20,
    CP: 3360,
    letra: '',
    nombre: 'OBERA',
  },
  {
    codCiudad: 1669,
    codPcia: 4,
    CP: 5225,
    letra: '',
    nombre: 'OBISPO TREJO',
  },
  {
    codCiudad: 2392,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'Ojo De Agua',
  },
  {
    codCiudad: 1832,
    codPcia: 10,
    CP: 4190,
    letra: '',
    nombre: 'Ojo De Agua',
  },
  {
    codCiudad: 2145,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Ojo De Agua',
  },
  {
    codCiudad: 3126,
    codPcia: 14,
    CP: 4302,
    letra: '',
    nombre: 'OJOS DE AGUA',
  },
  {
    codCiudad: 2099,
    codPcia: 10,
    CP: 4413,
    letra: '',
    nombre: 'Olacapanto Chico',
  },
  {
    codCiudad: 2100,
    codPcia: 10,
    CP: 4413,
    letra: '',
    nombre: 'Olacapanto Grande',
  },
  {
    codCiudad: 1174,
    codPcia: 2,
    CP: 7400,
    letra: '',
    nombre: 'OLAVARRIA',
  },
  {
    codCiudad: 3137,
    codPcia: 20,
    CP: 3311,
    letra: '',
    nombre: 'OLEGARIO ANDRADE',
  },
  {
    codCiudad: 1059,
    codPcia: 4,
    CP: 5980,
    letra: '',
    nombre: 'OLIVA',
  },
  {
    codCiudad: 1116,
    codPcia: 2,
    CP: 6608,
    letra: '',
    nombre: 'OLIVERA',
  },
  {
    codCiudad: 484,
    codPcia: 13,
    CP: 2206,
    letra: '',
    nombre: 'OLIVEROS',
  },
  {
    codCiudad: 304,
    codPcia: 2,
    CP: 1636,
    letra: '',
    nombre: 'OLIVOS',
  },
  {
    codCiudad: 1989,
    codPcia: 10,
    CP: 4403,
    letra: '',
    nombre: 'Olmos',
  },
  {
    codCiudad: 1061,
    codPcia: 4,
    CP: 5986,
    letra: '',
    nombre: 'ONCATIVO',
  },
  {
    codCiudad: 1134,
    codPcia: 2,
    CP: 6708,
    letra: '',
    nombre: 'OPEN DOOR',
  },
  {
    codCiudad: 859,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'ORAN',
  },
  {
    codCiudad: 1224,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'ORÁN',
  },
  {
    codCiudad: 2708,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'Oran',
  },
  {
    codCiudad: 542,
    codPcia: 4,
    CP: 2555,
    letra: '',
    nombre: 'ORDOÑEZ',
  },
  {
    codCiudad: 3076,
    codPcia: 10,
    CP: 4653,
    letra: '',
    nombre: 'Ornillo',
  },
  {
    codCiudad: 2248,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'Osma',
  },
  {
    codCiudad: 1446,
    codPcia: 2,
    CP: 7167,
    letra: '',
    nombre: 'OSTENDE',
  },
  {
    codCiudad: 2828,
    codPcia: 10,
    CP: 4550,
    letra: '',
    nombre: 'Otomana',
  },
  {
    codCiudad: 1833,
    codPcia: 10,
    CP: 4190,
    letra: '',
    nombre: 'Ovando',
  },
  {
    codCiudad: 1920,
    codPcia: 10,
    CP: 4198,
    letra: '',
    nombre: 'Ovejeria',
  },
  {
    codCiudad: 2522,
    codPcia: 10,
    CP: 4444,
    letra: '',
    nombre: 'Ovejeria',
  },
  {
    codCiudad: 2544,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'P De Las Carretas',
  },
  {
    codCiudad: 2068,
    codPcia: 10,
    CP: 4411,
    letra: '',
    nombre: 'P De Poyogasta',
  },
  {
    codCiudad: 2779,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'P El Milagro Sani',
  },
  {
    codCiudad: 2069,
    codPcia: 10,
    CP: 4411,
    letra: '',
    nombre: 'P Esq De Guardia',
  },
  {
    codCiudad: 2070,
    codPcia: 10,
    CP: 4411,
    letra: '',
    nombre: 'P Mina Concordia',
  },
  {
    codCiudad: 2071,
    codPcia: 10,
    CP: 4411,
    letra: '',
    nombre: 'P Morro Colorado',
  },
  {
    codCiudad: 2072,
    codPcia: 10,
    CP: 4411,
    letra: '',
    nombre: 'P Pastos Grandes',
  },
  {
    codCiudad: 2958,
    codPcia: 10,
    CP: 4568,
    letra: '',
    nombre: 'P S Mazza E Pocito',
  },
  {
    codCiudad: 753,
    codPcia: 16,
    CP: 3536,
    letra: '',
    nombre: 'P. DE LA PLAZA',
  },
  {
    codCiudad: 2709,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'P. Del Potrillo',
  },
  {
    codCiudad: 318,
    codPcia: 2,
    CP: 1657,
    letra: '',
    nombre: 'PABLO PODESTA',
  },
  {
    codCiudad: 804,
    codPcia: 3,
    CP: 4133,
    letra: '',
    nombre: 'PADILLA',
  },
  {
    codCiudad: 3017,
    codPcia: 10,
    CP: 4644,
    letra: '',
    nombre: 'Pairique Chico',
  },
  {
    codCiudad: 3143,
    codPcia: 13,
    CP: 2326,
    letra: '',
    nombre: 'PALACIOS',
  },
  {
    codCiudad: 2620,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'Palermo',
  },
  {
    codCiudad: 2146,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Palermo Oeste',
  },
  {
    codCiudad: 2621,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'Palma',
  },
  {
    codCiudad: 1754,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Palmar Largo',
  },
  {
    codCiudad: 1755,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Palmarcito',
  },
  {
    codCiudad: 2780,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'Palmarcito',
  },
  {
    codCiudad: 984,
    codPcia: 9,
    CP: 5584,
    letra: '',
    nombre: 'PALMIRA',
  },
  {
    codCiudad: 2284,
    codPcia: 10,
    CP: 4423,
    letra: '',
    nombre: 'Palmira',
  },
  {
    codCiudad: 2622,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'Palo A Pique',
  },
  {
    codCiudad: 3117,
    codPcia: 14,
    CP: 2354,
    letra: '',
    nombre: 'PALO NEGRO',
  },
  {
    codCiudad: 2357,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'Palo Pintado',
  },
  {
    codCiudad: 2870,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Palo Santo',
  },
  {
    codCiudad: 1233,
    codPcia: 18,
    CP: 3608,
    letra: '',
    nombre: 'PALO SANTO',
  },
  {
    codCiudad: 1834,
    codPcia: 10,
    CP: 4190,
    letra: '',
    nombre: 'Palomar',
  },
  {
    codCiudad: 2474,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'Palomitas',
  },
  {
    codCiudad: 779,
    codPcia: 14,
    CP: 3712,
    letra: '',
    nombre: 'PAMPA DE LOS GUANACOS',
  },
  {
    codCiudad: 994,
    codPcia: 12,
    CP: 5701,
    letra: '',
    nombre: 'PAMPA DE TAMBORERO',
  },
  {
    codCiudad: 1444,
    codPcia: 16,
    CP: 3531,
    letra: '',
    nombre: 'PAMPA DEL INDIO',
  },
  {
    codCiudad: 1340,
    codPcia: 16,
    CP: 3708,
    letra: '',
    nombre: 'PAMPA DEL INFIERNO',
  },
  {
    codCiudad: 2325,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'Pampa Grande',
  },
  {
    codCiudad: 3184,
    codPcia: 14,
    CP: 4351,
    letra: '',
    nombre: 'PAMPA MUYOJ',
  },
  {
    codCiudad: 3050,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'Papa Chacra',
  },
  {
    codCiudad: 1580,
    codPcia: 12,
    CP: 5883,
    letra: '',
    nombre: 'PAPAGAYOS',
  },
  {
    codCiudad: 995,
    codPcia: 12,
    CP: 5703,
    letra: '',
    nombre: 'PARAISO',
  },
  {
    codCiudad: 2781,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'Paraiso',
  },
  {
    codCiudad: 2904,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'Paraje Campo Largo',
  },
  {
    codCiudad: 2073,
    codPcia: 10,
    CP: 4411,
    letra: '',
    nombre: 'Paraje Cerro Negro',
  },
  {
    codCiudad: 2074,
    codPcia: 10,
    CP: 4411,
    letra: '',
    nombre: 'Paraje Cobres',
  },
  {
    codCiudad: 2075,
    codPcia: 10,
    CP: 4411,
    letra: '',
    nombre: 'Paraje Cortaderas',
  },
  {
    codCiudad: 1658,
    codPcia: 14,
    CP: 4313,
    letra: '',
    nombre: 'PARAJE LAGUNA BLANCA',
  },
  {
    codCiudad: 2076,
    codPcia: 10,
    CP: 4411,
    letra: '',
    nombre: 'Paraje Las Cuevas',
  },
  {
    codCiudad: 2077,
    codPcia: 10,
    CP: 4411,
    letra: '',
    nombre: 'Paraje Nacimientos',
  },
  {
    codCiudad: 2101,
    codPcia: 10,
    CP: 4413,
    letra: '',
    nombre: 'Paraje Olacapato',
  },
  {
    codCiudad: 2078,
    codPcia: 10,
    CP: 4411,
    letra: '',
    nombre: 'Paraje Pircas',
  },
  {
    codCiudad: 2079,
    codPcia: 10,
    CP: 4411,
    letra: '',
    nombre: 'Paraje Pizcuno',
  },
  {
    codCiudad: 1714,
    codPcia: 20,
    CP: 3355,
    letra: '',
    nombre: 'PARAJE SAN ISIDRO',
  },
  {
    codCiudad: 597,
    codPcia: 2,
    CP: 2711,
    letra: '',
    nombre: 'PARAJE STA ROSA',
  },
  {
    codCiudad: 2080,
    codPcia: 10,
    CP: 4411,
    letra: '',
    nombre: 'Paraje Uncuru',
  },
  {
    codCiudad: 1990,
    codPcia: 10,
    CP: 4403,
    letra: '',
    nombre: 'Paraje Zanjon',
  },
  {
    codCiudad: 2393,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'Paramamaya',
  },
  {
    codCiudad: 976,
    codPcia: 9,
    CP: 5533,
    letra: '',
    nombre: 'PARAMILLO',
  },
  {
    codCiudad: 688,
    codPcia: 6,
    CP: 3100,
    letra: '',
    nombre: 'PARANA',
  },
  {
    codCiudad: 1966,
    codPcia: 10,
    CP: 4401,
    letra: '',
    nombre: 'Paredes',
  },
  {
    codCiudad: 1445,
    codPcia: 2,
    CP: 1664,
    letra: '',
    nombre: 'PARQUE TRUJUI',
  },
  {
    codCiudad: 3077,
    codPcia: 10,
    CP: 4653,
    letra: '',
    nombre: 'Pasajes',
  },
  {
    codCiudad: 3051,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'Pascalla',
  },
  {
    codCiudad: 2020,
    codPcia: 10,
    CP: 4405,
    letra: '',
    nombre: 'Pascha',
  },
  {
    codCiudad: 1461,
    codPcia: 4,
    CP: 5925,
    letra: '',
    nombre: 'PASCO',
  },
  {
    codCiudad: 2497,
    codPcia: 10,
    CP: 4440,
    letra: '',
    nombre: 'Paso De Baderrana',
  },
  {
    codCiudad: 1416,
    codPcia: 17,
    CP: 9207,
    letra: '',
    nombre: 'PASO DE INDIOS',
  },
  {
    codCiudad: 2475,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'Paso De La Cruz',
  },
  {
    codCiudad: 725,
    codPcia: 5,
    CP: 3409,
    letra: '',
    nombre: 'PASO DE LA PATRIA',
  },
  {
    codCiudad: 709,
    codPcia: 5,
    CP: 3230,
    letra: '',
    nombre: 'PASO DE LOS LIBRES',
  },
  {
    codCiudad: 2498,
    codPcia: 10,
    CP: 4440,
    letra: '',
    nombre: 'Paso Del Durazno',
  },
  {
    codCiudad: 347,
    codPcia: 2,
    CP: 1742,
    letra: '',
    nombre: 'PASO DEL REY',
  },
  {
    codCiudad: 2249,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'Paso Del Rio',
  },
  {
    codCiudad: 1404,
    codPcia: 17,
    CP: 9201,
    letra: '',
    nombre: 'PASO DEL SAPO',
  },
  {
    codCiudad: 704,
    codPcia: 6,
    CP: 3192,
    letra: '',
    nombre: 'PASO GARIBALDI',
  },
  {
    codCiudad: 2545,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'Paso La Cruz',
  },
  {
    codCiudad: 1921,
    codPcia: 10,
    CP: 4198,
    letra: '',
    nombre: 'Paso Verde',
  },
  {
    codCiudad: 2499,
    codPcia: 10,
    CP: 4440,
    letra: '',
    nombre: 'Pasteadero',
  },
  {
    codCiudad: 3078,
    codPcia: 10,
    CP: 4653,
    letra: '',
    nombre: 'Pasto Pampa',
  },
  {
    codCiudad: 2836,
    codPcia: 10,
    CP: 4552,
    letra: '',
    nombre: 'Pastor Sevillosa',
  },
  {
    codCiudad: 1421,
    codPcia: 8,
    CP: 5386,
    letra: '',
    nombre: 'PATQUIA',
  },
  {
    codCiudad: 636,
    codPcia: 13,
    CP: 2918,
    letra: '',
    nombre: 'PAVON',
  },
  {
    codCiudad: 1397,
    codPcia: 2,
    CP: 2812,
    letra: '',
    nombre: 'PAVÓN - GENERAL LAVALLE',
  },
  {
    codCiudad: 432,
    codPcia: 13,
    CP: 2109,
    letra: '',
    nombre: 'PAVON ARRIBA',
  },
  {
    codCiudad: 2179,
    codPcia: 10,
    CP: 4418,
    letra: '',
    nombre: 'Payogasta',
  },
  {
    codCiudad: 2147,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Payogasta',
  },
  {
    codCiudad: 2358,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'Payogastilla',
  },
  {
    codCiudad: 2285,
    codPcia: 10,
    CP: 4423,
    letra: '',
    nombre: 'Pedregal',
  },
  {
    codCiudad: 2871,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Pedro Lozano',
  },
  {
    codCiudad: 1100,
    codPcia: 2,
    CP: 6450,
    letra: '',
    nombre: 'PEHUAJO',
  },
  {
    codCiudad: 1096,
    codPcia: 2,
    CP: 6346,
    letra: '',
    nombre: 'PELLEGRINI',
  },
  {
    codCiudad: 442,
    codPcia: 13,
    CP: 2121,
    letra: '',
    nombre: 'PEREZ',
  },
  {
    codCiudad: 512,
    codPcia: 13,
    CP: 2365,
    letra: '',
    nombre: 'PEREZ',
  },
  {
    codCiudad: 643,
    codPcia: 2,
    CP: 2933,
    letra: '',
    nombre: 'PEREZ MILLAN',
  },
  {
    codCiudad: 591,
    codPcia: 2,
    CP: 2700,
    letra: '',
    nombre: 'PERGAMINO',
  },
  {
    codCiudad: 2500,
    codPcia: 10,
    CP: 4440,
    letra: '',
    nombre: 'Peru',
  },
  {
    codCiudad: 434,
    codPcia: 13,
    CP: 2113,
    letra: '',
    nombre: 'PEYRANO',
  },
  {
    codCiudad: 536,
    codPcia: 13,
    CP: 2529,
    letra: '',
    nombre: 'PIAMONTE',
  },
  {
    codCiudad: 1704,
    codPcia: 10,
    CP: 4534,
    letra: '',
    nombre: 'PICHANAL',
  },
  {
    codCiudad: 1259,
    codPcia: 23,
    CP: 0,
    letra: '',
    nombre: 'PICO TRUNCADO',
  },
  {
    codCiudad: 2652,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Picos De Amor',
  },
  {
    codCiudad: 2653,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Picos De Arroz',
  },
  {
    codCiudad: 1545,
    codPcia: 21,
    CP: 8313,
    letra: '',
    nombre: 'PICUN LEUFU',
  },
  {
    codCiudad: 2148,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Pie De La Cuesta',
  },
  {
    codCiudad: 2021,
    codPcia: 10,
    CP: 4405,
    letra: '',
    nombre: 'Pie De La Cuesta',
  },
  {
    codCiudad: 1991,
    codPcia: 10,
    CP: 4403,
    letra: '',
    nombre: 'Piedemonte',
  },
  {
    codCiudad: 1712,
    codPcia: 3,
    CP: 4709,
    letra: '',
    nombre: 'PIEDRA BLANCA',
  },
  {
    codCiudad: 1487,
    codPcia: 21,
    CP: 8315,
    letra: '',
    nombre: 'PIEDRA DEL AGUILA',
  },
  {
    codCiudad: 2250,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'Piedra Del Molino',
  },
  {
    codCiudad: 2251,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'Piedras Moradas',
  },
  {
    codCiudad: 1197,
    codPcia: 2,
    CP: 8170,
    letra: '',
    nombre: 'PIGUE',
  },
  {
    codCiudad: 1153,
    codPcia: 2,
    CP: 7116,
    letra: '',
    nombre: 'PILA',
  },
  {
    codCiudad: 1057,
    codPcia: 4,
    CP: 5972,
    letra: '',
    nombre: 'PILAR',
  },
  {
    codCiudad: 687,
    codPcia: 13,
    CP: 3085,
    letra: '',
    nombre: 'PILAR',
  },
  {
    codCiudad: 300,
    codPcia: 2,
    CP: 1629,
    letra: '',
    nombre: 'PILAR',
  },
  {
    codCiudad: 1506,
    codPcia: 22,
    CP: 8412,
    letra: '',
    nombre: 'PILCANIYEU',
  },
  {
    codCiudad: 2982,
    codPcia: 10,
    CP: 4633,
    letra: '',
    nombre: 'Pinal',
  },
  {
    codCiudad: 1158,
    codPcia: 2,
    CP: 7167,
    letra: '',
    nombre: 'PINAMAR',
  },
  {
    codCiudad: 937,
    codPcia: 8,
    CP: 5301,
    letra: '',
    nombre: 'PINCHAS',
  },
  {
    codCiudad: 511,
    codPcia: 14,
    CP: 2356,
    letra: '',
    nombre: 'PINTO',
  },
  {
    codCiudad: 593,
    codPcia: 2,
    CP: 2703,
    letra: '',
    nombre: 'PINZON',
  },
  {
    codCiudad: 417,
    codPcia: 2,
    CP: 1921,
    letra: '',
    nombre: 'PIPINAS',
  },
  {
    codCiudad: 2623,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'Piquete Cabado',
  },
  {
    codCiudad: 2574,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'Piquete De Anta',
  },
  {
    codCiudad: 2476,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'Piquete De Anta',
  },
  {
    codCiudad: 2948,
    codPcia: 10,
    CP: 4564,
    letra: '',
    nombre: 'Piquirenda',
  },
  {
    codCiudad: 770,
    codPcia: 18,
    CP: 3606,
    letra: '',
    nombre: 'PIRANE',
  },
  {
    codCiudad: 3052,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'Piscuno',
  },
  {
    codCiudad: 2149,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Piul',
  },
  {
    codCiudad: 2749,
    codPcia: 10,
    CP: 4534,
    letra: '',
    nombre: 'Pizarro',
  },
  {
    codCiudad: 440,
    codPcia: 13,
    CP: 2119,
    letra: '',
    nombre: 'PI¥ERO',
  },
  {
    codCiudad: 2654,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Platero',
  },
  {
    codCiudad: 1151,
    codPcia: 2,
    CP: 7111,
    letra: '',
    nombre: 'PLAYA SAN BERNARDO',
  },
  {
    codCiudad: 1247,
    codPcia: 21,
    CP: 8318,
    letra: '',
    nombre: 'PLAZA HUINCUL',
  },
  {
    codCiudad: 1440,
    codPcia: 21,
    CP: 8316,
    letra: '',
    nombre: 'PLOTTIER',
  },
  {
    codCiudad: 2872,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Pluma De Pato',
  },
  {
    codCiudad: 2873,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Pluma Del Pato',
  },
  {
    codCiudad: 2905,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'Pluma Del Pato',
  },
  {
    codCiudad: 2523,
    codPcia: 10,
    CP: 4444,
    letra: '',
    nombre: 'Pob. De Ortega',
  },
  {
    codCiudad: 2575,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'Poblacion',
  },
  {
    codCiudad: 2546,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'Poblacion',
  },
  {
    codCiudad: 1628,
    codPcia: 11,
    CP: 5427,
    letra: '',
    nombre: 'POCITO ABERASTAIN',
  },
  {
    codCiudad: 956,
    codPcia: 11,
    CP: 5429,
    letra: '',
    nombre: 'POCITO LA RINCONADA',
  },
  {
    codCiudad: 2959,
    codPcia: 10,
    CP: 4568,
    letra: '',
    nombre: 'Pocitos',
  },
  {
    codCiudad: 2837,
    codPcia: 10,
    CP: 4552,
    letra: '',
    nombre: 'Pocoy',
  },
  {
    codCiudad: 1169,
    codPcia: 2,
    CP: 7267,
    letra: '',
    nombre: 'POLVAREDAS - PDO DE',
  },
  {
    codCiudad: 1206,
    codPcia: 22,
    CP: 8363,
    letra: '',
    nombre: 'POMONA',
  },
  {
    codCiudad: 2150,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Pompeya',
  },
  {
    codCiudad: 358,
    codPcia: 2,
    CP: 1761,
    letra: '',
    nombre: 'PONTEVEDRA',
  },
  {
    codCiudad: 2782,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'Porongal',
  },
  {
    codCiudad: 1651,
    codPcia: 4,
    CP: 2415,
    letra: '',
    nombre: 'PORTEÑA',
  },
  {
    codCiudad: 3140,
    codPcia: 13,
    CP: 3071,
    letra: '',
    nombre: 'PORTUGALETE',
  },
  {
    codCiudad: 714,
    codPcia: 20,
    CP: 3300,
    letra: '',
    nombre: 'POSADAS',
  },
  {
    codCiudad: 3053,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'Poscaya',
  },
  {
    codCiudad: 2576,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'Poso De Algarrobo',
  },
  {
    codCiudad: 1967,
    codPcia: 10,
    CP: 4401,
    letra: '',
    nombre: 'Pot De Castilla',
  },
  {
    codCiudad: 1835,
    codPcia: 10,
    CP: 4190,
    letra: '',
    nombre: 'Potrerillo',
  },
  {
    codCiudad: 2547,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'Potrerillo',
  },
  {
    codCiudad: 1788,
    codPcia: 10,
    CP: 4126,
    letra: '',
    nombre: 'Potrerillos',
  },
  {
    codCiudad: 2081,
    codPcia: 10,
    CP: 4411,
    letra: '',
    nombre: 'Potrerillos',
  },
  {
    codCiudad: 2326,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'Potrerillos',
  },
  {
    codCiudad: 2548,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'Potrero',
  },
  {
    codCiudad: 2151,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Potrero',
  },
  {
    codCiudad: 1893,
    codPcia: 10,
    CP: 4195,
    letra: '',
    nombre: 'Potrero',
  },
  {
    codCiudad: 3033,
    codPcia: 10,
    CP: 4650,
    letra: '',
    nombre: 'Potrero',
  },
  {
    codCiudad: 2286,
    codPcia: 10,
    CP: 4423,
    letra: '',
    nombre: 'Potrero De Diaz',
  },
  {
    codCiudad: 1316,
    codPcia: 4,
    CP: 5189,
    letra: '',
    nombre: 'POTRERO DE GARAY',
  },
  {
    codCiudad: 2029,
    codPcia: 10,
    CP: 4407,
    letra: '',
    nombre: 'Potrero De Linares',
  },
  {
    codCiudad: 2030,
    codPcia: 10,
    CP: 4407,
    letra: '',
    nombre: 'Potrero De Uriburu',
  },
  {
    codCiudad: 1177,
    codPcia: 2,
    CP: 7404,
    letra: '',
    nombre: 'POURTALE',
  },
  {
    codCiudad: 2710,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'Pozo Azul',
  },
  {
    codCiudad: 2906,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'Pozo Bermejo',
  },
  {
    codCiudad: 1872,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'Pozo Blanco',
  },
  {
    codCiudad: 2874,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Pozo Bravo',
  },
  {
    codCiudad: 2577,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'Pozo Cantado',
  },
  {
    codCiudad: 2783,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'Pozo Cercado',
  },
  {
    codCiudad: 1756,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Pozo Cercado',
  },
  {
    codCiudad: 2711,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'Pozo De La Piedra',
  },
  {
    codCiudad: 1757,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Pozo De La Yegua',
  },
  {
    codCiudad: 2875,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Pozo Del Chaqar',
  },
  {
    codCiudad: 2876,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Pozo Del Cuico',
  },
  {
    codCiudad: 2578,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'Pozo Del Greal',
  },
  {
    codCiudad: 1758,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Pozo Del Maza',
  },
  {
    codCiudad: 1327,
    codPcia: 4,
    CP: 5913,
    letra: '',
    nombre: 'POZO DEL MOLLE',
  },
  {
    codCiudad: 2784,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'Pozo Del Pato',
  },
  {
    codCiudad: 2785,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'Pozo Del Sauce',
  },
  {
    codCiudad: 788,
    codPcia: 14,
    CP: 3741,
    letra: '',
    nombre: 'POZO DEL TOBA',
  },
  {
    codCiudad: 2786,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'Pozo Del Zorro',
  },
  {
    codCiudad: 2394,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'Pozo El Algarrobo',
  },
  {
    codCiudad: 2624,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'Pozo Grande',
  },
  {
    codCiudad: 1894,
    codPcia: 10,
    CP: 4195,
    letra: '',
    nombre: 'Pozo Grande',
  },
  {
    codCiudad: 2877,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Pozo Hondo',
  },
  {
    codCiudad: 1895,
    codPcia: 10,
    CP: 4195,
    letra: '',
    nombre: 'Pozo Largo',
  },
  {
    codCiudad: 1337,
    codPcia: 4,
    CP: 5209,
    letra: '',
    nombre: 'POZO NUEVO',
  },
  {
    codCiudad: 2712,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'Pozo Pringles',
  },
  {
    codCiudad: 2787,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'Pozo Verde',
  },
  {
    codCiudad: 2625,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'Pozo Verde',
  },
  {
    codCiudad: 1922,
    codPcia: 10,
    CP: 4198,
    letra: '',
    nombre: 'Pozos Largos',
  },
  {
    codCiudad: 2549,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'Pringles',
  },
  {
    codCiudad: 664,
    codPcia: 13,
    CP: 3023,
    letra: '',
    nombre: 'PROGRESO',
  },
  {
    codCiudad: 303,
    codPcia: 2,
    CP: 1635,
    letra: '',
    nombre: 'PTE DERQUI',
  },
  {
    codCiudad: 1215,
    codPcia: 17,
    CP: 9120,
    letra: '',
    nombre: 'PTO MADRYN',
  },
  {
    codCiudad: 2359,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'Pucara',
  },
  {
    codCiudad: 3169,
    codPcia: 6,
    CP: 3125,
    letra: '',
    nombre: 'PUEBLO BRUGO',
  },
  {
    codCiudad: 451,
    codPcia: 13,
    CP: 2126,
    letra: '',
    nombre: 'PUEBLO ESTHER',
  },
  {
    codCiudad: 1591,
    codPcia: 6,
    CP: 2821,
    letra: '',
    nombre: 'PUEBLO GENERAL BELGRANO',
  },
  {
    codCiudad: 1418,
    codPcia: 4,
    CP: 2651,
    letra: '',
    nombre: 'PUEBLO ITALIANO',
  },
  {
    codCiudad: 1432,
    codPcia: 4,
    CP: 2651,
    letra: '',
    nombre: 'PUEBLO ITALIANO',
  },
  {
    codCiudad: 713,
    codPcia: 6,
    CP: 3281,
    letra: '',
    nombre: 'PUEBLO LIEBIG',
  },
  {
    codCiudad: 438,
    codPcia: 13,
    CP: 2119,
    letra: '',
    nombre: 'PUEBLO MU|OZ',
  },
  {
    codCiudad: 2152,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Pueblo Nuevo',
  },
  {
    codCiudad: 2153,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Pueblo Viejo',
  },
  {
    codCiudad: 2174,
    codPcia: 10,
    CP: 4417,
    letra: '',
    nombre: 'Pueblo Viejo',
  },
  {
    codCiudad: 2983,
    codPcia: 10,
    CP: 4633,
    letra: '',
    nombre: 'Pueblo Viejo',
  },
  {
    codCiudad: 1587,
    codPcia: 19,
    CP: 8307,
    letra: '',
    nombre: 'PUELEN',
  },
  {
    codCiudad: 2252,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'Puente De Diaz',
  },
  {
    codCiudad: 1873,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'Puente De Plata',
  },
  {
    codCiudad: 2579,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'Puerta Blanca',
  },
  {
    codCiudad: 1810,
    codPcia: 10,
    CP: 4141,
    letra: '',
    nombre: 'Puerta De Julipao',
  },
  {
    codCiudad: 2175,
    codPcia: 10,
    CP: 4417,
    letra: '',
    nombre: 'Puerta De La Paya',
  },
  {
    codCiudad: 2053,
    codPcia: 10,
    CP: 4409,
    letra: '',
    nombre: 'Puerta De Tastil',
  },
  {
    codCiudad: 2838,
    codPcia: 10,
    CP: 4552,
    letra: '',
    nombre: 'Puerto Baules',
  },
  {
    codCiudad: 3177,
    codPcia: 6,
    CP: 3113,
    letra: '',
    nombre: 'PUERTO CURTIEMBRE',
  },
  {
    codCiudad: 2374,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'Puerto De Diaz',
  },
  {
    codCiudad: 1260,
    codPcia: 23,
    CP: 0,
    letra: '',
    nombre: 'PUERTO DESEADO',
  },
  {
    codCiudad: 3106,
    codPcia: 13,
    CP: 2208,
    letra: '',
    nombre: 'Puerto Gaboto',
  },
  {
    codCiudad: 720,
    codPcia: 20,
    CP: 3370,
    letra: '',
    nombre: 'PUERTO IGUAZU',
  },
  {
    codCiudad: 2931,
    codPcia: 10,
    CP: 4561,
    letra: '',
    nombre: 'Puerto La Paz',
  },
  {
    codCiudad: 722,
    codPcia: 20,
    CP: 3381,
    letra: '',
    nombre: 'PUERTO PIRAI',
  },
  {
    codCiudad: 1281,
    codPcia: 20,
    CP: 3334,
    letra: '',
    nombre: 'PUERTO RICO',
  },
  {
    codCiudad: 1261,
    codPcia: 23,
    CP: 0,
    letra: '',
    nombre: 'PUERTO SAN JULIAN',
  },
  {
    codCiudad: 719,
    codPcia: 20,
    CP: 3363,
    letra: '',
    nombre: 'PUERTO SAN MARTIN',
  },
  {
    codCiudad: 482,
    codPcia: 13,
    CP: 2202,
    letra: '',
    nombre: 'PUERTO SAN MARTIN',
  },
  {
    codCiudad: 1262,
    codPcia: 23,
    CP: 0,
    letra: '',
    nombre: 'PUERTO SANTA CRUZ',
  },
  {
    codCiudad: 745,
    codPcia: 16,
    CP: 3505,
    letra: '',
    nombre: 'PUERTO TIROL',
  },
  {
    codCiudad: 1589,
    codPcia: 6,
    CP: 3127,
    letra: '',
    nombre: 'PUERTO VIBORAS',
  },
  {
    codCiudad: 744,
    codPcia: 16,
    CP: 3503,
    letra: '',
    nombre: 'PUERTO VILELAS',
  },
  {
    codCiudad: 1759,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Puerto Yrigoyen',
  },
  {
    codCiudad: 3054,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'Puesto',
  },
  {
    codCiudad: 3089,
    codPcia: 10,
    CP: 5233,
    letra: '',
    nombre: 'Puesto De Castro',
  },
  {
    codCiudad: 1811,
    codPcia: 10,
    CP: 4141,
    letra: '',
    nombre: 'Puesto De Julipao',
  },
  {
    codCiudad: 2788,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'Puesto De La Viuda',
  },
  {
    codCiudad: 2713,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'Puesto De Motijo',
  },
  {
    codCiudad: 3018,
    codPcia: 10,
    CP: 4644,
    letra: '',
    nombre: 'Puesto Del Marquez',
  },
  {
    codCiudad: 2750,
    codPcia: 10,
    CP: 4534,
    letra: '',
    nombre: 'Puesto Del Medio',
  },
  {
    codCiudad: 1928,
    codPcia: 10,
    CP: 4200,
    letra: '',
    nombre: 'Puesto Del Medio',
  },
  {
    codCiudad: 2878,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Puesto Del Paquelo',
  },
  {
    codCiudad: 3101,
    codPcia: 10,
    CP: 5236,
    letra: '',
    nombre: 'Puesto Del Rosario',
  },
  {
    codCiudad: 3079,
    codPcia: 10,
    CP: 4653,
    letra: '',
    nombre: 'Puesto Grande',
  },
  {
    codCiudad: 2829,
    codPcia: 10,
    CP: 4550,
    letra: '',
    nombre: 'Puesto Grande',
  },
  {
    codCiudad: 2395,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'Puesto Viejo',
  },
  {
    codCiudad: 690,
    codPcia: 6,
    CP: 3103,
    letra: '',
    nombre: 'PUIGGARI',
  },
  {
    codCiudad: 2176,
    codPcia: 10,
    CP: 4417,
    letra: '',
    nombre: 'Puil',
  },
  {
    codCiudad: 443,
    codPcia: 13,
    CP: 2122,
    letra: '',
    nombre: 'PUJATO',
  },
  {
    codCiudad: 2287,
    codPcia: 10,
    CP: 4423,
    letra: '',
    nombre: 'Pulares',
  },
  {
    codCiudad: 2550,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'Puli',
  },
  {
    codCiudad: 3019,
    codPcia: 10,
    CP: 4644,
    letra: '',
    nombre: 'Pumahuasi',
  },
  {
    codCiudad: 3055,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'Punca Viscana',
  },
  {
    codCiudad: 3056,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'Punco Viscana',
  },
  {
    codCiudad: 1193,
    codPcia: 2,
    CP: 8109,
    letra: '',
    nombre: 'PUNTA ALTA',
  },
  {
    codCiudad: 3020,
    codPcia: 10,
    CP: 4644,
    letra: '',
    nombre: 'Punta De Agua',
  },
  {
    codCiudad: 2154,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Punta De Agua',
  },
  {
    codCiudad: 2501,
    codPcia: 10,
    CP: 4440,
    letra: '',
    nombre: 'Punta Del Agua',
  },
  {
    codCiudad: 991,
    codPcia: 9,
    CP: 5621,
    letra: '',
    nombre: 'PUNTA DEL AGUA',
  },
  {
    codCiudad: 1760,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Pzo D Ls Chanchos',
  },
  {
    codCiudad: 1761,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Pzo Vrde  I G N Ju',
  },
  {
    codCiudad: 2580,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'Quebrachal',
  },
  {
    codCiudad: 1896,
    codPcia: 10,
    CP: 4195,
    letra: '',
    nombre: 'Quebracho Coto',
  },
  {
    codCiudad: 2102,
    codPcia: 10,
    CP: 4413,
    letra: '',
    nombre: 'Quebrada Del Agua',
  },
  {
    codCiudad: 2054,
    codPcia: 10,
    CP: 4409,
    letra: '',
    nombre: 'Quebrada Del Toro',
  },
  {
    codCiudad: 2055,
    codPcia: 10,
    CP: 4409,
    letra: '',
    nombre: 'Quebrada Muqano',
  },
  {
    codCiudad: 1427,
    codPcia: 19,
    CP: 6325,
    letra: '',
    nombre: 'QUEHUÉ',
  },
  {
    codCiudad: 1897,
    codPcia: 10,
    CP: 4195,
    letra: '',
    nombre: 'Quemadito',
  },
  {
    codCiudad: 1291,
    codPcia: 19,
    CP: 6333,
    letra: '',
    nombre: 'QUEMU QUEMU',
  },
  {
    codCiudad: 3021,
    codPcia: 10,
    CP: 4644,
    letra: '',
    nombre: 'Quenti Taco',
  },
  {
    codCiudad: 2714,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'Quequa',
  },
  {
    codCiudad: 1564,
    codPcia: 2,
    CP: 7631,
    letra: '',
    nombre: 'QUEQUEN',
  },
  {
    codCiudad: 2999,
    codPcia: 10,
    CP: 4634,
    letra: '',
    nombre: 'Quera',
  },
  {
    codCiudad: 2477,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'Quesera',
  },
  {
    codCiudad: 1670,
    codPcia: 19,
    CP: 6212,
    letra: '',
    nombre: 'QUETREQUEN',
  },
  {
    codCiudad: 911,
    codPcia: 4,
    CP: 5214,
    letra: '',
    nombre: 'QUILINO',
  },
  {
    codCiudad: 1812,
    codPcia: 10,
    CP: 4141,
    letra: '',
    nombre: 'Quilmes',
  },
  {
    codCiudad: 401,
    codPcia: 2,
    CP: 1878,
    letra: '',
    nombre: 'QUILMES',
  },
  {
    codCiudad: 402,
    codPcia: 2,
    CP: 1879,
    letra: '',
    nombre: 'QUILMES OESTE',
  },
  {
    codCiudad: 787,
    codPcia: 14,
    CP: 3740,
    letra: '',
    nombre: 'QUIMILI',
  },
  {
    codCiudad: 996,
    codPcia: 12,
    CP: 5711,
    letra: '',
    nombre: 'QUINES',
  },
  {
    codCiudad: 1813,
    codPcia: 10,
    CP: 4141,
    letra: '',
    nombre: 'Quisca Grande',
  },
  {
    codCiudad: 2253,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'Quisca Loro',
  },
  {
    codCiudad: 2396,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'Quisto',
  },
  {
    codCiudad: 752,
    codPcia: 16,
    CP: 3530,
    letra: '',
    nombre: 'QUITILIPI',
  },
  {
    codCiudad: 1534,
    codPcia: 17,
    CP: 9001,
    letra: '',
    nombre: 'RADA TILLY',
  },
  {
    codCiudad: 388,
    codPcia: 2,
    CP: 1847,
    letra: '',
    nombre: 'RAFAEL CALZADA',
  },
  {
    codCiudad: 354,
    codPcia: 2,
    CP: 1755,
    letra: '',
    nombre: 'RAFAEL CASTILLO',
  },
  {
    codCiudad: 501,
    codPcia: 13,
    CP: 2300,
    letra: '',
    nombre: 'RAFAELA',
  },
  {
    codCiudad: 1554,
    codPcia: 6,
    CP: 3177,
    letra: '',
    nombre: 'RAICES AL ESTE',
  },
  {
    codCiudad: 634,
    codPcia: 2,
    CP: 2915,
    letra: '',
    nombre: 'RAMALLO',
  },
  {
    codCiudad: 1639,
    codPcia: 13,
    CP: 3042,
    letra: '',
    nombre: 'RAMAYON',
  },
  {
    codCiudad: 1579,
    codPcia: 6,
    CP: 3164,
    letra: '',
    nombre: 'RAMIREZ',
  },
  {
    codCiudad: 1713,
    codPcia: 2,
    CP: 7641,
    letra: '',
    nombre: 'RAMON SANTAMARIA',
  },
  {
    codCiudad: 335,
    codPcia: 2,
    CP: 1704,
    letra: '',
    nombre: 'RAMOS MEJIA',
  },
  {
    codCiudad: 1484,
    codPcia: 22,
    CP: 8534,
    letra: '',
    nombre: 'RAMOS MEXIA',
  },
  {
    codCiudad: 422,
    codPcia: 2,
    CP: 1987,
    letra: '',
    nombre: 'RANCHOS',
  },
  {
    codCiudad: 406,
    codPcia: 2,
    CP: 1886,
    letra: '',
    nombre: 'RANELAGH',
  },
  {
    codCiudad: 828,
    codPcia: 14,
    CP: 4189,
    letra: '',
    nombre: 'RAPELLI',
  },
  {
    codCiudad: 1160,
    codPcia: 2,
    CP: 7203,
    letra: '',
    nombre: 'RAUCH',
  },
  {
    codCiudad: 1214,
    codPcia: 17,
    CP: 9103,
    letra: '',
    nombre: 'RAWSON',
  },
  {
    codCiudad: 1140,
    codPcia: 2,
    CP: 6734,
    letra: '',
    nombre: 'RAWSON',
  },
  {
    codCiudad: 1424,
    codPcia: 11,
    CP: 5400,
    letra: '',
    nombre: 'RAWSON',
  },
  {
    codCiudad: 920,
    codPcia: 4,
    CP: 5246,
    letra: '',
    nombre: 'RAYO CORTADO',
  },
  {
    codCiudad: 1111,
    codPcia: 2,
    CP: 6559,
    letra: '',
    nombre: 'RECALDE',
  },
  {
    codCiudad: 2946,
    codPcia: 10,
    CP: 4563,
    letra: '',
    nombre: 'Recaredo',
  },
  {
    codCiudad: 760,
    codPcia: 13,
    CP: 3560,
    letra: '',
    nombre: 'RECONQUISTA',
  },
  {
    codCiudad: 662,
    codPcia: 13,
    CP: 3018,
    letra: '',
    nombre: 'RECREO',
  },
  {
    codCiudad: 923,
    codPcia: 15,
    CP: 5260,
    letra: '',
    nombre: 'RECREO',
  },
  {
    codCiudad: 1874,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'Recreo',
  },
  {
    codCiudad: 3022,
    codPcia: 10,
    CP: 4644,
    letra: '',
    nombre: 'Redonda',
  },
  {
    codCiudad: 2327,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'Redondo',
  },
  {
    codCiudad: 1009,
    codPcia: 4,
    CP: 5803,
    letra: '',
    nombre: 'REDUCCION',
  },
  {
    codCiudad: 380,
    codPcia: 2,
    CP: 1826,
    letra: '',
    nombre: 'REMEDIOS DE ECALADA',
  },
  {
    codCiudad: 741,
    codPcia: 16,
    CP: 3500,
    letra: '',
    nombre: 'RESISTENCIA',
  },
  {
    codCiudad: 2879,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Resistencia',
  },
  {
    codCiudad: 2254,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'Retiro',
  },
  {
    codCiudad: 3149,
    codPcia: 18,
    CP: 3611,
    letra: '',
    nombre: 'RIACHO HE HE',
  },
  {
    codCiudad: 730,
    codPcia: 5,
    CP: 3416,
    letra: '',
    nombre: 'RIACHUELO',
  },
  {
    codCiudad: 1789,
    codPcia: 10,
    CP: 4126,
    letra: '',
    nombre: 'Riarte',
  },
  {
    codCiudad: 1762,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Ricardo Guiraldes',
  },
  {
    codCiudad: 481,
    codPcia: 13,
    CP: 2201,
    letra: '',
    nombre: 'RICARDONE',
  },
  {
    codCiudad: 1814,
    codPcia: 10,
    CP: 4141,
    letra: '',
    nombre: 'Rincon De Quilmes',
  },
  {
    codCiudad: 413,
    codPcia: 2,
    CP: 1901,
    letra: '',
    nombre: 'RINGUELET',
  },
  {
    codCiudad: 2328,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'Rio Alemania',
  },
  {
    codCiudad: 1992,
    codPcia: 10,
    CP: 4403,
    letra: '',
    nombre: 'Rio Ancho',
  },
  {
    codCiudad: 1945,
    codPcia: 10,
    CP: 4400,
    letra: '',
    nombre: 'Rio Ancho',
  },
  {
    codCiudad: 2155,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Rio Blanco',
  },
  {
    codCiudad: 2955,
    codPcia: 10,
    CP: 4566,
    letra: '',
    nombre: 'Rio Carapan',
  },
  {
    codCiudad: 879,
    codPcia: 4,
    CP: 5111,
    letra: '',
    nombre: 'RIO CEBALLOS',
  },
  {
    codCiudad: 2715,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'Rio Colorado',
  },
  {
    codCiudad: 3023,
    codPcia: 10,
    CP: 4644,
    letra: '',
    nombre: 'Rio Colorado',
  },
  {
    codCiudad: 1194,
    codPcia: 22,
    CP: 8138,
    letra: '',
    nombre: 'RIO COLORADO',
  },
  {
    codCiudad: 1007,
    codPcia: 4,
    CP: 5800,
    letra: '',
    nombre: 'RIO CUARTO',
  },
  {
    codCiudad: 2716,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'Rio De Las Piedras',
  },
  {
    codCiudad: 2478,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'Rio De Las Piedras',
  },
  {
    codCiudad: 1624,
    codPcia: 4,
    CP: 5821,
    letra: '',
    nombre: 'RÍO DE LOS SAUCES',
  },
  {
    codCiudad: 2626,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'Rio Del Valle',
  },
  {
    codCiudad: 1216,
    codPcia: 23,
    CP: 9400,
    letra: '',
    nombre: 'RIO GALLEGOS',
  },
  {
    codCiudad: 1217,
    codPcia: 23,
    CP: 9420,
    letra: '',
    nombre: 'RIO GRANDE',
  },
  {
    codCiudad: 1464,
    codPcia: 24,
    CP: 9420,
    letra: '',
    nombre: 'RIO GRANDE',
  },
  {
    codCiudad: 3000,
    codPcia: 10,
    CP: 4634,
    letra: '',
    nombre: 'Rio Grande',
  },
  {
    codCiudad: 2431,
    codPcia: 10,
    CP: 4432,
    letra: '',
    nombre: 'Rio Lavallen',
  },
  {
    codCiudad: 1394,
    codPcia: 17,
    CP: 9030,
    letra: '',
    nombre: 'RIO MAYO',
  },
  {
    codCiudad: 2717,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'Rio Pescado',
  },
  {
    codCiudad: 1252,
    codPcia: 4,
    CP: 5127,
    letra: '',
    nombre: 'RIO PRIMERO',
  },
  {
    codCiudad: 887,
    codPcia: 4,
    CP: 5127,
    letra: '',
    nombre: 'RIO PRIMERO',
  },
  {
    codCiudad: 2839,
    codPcia: 10,
    CP: 4552,
    letra: '',
    nombre: 'Rio Seco',
  },
  {
    codCiudad: 808,
    codPcia: 3,
    CP: 4145,
    letra: '',
    nombre: 'RIO SECO',
  },
  {
    codCiudad: 1482,
    codPcia: 4,
    CP: 5284,
    letra: '',
    nombre: 'RÍO SECO',
  },
  {
    codCiudad: 1052,
    codPcia: 4,
    CP: 5960,
    letra: '',
    nombre: 'RIO SEGUNDO',
  },
  {
    codCiudad: 1489,
    codPcia: 17,
    CP: 9033,
    letra: '',
    nombre: 'RIO SENGUER',
  },
  {
    codCiudad: 648,
    codPcia: 2,
    CP: 2944,
    letra: '',
    nombre: 'RIO TALA',
  },
  {
    codCiudad: 1022,
    codPcia: 4,
    CP: 5850,
    letra: '',
    nombre: 'RIO TERCERO',
  },
  {
    codCiudad: 2156,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Rio Toro',
  },
  {
    codCiudad: 1266,
    codPcia: 23,
    CP: 0,
    letra: '',
    nombre: 'RIO TURBIO',
  },
  {
    codCiudad: 1021,
    codPcia: 4,
    CP: 5848,
    letra: '',
    nombre: 'RIPAMONTI.',
  },
  {
    codCiudad: 1453,
    codPcia: 11,
    CP: 5400,
    letra: '',
    nombre: 'RIVADAVIA',
  },
  {
    codCiudad: 998,
    codPcia: 12,
    CP: 5719,
    letra: '',
    nombre: 'RIVADAVIA',
  },
  {
    codCiudad: 982,
    codPcia: 9,
    CP: 5577,
    letra: '',
    nombre: 'RIVADAVIA',
  },
  {
    codCiudad: 2789,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'Rivadavia',
  },
  {
    codCiudad: 1295,
    codPcia: 2,
    CP: 6075,
    letra: '',
    nombre: 'ROBERTS',
  },
  {
    codCiudad: 2655,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Roca',
  },
  {
    codCiudad: 836,
    codPcia: 14,
    CP: 4233,
    letra: '',
    nombre: 'RODEITO',
  },
  {
    codCiudad: 3057,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'Rodeo',
  },
  {
    codCiudad: 2984,
    codPcia: 10,
    CP: 4633,
    letra: '',
    nombre: 'Rodeo Colorado',
  },
  {
    codCiudad: 971,
    codPcia: 9,
    CP: 5525,
    letra: '',
    nombre: 'RODEO DE LA CRUZ',
  },
  {
    codCiudad: 973,
    codPcia: 9,
    CP: 5529,
    letra: '',
    nombre: 'RODEO DEL MEDIO',
  },
  {
    codCiudad: 2432,
    codPcia: 10,
    CP: 4432,
    letra: '',
    nombre: 'Rodeo Grande',
  },
  {
    codCiudad: 3058,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'Rodeo Pampa',
  },
  {
    codCiudad: 1993,
    codPcia: 10,
    CP: 4403,
    letra: '',
    nombre: 'Rodeos',
  },
  {
    codCiudad: 985,
    codPcia: 9,
    CP: 5585,
    letra: '',
    nombre: 'RODRIGUEZ PE',
  },
  {
    codCiudad: 594,
    codPcia: 2,
    CP: 2705,
    letra: '',
    nombre: 'ROJAS',
  },
  {
    codCiudad: 455,
    codPcia: 13,
    CP: 2134,
    letra: '',
    nombre: 'ROLDAN',
  },
  {
    codCiudad: 1219,
    codPcia: 19,
    CP: 0,
    letra: '',
    nombre: 'ROLDAN',
  },
  {
    codCiudad: 1451,
    codPcia: 19,
    CP: 6305,
    letra: '',
    nombre: 'ROLON',
  },
  {
    codCiudad: 854,
    codPcia: 14,
    CP: 4452,
    letra: '',
    nombre: 'ROMA',
  },
  {
    codCiudad: 2656,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Roma',
  },
  {
    codCiudad: 759,
    codPcia: 13,
    CP: 3555,
    letra: '',
    nombre: 'ROMANG',
  },
  {
    codCiudad: 3024,
    codPcia: 10,
    CP: 4644,
    letra: '',
    nombre: 'Rontuyoc',
  },
  {
    codCiudad: 1164,
    codPcia: 2,
    CP: 7245,
    letra: '',
    nombre: 'ROQUE PEREZ',
  },
  {
    codCiudad: 775,
    codPcia: 16,
    CP: 3700,
    letra: '',
    nombre: 'ROQUE SAENZ PENA',
  },
  {
    codCiudad: 1369,
    codPcia: 4,
    CP: 6128,
    letra: '',
    nombre: 'ROSALES',
  },
  {
    codCiudad: 2551,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'Rosales',
  },
  {
    codCiudad: 829,
    codPcia: 10,
    CP: 4190,
    letra: '',
    nombre: 'ROSARIO DE LA FRONTERA',
  },
  {
    codCiudad: 1836,
    codPcia: 10,
    CP: 4190,
    letra: '',
    nombre: 'Rosario De La Frontera',
  },
  {
    codCiudad: 2022,
    codPcia: 10,
    CP: 4405,
    letra: '',
    nombre: 'Rosario De Lerma',
  },
  {
    codCiudad: 2627,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'Rosario Del Dorado',
  },
  {
    codCiudad: 1530,
    codPcia: 6,
    CP: 3174,
    letra: '',
    nombre: 'ROSARIO DEL TALA',
  },
  {
    codCiudad: 1837,
    codPcia: 10,
    CP: 4190,
    letra: '',
    nombre: 'Rosario Funca',
  },
  {
    codCiudad: 640,
    codPcia: 13,
    CP: 2921,
    letra: '',
    nombre: 'RUEDA',
  },
  {
    codCiudad: 1075,
    codPcia: 13,
    CP: 6100,
    letra: '',
    nombre: 'RUFINO',
  },
  {
    codCiudad: 1790,
    codPcia: 10,
    CP: 4126,
    letra: '',
    nombre: 'Ruiz De Los Llanos',
  },
  {
    codCiudad: 820,
    codPcia: 3,
    CP: 4164,
    letra: '',
    nombre: 'RUMI PUNCO',
  },
  {
    codCiudad: 2157,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Rumiarco',
  },
  {
    codCiudad: 2177,
    codPcia: 10,
    CP: 4417,
    letra: '',
    nombre: 'Rumihuasi',
  },
  {
    codCiudad: 2206,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'Rumihuasi',
  },
  {
    codCiudad: 2360,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'Rumiuarco',
  },
  {
    codCiudad: 1763,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'S Alberto Vlba',
  },
  {
    codCiudad: 2082,
    codPcia: 10,
    CP: 4411,
    letra: '',
    nombre: 'S Ant D Los Cobres',
  },
  {
    codCiudad: 3102,
    codPcia: 10,
    CP: 5236,
    letra: '',
    nombre: 'S Ant De B Vista',
  },
  {
    codCiudad: 2255,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'S Antonio Chicoana',
  },
  {
    codCiudad: 2985,
    codPcia: 10,
    CP: 4633,
    letra: '',
    nombre: 'S Antonio De Iruya',
  },
  {
    codCiudad: 1211,
    codPcia: 22,
    CP: 8520,
    letra: '',
    nombre: 'S ANTONIO OESTE',
  },
  {
    codCiudad: 2207,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'S De Hombre Muerto',
  },
  {
    codCiudad: 2628,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'S Dgo S Victoria',
  },
  {
    codCiudad: 2288,
    codPcia: 10,
    CP: 4423,
    letra: '',
    nombre: 'S F. De Escoipe',
  },
  {
    codCiudad: 2840,
    codPcia: 10,
    CP: 4552,
    letra: '',
    nombre: 'S Hachada E Fcgb',
  },
  {
    codCiudad: 2718,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'S Ign De Loyola',
  },
  {
    codCiudad: 464,
    codPcia: 13,
    CP: 2147,
    letra: '',
    nombre: 'S JENARO NORTE',
  },
  {
    codCiudad: 2907,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'S Jollin',
  },
  {
    codCiudad: 2208,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'S Jose De Escalchi',
  },
  {
    codCiudad: 2552,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'S Jose De Orqueras',
  },
  {
    codCiudad: 2158,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'S Martin La Cuesta',
  },
  {
    codCiudad: 1843,
    codPcia: 10,
    CP: 4191,
    letra: '',
    nombre: 'S P. De L Corrales',
  },
  {
    codCiudad: 2397,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'S Pedro De Aranda',
  },
  {
    codCiudad: 1791,
    codPcia: 10,
    CP: 4126,
    letra: '',
    nombre: 'S Pedro De Aranda',
  },
  {
    codCiudad: 2083,
    codPcia: 10,
    CP: 4411,
    letra: '',
    nombre: 'S R De L P Grande',
  },
  {
    codCiudad: 2719,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'S R De La Nva Oran',
  },
  {
    codCiudad: 3083,
    codPcia: 10,
    CP: 5231,
    letra: '',
    nombre: 'S Roque Las Arrias',
  },
  {
    codCiudad: 2056,
    codPcia: 10,
    CP: 4409,
    letra: '',
    nombre: 'S Rosa De Tastil',
  },
  {
    codCiudad: 2932,
    codPcia: 10,
    CP: 4561,
    letra: '',
    nombre: 'S Victoria Este',
  },
  {
    codCiudad: 341,
    codPcia: 2,
    CP: 1718,
    letra: '',
    nombre: 'S. A. DE PADUA',
  },
  {
    codCiudad: 403,
    codPcia: 2,
    CP: 1881,
    letra: '',
    nombre: 'S. FCO. SOLANO',
  },
  {
    codCiudad: 2629,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'S. Forestal Km 50',
  },
  {
    codCiudad: 724,
    codPcia: 5,
    CP: 3403,
    letra: '',
    nombre: 'S. LUIS DEL PALMAR',
  },
  {
    codCiudad: 545,
    codPcia: 4,
    CP: 2559,
    letra: '',
    nombre: 'S.ANTONIO LITIN',
  },
  {
    codCiudad: 1567,
    codPcia: 2,
    CP: 8174,
    letra: '',
    nombre: 'SAAVEDRA',
  },
  {
    codCiudad: 326,
    codPcia: 2,
    CP: 1674,
    letra: '',
    nombre: 'SAENZ PEÑA',
  },
  {
    codCiudad: 534,
    codPcia: 4,
    CP: 2525,
    letra: '',
    nombre: 'SAIRA',
  },
  {
    codCiudad: 852,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'SALADILLO',
  },
  {
    codCiudad: 555,
    codPcia: 4,
    CP: 2587,
    letra: '',
    nombre: 'SALADILLO',
  },
  {
    codCiudad: 844,
    codPcia: 14,
    CP: 4319,
    letra: '',
    nombre: 'SALADILLO',
  },
  {
    codCiudad: 858,
    codPcia: 7,
    CP: 4522,
    letra: '',
    nombre: 'SALADILLO',
  },
  {
    codCiudad: 773,
    codPcia: 18,
    CP: 3620,
    letra: '',
    nombre: 'SALADILLO',
  },
  {
    codCiudad: 809,
    codPcia: 3,
    CP: 4146,
    letra: '',
    nombre: 'SALADILLO',
  },
  {
    codCiudad: 851,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'SALADILLO',
  },
  {
    codCiudad: 1004,
    codPcia: 12,
    CP: 5751,
    letra: '',
    nombre: 'SALADILLO',
  },
  {
    codCiudad: 849,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'SALADILLO',
  },
  {
    codCiudad: 1165,
    codPcia: 2,
    CP: 7260,
    letra: '',
    nombre: 'SALADILLO',
  },
  {
    codCiudad: 2581,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'Saladillo  Juarez',
  },
  {
    codCiudad: 850,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'SALADILLO DE OSMA',
  },
  {
    codCiudad: 1166,
    codPcia: 2,
    CP: 7261,
    letra: '',
    nombre: 'SALADILLO NORTE',
  },
  {
    codCiudad: 2103,
    codPcia: 10,
    CP: 4413,
    letra: '',
    nombre: 'Salar De Pocitos',
  },
  {
    codCiudad: 893,
    codPcia: 4,
    CP: 5149,
    letra: '',
    nombre: 'SALDAN',
  },
  {
    codCiudad: 1095,
    codPcia: 2,
    CP: 6339,
    letra: '',
    nombre: 'SALLIQUELO',
  },
  {
    codCiudad: 880,
    codPcia: 4,
    CP: 5113,
    letra: '',
    nombre: 'SALSIPUEDES',
  },
  {
    codCiudad: 848,
    codPcia: 10,
    CP: 4400,
    letra: '',
    nombre: 'SALTA',
  },
  {
    codCiudad: 612,
    codPcia: 2,
    CP: 2741,
    letra: '',
    nombre: 'SALTO',
  },
  {
    codCiudad: 459,
    codPcia: 13,
    CP: 2142,
    letra: '',
    nombre: 'SALTO GRANDE',
  },
  {
    codCiudad: 2960,
    codPcia: 10,
    CP: 4568,
    letra: '',
    nombre: 'Salvador Mazza',
  },
  {
    codCiudad: 1017,
    codPcia: 4,
    CP: 5829,
    letra: '',
    nombre: 'SAMPACHO',
  },
  {
    codCiudad: 1392,
    codPcia: 16,
    CP: 3543,
    letra: '',
    nombre: 'SAMUHU',
  },
  {
    codCiudad: 1136,
    codPcia: 2,
    CP: 6720,
    letra: '',
    nombre: 'SAN A DE GILES',
  },
  {
    codCiudad: 1875,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'San Agustin',
  },
  {
    codCiudad: 1572,
    codPcia: 2,
    CP: 7623,
    letra: '',
    nombre: 'SAN AGUSTIN',
  },
  {
    codCiudad: 3146,
    codPcia: 13,
    CP: 3017,
    letra: '',
    nombre: 'SAN AGUSTIN',
  },
  {
    codCiudad: 904,
    codPcia: 4,
    CP: 5191,
    letra: '',
    nombre: 'SAN AGUSTIN',
  },
  {
    codCiudad: 2256,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'San Agustin',
  },
  {
    codCiudad: 1968,
    codPcia: 10,
    CP: 4401,
    letra: '',
    nombre: 'San Alejo',
  },
  {
    codCiudad: 2720,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'San Andres',
  },
  {
    codCiudad: 314,
    codPcia: 2,
    CP: 1651,
    letra: '',
    nombre: 'SAN ANDRES',
  },
  {
    codCiudad: 944,
    codPcia: 8,
    CP: 5310,
    letra: '',
    nombre: 'SAN ANTONIO',
  },
  {
    codCiudad: 2721,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'San Antonio',
  },
  {
    codCiudad: 2361,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'San Antonio',
  },
  {
    codCiudad: 2986,
    codPcia: 10,
    CP: 4633,
    letra: '',
    nombre: 'San Antonio',
  },
  {
    codCiudad: 617,
    codPcia: 2,
    CP: 2760,
    letra: '',
    nombre: 'SAN ANTONIO DE ARECO',
  },
  {
    codCiudad: 1555,
    codPcia: 4,
    CP: 2559,
    letra: '',
    nombre: 'SAN ANTONIO DE LITIN',
  },
  {
    codCiudad: 2084,
    codPcia: 10,
    CP: 4411,
    letra: '',
    nombre: 'San Antonio De Los Cobres',
  },
  {
    codCiudad: 1248,
    codPcia: 13,
    CP: 3587,
    letra: '',
    nombre: 'SAN ANTONIO DE OBLIGADO',
  },
  {
    codCiudad: 1635,
    codPcia: 4,
    CP: 5841,
    letra: '',
    nombre: 'SAN BASILIO',
  },
  {
    codCiudad: 2933,
    codPcia: 10,
    CP: 4561,
    letra: '',
    nombre: 'San Bernardo',
  },
  {
    codCiudad: 1360,
    codPcia: 16,
    CP: 3701,
    letra: '',
    nombre: 'SAN BERNARDO',
  },
  {
    codCiudad: 1112,
    codPcia: 2,
    CP: 6561,
    letra: '',
    nombre: 'SAN BERNARDO',
  },
  {
    codCiudad: 2722,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'San Bernardo',
  },
  {
    codCiudad: 1638,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'SAN CARLOS',
  },
  {
    codCiudad: 1377,
    codPcia: 9,
    CP: 5569,
    letra: '',
    nombre: 'SAN CARLOS',
  },
  {
    codCiudad: 2371,
    codPcia: 10,
    CP: 4428,
    letra: '',
    nombre: 'San Carlos',
  },
  {
    codCiudad: 657,
    codPcia: 13,
    CP: 3013,
    letra: '',
    nombre: 'SAN CARLOS CENTRO',
  },
  {
    codCiudad: 1372,
    codPcia: 4,
    CP: 5291,
    letra: '',
    nombre: 'SAN CARLOS MINAS',
  },
  {
    codCiudad: 658,
    codPcia: 13,
    CP: 3013,
    letra: '',
    nombre: 'SAN CARLOS SUD',
  },
  {
    codCiudad: 1994,
    codPcia: 10,
    CP: 4403,
    letra: '',
    nombre: 'San Clemente',
  },
  {
    codCiudad: 1147,
    codPcia: 2,
    CP: 7105,
    letra: '',
    nombre: 'SAN CLEMENTE DEL TUY',
  },
  {
    codCiudad: 727,
    codPcia: 5,
    CP: 3412,
    letra: '',
    nombre: 'SAN COSME',
  },
  {
    codCiudad: 683,
    codPcia: 13,
    CP: 3070,
    letra: '',
    nombre: 'SAN CRISTOBAL',
  },
  {
    codCiudad: 566,
    codPcia: 13,
    CP: 2615,
    letra: '',
    nombre: 'SAN EDUARDO',
  },
  {
    codCiudad: 902,
    codPcia: 4,
    CP: 5182,
    letra: '',
    nombre: 'SAN ESTEBAN',
  },
  {
    codCiudad: 1838,
    codPcia: 10,
    CP: 4190,
    letra: '',
    nombre: 'San Esteban',
  },
  {
    codCiudad: 497,
    codPcia: 13,
    CP: 2253,
    letra: '',
    nombre: 'SAN EUGENIO',
  },
  {
    codCiudad: 2362,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'San Felipe',
  },
  {
    codCiudad: 1923,
    codPcia: 10,
    CP: 4198,
    letra: '',
    nombre: 'San Felipe',
  },
  {
    codCiudad: 3059,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'San Felipe',
  },
  {
    codCiudad: 2582,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'San Fernando',
  },
  {
    codCiudad: 310,
    codPcia: 2,
    CP: 1646,
    letra: '',
    nombre: 'SAN FERNANDO',
  },
  {
    codCiudad: 1412,
    codPcia: 3,
    CP: 4700,
    letra: '',
    nombre: 'SAN FERNANDO DEL VALLE DE CATA',
  },
  {
    codCiudad: 3060,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'San Francisco',
  },
  {
    codCiudad: 513,
    codPcia: 4,
    CP: 2400,
    letra: '',
    nombre: 'SAN FRANCISCO',
  },
  {
    codCiudad: 908,
    codPcia: 4,
    CP: 5209,
    letra: '',
    nombre: 'SAN FRANCISCO DEL CH',
  },
  {
    codCiudad: 2657,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'San Gabriel',
  },
  {
    codCiudad: 463,
    codPcia: 13,
    CP: 2146,
    letra: '',
    nombre: 'SAN GENARO',
  },
  {
    codCiudad: 456,
    codPcia: 13,
    CP: 2136,
    letra: '',
    nombre: 'SAN GERONIMO',
  },
  {
    codCiudad: 2257,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'San Geronimo',
  },
  {
    codCiudad: 656,
    codPcia: 13,
    CP: 3011,
    letra: '',
    nombre: 'SAN GERONIMO NORTE',
  },
  {
    codCiudad: 565,
    codPcia: 13,
    CP: 2613,
    letra: '',
    nombre: 'SAN GREGORIO',
  },
  {
    codCiudad: 3165,
    codPcia: 13,
    CP: 2347,
    letra: '',
    nombre: 'SAN GUILLERMO',
  },
  {
    codCiudad: 2723,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'San Ignacio',
  },
  {
    codCiudad: 2583,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'San Ignacio',
  },
  {
    codCiudad: 866,
    codPcia: 3,
    CP: 4707,
    letra: '',
    nombre: 'SAN ISIDRO',
  },
  {
    codCiudad: 2398,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'San Isidro',
  },
  {
    codCiudad: 2790,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'San Isidro',
  },
  {
    codCiudad: 307,
    codPcia: 2,
    CP: 1642,
    letra: '',
    nombre: 'SAN ISIDRO',
  },
  {
    codCiudad: 2658,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'San Isidro',
  },
  {
    codCiudad: 1764,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'San Isidro',
  },
  {
    codCiudad: 2363,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'San Isidro-Salta',
  },
  {
    codCiudad: 1301,
    codPcia: 6,
    CP: 3185,
    letra: '',
    nombre: 'SAN JAIME',
  },
  {
    codCiudad: 2502,
    codPcia: 10,
    CP: 4440,
    letra: '',
    nombre: 'San Javier',
  },
  {
    codCiudad: 654,
    codPcia: 13,
    CP: 3005,
    letra: '',
    nombre: 'SAN JAVIER',
  },
  {
    codCiudad: 1569,
    codPcia: 13,
    CP: 3009,
    letra: '',
    nombre: 'SAN JERONIMO DEL SAUCE',
  },
  {
    codCiudad: 2289,
    codPcia: 10,
    CP: 4423,
    letra: '',
    nombre: 'San Joaquin',
  },
  {
    codCiudad: 1677,
    codPcia: 4,
    CP: 6123,
    letra: '',
    nombre: 'SAN JOAQUIN',
  },
  {
    codCiudad: 2791,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'San Joaquin',
  },
  {
    codCiudad: 2584,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'San Jorge',
  },
  {
    codCiudad: 520,
    codPcia: 13,
    CP: 2451,
    letra: '',
    nombre: 'SAN JORGE',
  },
  {
    codCiudad: 968,
    codPcia: 9,
    CP: 5519,
    letra: '',
    nombre: 'SAN JOSE',
  },
  {
    codCiudad: 2258,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'San Jose',
  },
  {
    codCiudad: 1623,
    codPcia: 3,
    CP: 4139,
    letra: '',
    nombre: 'SAN JOSE',
  },
  {
    codCiudad: 3171,
    codPcia: 20,
    CP: 3306,
    letra: '',
    nombre: 'SAN JOSE',
  },
  {
    codCiudad: 2209,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'San Jose De Colte',
  },
  {
    codCiudad: 2178,
    codPcia: 10,
    CP: 4417,
    letra: '',
    nombre: 'San Jose De Colte',
  },
  {
    codCiudad: 703,
    codPcia: 6,
    CP: 3187,
    letra: '',
    nombre: 'SAN JOSE DE FELICIAN',
  },
  {
    codCiudad: 919,
    codPcia: 4,
    CP: 5244,
    letra: '',
    nombre: 'SAN JOSE DE LA DORMI',
  },
  {
    codCiudad: 1321,
    codPcia: 4,
    CP: 5244,
    letra: '',
    nombre: 'SAN JOSE DE LA DORMIDA',
  },
  {
    codCiudad: 1242,
    codPcia: 13,
    CP: 2185,
    letra: '',
    nombre: 'SAN JOSE DE LA ESQUINA',
  },
  {
    codCiudad: 1798,
    codPcia: 10,
    CP: 4128,
    letra: '',
    nombre: 'San Jose De Lules',
  },
  {
    codCiudad: 652,
    codPcia: 13,
    CP: 3001,
    letra: '',
    nombre: 'SAN JOSE DEL RINCON',
  },
  {
    codCiudad: 2553,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'San Juan',
  },
  {
    codCiudad: 949,
    codPcia: 11,
    CP: 5400,
    letra: '',
    nombre: 'SAN JUAN',
  },
  {
    codCiudad: 1876,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'San Juan',
  },
  {
    codCiudad: 3061,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'San Juan De Oro',
  },
  {
    codCiudad: 353,
    codPcia: 2,
    CP: 1754,
    letra: '',
    nombre: 'SAN JUSTO',
  },
  {
    codCiudad: 670,
    codPcia: 13,
    CP: 3040,
    letra: '',
    nombre: 'SAN JUSTO',
  },
  {
    codCiudad: 1717,
    codPcia: 6,
    CP: 3260,
    letra: '',
    nombre: 'SAN JUSTO',
  },
  {
    codCiudad: 2908,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'San Laurencio',
  },
  {
    codCiudad: 3062,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'San Leon',
  },
  {
    codCiudad: 480,
    codPcia: 13,
    CP: 2200,
    letra: '',
    nombre: 'SAN LORENZO',
  },
  {
    codCiudad: 1885,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'San Lorenzo',
  },
  {
    codCiudad: 1924,
    codPcia: 10,
    CP: 4198,
    letra: '',
    nombre: 'San Lorenzo',
  },
  {
    codCiudad: 2364,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'San Lucas',
  },
  {
    codCiudad: 993,
    codPcia: 12,
    CP: 5700,
    letra: '',
    nombre: 'SAN LUIS',
  },
  {
    codCiudad: 1877,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'San Luis',
  },
  {
    codCiudad: 2630,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'San Luis',
  },
  {
    codCiudad: 1365,
    codPcia: 5,
    CP: 3403,
    letra: '',
    nombre: 'SAN LUIS DEL PALMAR',
  },
  {
    codCiudad: 3162,
    codPcia: 2,
    CP: 7007,
    letra: '',
    nombre: 'SAN MANUEL',
  },
  {
    codCiudad: 3063,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'San Marcos',
  },
  {
    codCiudad: 1226,
    codPcia: 4,
    CP: 5282,
    letra: '',
    nombre: 'SAN MARCOS SIERRAS',
  },
  {
    codCiudad: 548,
    codPcia: 4,
    CP: 2566,
    letra: '',
    nombre: 'SAN MARCOS SUD',
  },
  {
    codCiudad: 2210,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'San Martin',
  },
  {
    codCiudad: 2631,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'San Martin',
  },
  {
    codCiudad: 3198,
    codPcia: 16,
    CP: 3714,
    letra: '',
    nombre: 'SAN MARTIN',
  },
  {
    codCiudad: 2259,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'San Martin',
  },
  {
    codCiudad: 1437,
    codPcia: 11,
    CP: 5439,
    letra: '',
    nombre: 'SAN MARTIN',
  },
  {
    codCiudad: 3187,
    codPcia: 18,
    CP: 3621,
    letra: '',
    nombre: 'SAN MARTIN',
  },
  {
    codCiudad: 2433,
    codPcia: 10,
    CP: 4432,
    letra: '',
    nombre: 'San Martin',
  },
  {
    codCiudad: 313,
    codPcia: 2,
    CP: 1650,
    letra: '',
    nombre: 'SAN MARTIN',
  },
  {
    codCiudad: 519,
    codPcia: 13,
    CP: 2449,
    letra: '',
    nombre: 'SAN MARTIN DE LA ESC',
  },
  {
    codCiudad: 1268,
    codPcia: 21,
    CP: 8370,
    letra: '',
    nombre: 'SAN MARTIN DE LOS ANDES',
  },
  {
    codCiudad: 673,
    codPcia: 13,
    CP: 3045,
    letra: '',
    nombre: 'SAN MARTIN NORTE',
  },
  {
    codCiudad: 321,
    codPcia: 2,
    CP: 1663,
    letra: '',
    nombre: 'SAN MIGUEL',
  },
  {
    codCiudad: 1277,
    codPcia: 5,
    CP: 3485,
    letra: '',
    nombre: 'SAN MIGUEL',
  },
  {
    codCiudad: 2792,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'San Miguel',
  },
  {
    codCiudad: 1995,
    codPcia: 10,
    CP: 4403,
    letra: '',
    nombre: 'San Miguel',
  },
  {
    codCiudad: 791,
    codPcia: 15,
    CP: 4000,
    letra: '',
    nombre: 'SAN MIGUEL DE TUCUMAN',
  },
  {
    codCiudad: 1689,
    codPcia: 2,
    CP: 7220,
    letra: '',
    nombre: 'SAN MIGUEL DEL MONTE',
  },
  {
    codCiudad: 627,
    codPcia: 2,
    CP: 2900,
    letra: '',
    nombre: 'SAN NICOLAS',
  },
  {
    codCiudad: 2260,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'San Nicolas',
  },
  {
    codCiudad: 2967,
    codPcia: 10,
    CP: 4600,
    letra: '',
    nombre: 'San Pablo De Reyes',
  },
  {
    codCiudad: 2880,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'San Patricio',
  },
  {
    codCiudad: 1496,
    codPcia: 21,
    CP: 8305,
    letra: '',
    nombre: 'SAN PATRICIO DEL CHAÑAR',
  },
  {
    codCiudad: 3205,
    codPcia: 20,
    CP: 3364,
    letra: '',
    nombre: 'SAN PEDRO',
  },
  {
    codCiudad: 641,
    codPcia: 2,
    CP: 2930,
    letra: '',
    nombre: 'SAN PEDRO',
  },
  {
    codCiudad: 2909,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'San Pedro',
  },
  {
    codCiudad: 933,
    codPcia: 8,
    CP: 5301,
    letra: '',
    nombre: 'SAN PEDRO',
  },
  {
    codCiudad: 855,
    codPcia: 7,
    CP: 4500,
    letra: '',
    nombre: 'SAN PEDRO DE JUJUY',
  },
  {
    codCiudad: 1240,
    codPcia: 4,
    CP: 5205,
    letra: '',
    nombre: 'SAN PEDRO NORTE',
  },
  {
    codCiudad: 988,
    codPcia: 9,
    CP: 5600,
    letra: '',
    nombre: 'SAN RAFAEL',
  },
  {
    codCiudad: 2365,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'San Rafael',
  },
  {
    codCiudad: 2632,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'San Ramon',
  },
  {
    codCiudad: 2724,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'San Ramon De La Nueva Oran',
  },
  {
    codCiudad: 1,
    codPcia: 13,
    CP: 2501,
    letra: '',
    nombre: 'SAN RICARDO',
  },
  {
    codCiudad: 2329,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'San Roque',
  },
  {
    codCiudad: 1339,
    codPcia: 5,
    CP: 3448,
    letra: '',
    nombre: 'SAN ROQUE',
  },
  {
    codCiudad: 1878,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'San Roque',
  },
  {
    codCiudad: 1236,
    codPcia: 6,
    CP: 3218,
    letra: '',
    nombre: 'SAN SALVADOR',
  },
  {
    codCiudad: 863,
    codPcia: 7,
    CP: 4600,
    letra: '',
    nombre: 'SAN SALVADOR DE JUJUY',
  },
  {
    codCiudad: 2479,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'San Sebastian',
  },
  {
    codCiudad: 518,
    codPcia: 13,
    CP: 2447,
    letra: '',
    nombre: 'SAN VICENTE',
  },
  {
    codCiudad: 1839,
    codPcia: 10,
    CP: 4190,
    letra: '',
    nombre: 'San Vicente',
  },
  {
    codCiudad: 2261,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'San Vicente',
  },
  {
    codCiudad: 395,
    codPcia: 2,
    CP: 1865,
    letra: '',
    nombre: 'SAN VICENTE',
  },
  {
    codCiudad: 1548,
    codPcia: 4,
    CP: 5200,
    letra: '',
    nombre: 'SAN VICENTE',
  },
  {
    codCiudad: 567,
    codPcia: 13,
    CP: 2617,
    letra: '',
    nombre: 'SANCTI SPIRITU',
  },
  {
    codCiudad: 470,
    codPcia: 13,
    CP: 2173,
    letra: '',
    nombre: 'SANFORD',
  },
  {
    codCiudad: 1529,
    codPcia: 2,
    CP: 6339,
    letra: '',
    nombre: 'SANIQUELLO',
  },
  {
    codCiudad: 3034,
    codPcia: 10,
    CP: 4650,
    letra: '',
    nombre: 'Sansana',
  },
  {
    codCiudad: 815,
    codPcia: 3,
    CP: 4155,
    letra: '',
    nombre: 'SANTA ANA',
  },
  {
    codCiudad: 2399,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'Santa Ana',
  },
  {
    codCiudad: 2290,
    codPcia: 10,
    CP: 4423,
    letra: '',
    nombre: 'Santa Ana',
  },
  {
    codCiudad: 2585,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'Santa Ana',
  },
  {
    codCiudad: 1410,
    codPcia: 6,
    CP: 3248,
    letra: '',
    nombre: 'SANTA ANITA',
  },
  {
    codCiudad: 2366,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'Santa Barbara',
  },
  {
    codCiudad: 1879,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'Santa Catalina',
  },
  {
    codCiudad: 2881,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Santa Clara',
  },
  {
    codCiudad: 3191,
    codPcia: 13,
    CP: 2258,
    letra: '',
    nombre: 'SANTA CLARA DE BUENA VISTA',
  },
  {
    codCiudad: 1613,
    codPcia: 13,
    CP: 2405,
    letra: '',
    nombre: 'SANTA CLARA DE SAGUIER',
  },
  {
    codCiudad: 1347,
    codPcia: 2,
    CP: 7609,
    letra: '',
    nombre: 'SANTA CLARA DEL MAR',
  },
  {
    codCiudad: 618,
    codPcia: 2,
    CP: 2761,
    letra: '',
    nombre: 'SANTA COLOMA',
  },
  {
    codCiudad: 2400,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'Santa Cruz',
  },
  {
    codCiudad: 3064,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'Santa Cruz',
  },
  {
    codCiudad: 1710,
    codPcia: 10,
    CP: 4531,
    letra: '',
    nombre: 'Santa Cruz',
  },
  {
    codCiudad: 948,
    codPcia: 8,
    CP: 5361,
    letra: '',
    nombre: 'SANTA CRUZ',
  },
  {
    codCiudad: 3120,
    codPcia: 6,
    CP: 3192,
    letra: '',
    nombre: 'SANTA ELENA',
  },
  {
    codCiudad: 1509,
    codPcia: 4,
    CP: 5131,
    letra: '',
    nombre: 'SANTA ELENA',
  },
  {
    codCiudad: 2330,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'Santa Elena',
  },
  {
    codCiudad: 2503,
    codPcia: 10,
    CP: 4440,
    letra: '',
    nombre: 'Santa Elena',
  },
  {
    codCiudad: 1996,
    codPcia: 10,
    CP: 4403,
    letra: '',
    nombre: 'Santa Elena',
  },
  {
    codCiudad: 1186,
    codPcia: 2,
    CP: 7609,
    letra: '',
    nombre: 'SANTA ELENA-PDO DE M',
  },
  {
    codCiudad: 1695,
    codPcia: 2,
    CP: 6241,
    letra: '',
    nombre: 'SANTA ELEODORA',
  },
  {
    codCiudad: 651,
    codPcia: 13,
    CP: 3000,
    letra: '',
    nombre: 'SANTA FE',
  },
  {
    codCiudad: 2291,
    codPcia: 10,
    CP: 4423,
    letra: '',
    nombre: 'Santa Gertrudis',
  },
  {
    codCiudad: 1512,
    codPcia: 19,
    CP: 6323,
    letra: '',
    nombre: 'SANTA ISABEL',
  },
  {
    codCiudad: 562,
    codPcia: 13,
    CP: 2605,
    letra: '',
    nombre: 'SANTA ISABEL',
  },
  {
    codCiudad: 1184,
    codPcia: 2,
    CP: 7605,
    letra: '',
    nombre: 'SANTA ISABEL',
  },
  {
    codCiudad: 2434,
    codPcia: 10,
    CP: 4432,
    letra: '',
    nombre: 'Santa Lucia',
  },
  {
    codCiudad: 644,
    codPcia: 2,
    CP: 2935,
    letra: '',
    nombre: 'SANTA LUCIA',
  },
  {
    codCiudad: 951,
    codPcia: 11,
    CP: 5411,
    letra: '',
    nombre: 'SANTA LUCIA',
  },
  {
    codCiudad: 681,
    codPcia: 13,
    CP: 3061,
    letra: '',
    nombre: 'SANTA MARGARITA',
  },
  {
    codCiudad: 1521,
    codPcia: 4,
    CP: 5889,
    letra: '',
    nombre: 'SANTA MARIA',
  },
  {
    codCiudad: 1880,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'Santa Maria',
  },
  {
    codCiudad: 2262,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'Santa Maria',
  },
  {
    codCiudad: 1490,
    codPcia: 3,
    CP: 4139,
    letra: '',
    nombre: 'SANTA MARIA',
  },
  {
    codCiudad: 3103,
    codPcia: 10,
    CP: 5236,
    letra: '',
    nombre: 'Santa Maria',
  },
  {
    codCiudad: 1430,
    codPcia: 4,
    CP: 5164,
    letra: '',
    nombre: 'SANTA MARIA DE PUNILLA',
  },
  {
    codCiudad: 2814,
    codPcia: 10,
    CP: 4542,
    letra: '',
    nombre: 'Santa Marina',
  },
  {
    codCiudad: 2401,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'Santa Rita',
  },
  {
    codCiudad: 1343,
    codPcia: 11,
    CP: 5443,
    letra: '',
    nombre: 'SANTA ROSA',
  },
  {
    codCiudad: 2659,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Santa Rosa',
  },
  {
    codCiudad: 2292,
    codPcia: 10,
    CP: 4423,
    letra: '',
    nombre: 'Santa Rosa',
  },
  {
    codCiudad: 1223,
    codPcia: 19,
    CP: 6300,
    letra: '',
    nombre: 'SANTA ROSA',
  },
  {
    codCiudad: 2751,
    codPcia: 10,
    CP: 4534,
    letra: '',
    nombre: 'Santa Rosa',
  },
  {
    codCiudad: 2367,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'Santa Rosa',
  },
  {
    codCiudad: 1571,
    codPcia: 3,
    CP: 5343,
    letra: '',
    nombre: 'SANTA ROSA',
  },
  {
    codCiudad: 2793,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'Santa Rosa',
  },
  {
    codCiudad: 2435,
    codPcia: 10,
    CP: 4432,
    letra: '',
    nombre: 'Santa Rosa',
  },
  {
    codCiudad: 1925,
    codPcia: 10,
    CP: 4198,
    letra: '',
    nombre: 'Santa Rosa',
  },
  {
    codCiudad: 2660,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Santa Rosa De Anta',
  },
  {
    codCiudad: 906,
    codPcia: 4,
    CP: 5196,
    letra: '',
    nombre: 'SANTA ROSA DE CALAMU',
  },
  {
    codCiudad: 1645,
    codPcia: 13,
    CP: 3001,
    letra: '',
    nombre: 'SANTA ROSA DE CALCHINES',
  },
  {
    codCiudad: 2057,
    codPcia: 10,
    CP: 4409,
    letra: '',
    nombre: 'Santa Rosa De Tastil',
  },
  {
    codCiudad: 1683,
    codPcia: 12,
    CP: 5777,
    letra: '',
    nombre: 'SANTA ROSA DEL CONLARA',
  },
  {
    codCiudad: 1969,
    codPcia: 10,
    CP: 4401,
    letra: '',
    nombre: 'Santa Rufina',
  },
  {
    codCiudad: 1341,
    codPcia: 16,
    CP: 3541,
    letra: '',
    nombre: 'SANTA SYLVINA',
  },
  {
    codCiudad: 1765,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Santa Teresa',
  },
  {
    codCiudad: 1840,
    codPcia: 10,
    CP: 4190,
    letra: '',
    nombre: 'Santa Teresa',
  },
  {
    codCiudad: 433,
    codPcia: 13,
    CP: 2111,
    letra: '',
    nombre: 'SANTA TERESA',
  },
  {
    codCiudad: 1148,
    codPcia: 1,
    CP: 7107,
    letra: '',
    nombre: 'SANTA TERESITA',
  },
  {
    codCiudad: 2830,
    codPcia: 10,
    CP: 4550,
    letra: '',
    nombre: 'Santa Victoria',
  },
  {
    codCiudad: 3073,
    codPcia: 10,
    CP: 4652,
    letra: '',
    nombre: 'Santa Victoria',
  },
  {
    codCiudad: 2934,
    codPcia: 10,
    CP: 4561,
    letra: '',
    nombre: 'Santa Victoria Este',
  },
  {
    codCiudad: 830,
    codPcia: 14,
    CP: 4200,
    letra: '',
    nombre: 'SANTIAGO DEL ESTERO',
  },
  {
    codCiudad: 1403,
    codPcia: 4,
    CP: 5125,
    letra: '',
    nombre: 'SANTIAGO TEMPLE',
  },
  {
    codCiudad: 2586,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'Santo Domingo',
  },
  {
    codCiudad: 2794,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'Santo Domingo',
  },
  {
    codCiudad: 2633,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'Santo Domingo Anta',
  },
  {
    codCiudad: 1508,
    codPcia: 21,
    CP: 8315,
    letra: '',
    nombre: 'SANTO TOMAS',
  },
  {
    codCiudad: 660,
    codPcia: 13,
    CP: 3016,
    letra: '',
    nombre: 'SANTO TOME',
  },
  {
    codCiudad: 716,
    codPcia: 5,
    CP: 3340,
    letra: '',
    nombre: 'SANTO TOME',
  },
  {
    codCiudad: 327,
    codPcia: 2,
    CP: 1676,
    letra: '',
    nombre: 'SANTOS LUGARES',
  },
  {
    codCiudad: 2795,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'Santos Lugares',
  },
  {
    codCiudad: 2587,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'Sapo Quemado',
  },
  {
    codCiudad: 397,
    codPcia: 2,
    CP: 1872,
    letra: '',
    nombre: 'SARANDI',
  },
  {
    codCiudad: 603,
    codPcia: 2,
    CP: 2721,
    letra: '',
    nombre: 'SARASA',
  },
  {
    codCiudad: 1471,
    codPcia: 13,
    CP: 2105,
    letra: '',
    nombre: 'SARGENTO CABRAL',
  },
  {
    codCiudad: 2402,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'Sargento Cristobal',
  },
  {
    codCiudad: 1389,
    codPcia: 17,
    CP: 9020,
    letra: '',
    nombre: 'SARMIENTO',
  },
  {
    codCiudad: 1621,
    codPcia: 13,
    CP: 2440,
    letra: '',
    nombre: 'SASTRE',
  },
  {
    codCiudad: 3158,
    codPcia: 4,
    CP: 5943,
    letra: '',
    nombre: 'SATURNINO MARIA LASPIUR',
  },
  {
    codCiudad: 1286,
    codPcia: 5,
    CP: 3463,
    letra: '',
    nombre: 'SAUCE',
  },
  {
    codCiudad: 2331,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'Sauce',
  },
  {
    codCiudad: 2263,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'Sauce Alegre',
  },
  {
    codCiudad: 2480,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'Sauce Bajada',
  },
  {
    codCiudad: 2332,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'Sauce Redondo',
  },
  {
    codCiudad: 2588,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'Sauce Solo',
  },
  {
    codCiudad: 661,
    codPcia: 13,
    CP: 3017,
    letra: '',
    nombre: 'SAUCE VIEJO',
  },
  {
    codCiudad: 2810,
    codPcia: 10,
    CP: 4538,
    letra: '',
    nombre: 'Saucelito',
  },
  {
    codCiudad: 2403,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'Sausalito',
  },
  {
    codCiudad: 2554,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'Sauzal',
  },
  {
    codCiudad: 2504,
    codPcia: 10,
    CP: 4440,
    letra: '',
    nombre: 'Schneidewind',
  },
  {
    codCiudad: 3084,
    codPcia: 10,
    CP: 5231,
    letra: '',
    nombre: 'Sebastian El Cano',
  },
  {
    codCiudad: 1285,
    codPcia: 4,
    CP: 5231,
    letra: '',
    nombre: 'SEBASTIAN ELCANO',
  },
  {
    codCiudad: 2211,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'Seclanta Adentro',
  },
  {
    codCiudad: 2212,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'Seclantas',
  },
  {
    codCiudad: 1539,
    codPcia: 4,
    CP: 2419,
    letra: '',
    nombre: 'SEEBER',
  },
  {
    codCiudad: 694,
    codPcia: 6,
    CP: 3117,
    letra: '',
    nombre: 'SEGUI',
  },
  {
    codCiudad: 1766,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Selva Maria',
  },
  {
    codCiudad: 488,
    codPcia: 13,
    CP: 2216,
    letra: '',
    nombre: 'SERODINO',
  },
  {
    codCiudad: 1361,
    codPcia: 4,
    CP: 6125,
    letra: '',
    nombre: 'SERRANO',
  },
  {
    codCiudad: 2264,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'Sevillar',
  },
  {
    codCiudad: 427,
    codPcia: 13,
    CP: 2105,
    letra: '',
    nombre: 'SGTO CABRAL',
  },
  {
    codCiudad: 1175,
    codPcia: 2,
    CP: 7401,
    letra: '',
    nombre: 'SIERRA CHICA',
  },
  {
    codCiudad: 1349,
    codPcia: 2,
    CP: 8168,
    letra: '',
    nombre: 'SIERRA DE LA VENTANA',
  },
  {
    codCiudad: 1176,
    codPcia: 2,
    CP: 7403,
    letra: '',
    nombre: 'SIERRAS BAYAS',
  },
  {
    codCiudad: 1898,
    codPcia: 10,
    CP: 4195,
    letra: '',
    nombre: 'Siete De Abril',
  },
  {
    codCiudad: 2404,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'Simbol Yaco',
  },
  {
    codCiudad: 2368,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'Simbolar',
  },
  {
    codCiudad: 2677,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Simbolar',
  },
  {
    codCiudad: 918,
    codPcia: 4,
    CP: 5242,
    letra: '',
    nombre: 'SIMBOLAR - DEPTO.TOT',
  },
  {
    codCiudad: 2589,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'Simbolito',
  },
  {
    codCiudad: 822,
    codPcia: 3,
    CP: 4172,
    letra: '',
    nombre: 'SIMOCA',
  },
  {
    codCiudad: 1287,
    codPcia: 4,
    CP: 5220,
    letra: '',
    nombre: 'SINSACATE',
  },
  {
    codCiudad: 2104,
    codPcia: 10,
    CP: 4413,
    letra: '',
    nombre: 'Socompa',
  },
  {
    codCiudad: 2725,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'Solazuti',
  },
  {
    codCiudad: 430,
    codPcia: 13,
    CP: 2107,
    letra: '',
    nombre: 'SOLDINI',
  },
  {
    codCiudad: 2726,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'Soledad',
  },
  {
    codCiudad: 665,
    codPcia: 13,
    CP: 3025,
    letra: '',
    nombre: 'SOLEDAD',
  },
  {
    codCiudad: 3065,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'Soledad',
  },
  {
    codCiudad: 3066,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'Soledani',
  },
  {
    codCiudad: 1767,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Sombrero Negro',
  },
  {
    codCiudad: 1588,
    codPcia: 13,
    CP: 3025,
    letra: '',
    nombre: 'SOUTO MAYOR',
  },
  {
    codCiudad: 500,
    codPcia: 13,
    CP: 2258,
    letra: '',
    nombre: 'STA CLARA DE BNA VIS',
  },
  {
    codCiudad: 735,
    codPcia: 5,
    CP: 3440,
    letra: '',
    nombre: 'STA LUCIA',
  },
  {
    codCiudad: 889,
    codPcia: 4,
    CP: 5133,
    letra: '',
    nombre: 'STA ROSA DE RIO 1RO',
  },
  {
    codCiudad: 689,
    codPcia: 6,
    CP: 3101,
    letra: '',
    nombre: 'STROBEL',
  },
  {
    codCiudad: 1676,
    codPcia: 13,
    CP: 2349,
    letra: '',
    nombre: 'SUARDI',
  },
  {
    codCiudad: 2505,
    codPcia: 10,
    CP: 4440,
    letra: '',
    nombre: 'Sucha Pera',
  },
  {
    codCiudad: 1117,
    codPcia: 2,
    CP: 6612,
    letra: '',
    nombre: 'SUIPACHA',
  },
  {
    codCiudad: 2265,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'Sumalao',
  },
  {
    codCiudad: 3166,
    codPcia: 3,
    CP: 4705,
    letra: '',
    nombre: 'SUMALAO',
  },
  {
    codCiudad: 1656,
    codPcia: 13,
    CP: 2322,
    letra: '',
    nombre: 'SUNCHALES',
  },
  {
    codCiudad: 2661,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Sunchalito',
  },
  {
    codCiudad: 1716,
    codPcia: 14,
    CP: 4350,
    letra: '',
    nombre: 'SUNCHO CORRAL',
  },
  {
    codCiudad: 1881,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'Suri Micuna',
  },
  {
    codCiudad: 2882,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Suri Pintado',
  },
  {
    codCiudad: 3067,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'Suripujio',
  },
  {
    codCiudad: 1899,
    codPcia: 10,
    CP: 4195,
    letra: '',
    nombre: 'Suriyacu',
  },
  {
    codCiudad: 2738,
    codPcia: 10,
    CP: 4533,
    letra: '',
    nombre: 'Tabacal Ingenio',
  },
  {
    codCiudad: 2883,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Tabaco Cimarron',
  },
  {
    codCiudad: 3207,
    codPcia: 5,
    CP: 3421,
    letra: '',
    nombre: 'TABAY',
  },
  {
    codCiudad: 361,
    codPcia: 2,
    CP: 1766,
    letra: '',
    nombre: 'TABLADA',
  },
  {
    codCiudad: 3147,
    codPcia: 6,
    CP: 3111,
    letra: '',
    nombre: 'TABOSSI',
  },
  {
    codCiudad: 2105,
    codPcia: 10,
    CP: 4413,
    letra: '',
    nombre: 'Taca Taca E Fcgb',
  },
  {
    codCiudad: 1363,
    codPcia: 14,
    CP: 3766,
    letra: '',
    nombre: 'TACAÑITAS',
  },
  {
    codCiudad: 2662,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Tacioj',
  },
  {
    codCiudad: 2663,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Taco Esquina',
  },
  {
    codCiudad: 2664,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Taco Pampa',
  },
  {
    codCiudad: 3093,
    codPcia: 10,
    CP: 5235,
    letra: '',
    nombre: 'Taco Pozo',
  },
  {
    codCiudad: 2058,
    codPcia: 10,
    CP: 4409,
    letra: '',
    nombre: 'Tacuara',
  },
  {
    codCiudad: 2213,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'Tacuil',
  },
  {
    codCiudad: 1561,
    codPcia: 13,
    CP: 2324,
    letra: '',
    nombre: 'TACURAL',
  },
  {
    codCiudad: 1616,
    codPcia: 15,
    CP: 4137,
    letra: '',
    nombre: 'TAFI DEL VALLE',
  },
  {
    codCiudad: 805,
    codPcia: 3,
    CP: 4137,
    letra: '',
    nombre: 'TAFI DEL VALLE',
  },
  {
    codCiudad: 1393,
    codPcia: 15,
    CP: 4103,
    letra: '',
    nombre: 'TAFI VIEJO',
  },
  {
    codCiudad: 1792,
    codPcia: 10,
    CP: 4126,
    letra: '',
    nombre: 'Tala',
  },
  {
    codCiudad: 1900,
    codPcia: 10,
    CP: 4195,
    letra: '',
    nombre: 'Tala Bajada',
  },
  {
    codCiudad: 930,
    codPcia: 4,
    CP: 5297,
    letra: '',
    nombre: 'TALA CA',
  },
  {
    codCiudad: 1793,
    codPcia: 10,
    CP: 4126,
    letra: '',
    nombre: 'Tala E R L Llanos',
  },
  {
    codCiudad: 2506,
    codPcia: 10,
    CP: 4440,
    letra: '',
    nombre: 'Tala Muyo',
  },
  {
    codCiudad: 2555,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'Tala Muyo',
  },
  {
    codCiudad: 1815,
    codPcia: 10,
    CP: 4141,
    letra: '',
    nombre: 'Tala Paso',
  },
  {
    codCiudad: 1929,
    codPcia: 10,
    CP: 4200,
    letra: '',
    nombre: 'Tala Pozo',
  },
  {
    codCiudad: 1882,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'Tala Yaco',
  },
  {
    codCiudad: 2333,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'Talapampa',
  },
  {
    codCiudad: 2556,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'Talas',
  },
  {
    codCiudad: 2678,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Talavera',
  },
  {
    codCiudad: 1926,
    codPcia: 10,
    CP: 4198,
    letra: '',
    nombre: 'Tamas Cortadas',
  },
  {
    codCiudad: 1047,
    codPcia: 4,
    CP: 5933,
    letra: '',
    nombre: 'TANCACHA',
  },
  {
    codCiudad: 1144,
    codPcia: 2,
    CP: 7000,
    letra: '',
    nombre: 'TANDIL',
  },
  {
    codCiudad: 1171,
    codPcia: 2,
    CP: 7303,
    letra: '',
    nombre: 'TAPALQUE',
  },
  {
    codCiudad: 1081,
    codPcia: 13,
    CP: 6103,
    letra: '',
    nombre: 'TARRAGONA',
  },
  {
    codCiudad: 2910,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'Tartagal',
  },
  {
    codCiudad: 1526,
    codPcia: 17,
    CP: 9201,
    letra: '',
    nombre: 'TECKA',
  },
  {
    codCiudad: 383,
    codPcia: 2,
    CP: 1834,
    letra: '',
    nombre: 'TEMPERLEY',
  },
  {
    codCiudad: 1067,
    codPcia: 13,
    CP: 6009,
    letra: '',
    nombre: 'TEODELINA',
  },
  {
    codCiudad: 833,
    codPcia: 14,
    CP: 4220,
    letra: '',
    nombre: 'TERMAS DE RIO HONDO',
  },
  {
    codCiudad: 1547,
    codPcia: 4,
    CP: 5927,
    letra: '',
    nombre: 'TICINO',
  },
  {
    codCiudad: 311,
    codPcia: 2,
    CP: 1648,
    letra: '',
    nombre: 'TIGRE',
  },
  {
    codCiudad: 3204,
    codPcia: 7,
    CP: 4624,
    letra: '',
    nombre: 'Tilcara',
  },
  {
    codCiudad: 2293,
    codPcia: 10,
    CP: 4423,
    letra: '',
    nombre: 'Tilian',
  },
  {
    codCiudad: 1006,
    codPcia: 12,
    CP: 5773,
    letra: '',
    nombre: 'TILISARAO',
  },
  {
    codCiudad: 2968,
    codPcia: 10,
    CP: 4600,
    letra: '',
    nombre: 'Tilquiza',
  },
  {
    codCiudad: 792,
    codPcia: 3,
    CP: 4101,
    letra: '',
    nombre: 'TIMBO VIEJO',
  },
  {
    codCiudad: 483,
    codPcia: 13,
    CP: 2204,
    letra: '',
    nombre: 'TIMBUES',
  },
  {
    codCiudad: 1659,
    codPcia: 14,
    CP: 3743,
    letra: '',
    nombre: 'TINTINA',
  },
  {
    codCiudad: 1816,
    codPcia: 10,
    CP: 4141,
    letra: '',
    nombre: 'Tio Franco',
  },
  {
    codCiudad: 1049,
    codPcia: 4,
    CP: 5936,
    letra: '',
    nombre: 'TIO PUJIO',
  },
  {
    codCiudad: 2334,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'Tipa Sola',
  },
  {
    codCiudad: 2987,
    codPcia: 10,
    CP: 4633,
    letra: '',
    nombre: 'Tipayoc',
  },
  {
    codCiudad: 2988,
    codPcia: 10,
    CP: 4633,
    letra: '',
    nombre: 'Titicoite',
  },
  {
    codCiudad: 3199,
    codPcia: 19,
    CP: 6303,
    letra: '',
    nombre: 'TOAY',
  },
  {
    codCiudad: 2949,
    codPcia: 10,
    CP: 4564,
    letra: '',
    nombre: 'Tobantirenda',
  },
  {
    codCiudad: 2106,
    codPcia: 10,
    CP: 4413,
    letra: '',
    nombre: 'Tolar Chico',
  },
  {
    codCiudad: 2107,
    codPcia: 10,
    CP: 4413,
    letra: '',
    nombre: 'Tolar Grande',
  },
  {
    codCiudad: 2679,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Tolloche',
  },
  {
    codCiudad: 1823,
    codPcia: 10,
    CP: 4154,
    letra: '',
    nombre: 'Tolombon',
  },
  {
    codCiudad: 2214,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'Tomuco',
  },
  {
    codCiudad: 2159,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Tonco',
  },
  {
    codCiudad: 2911,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'Tonono',
  },
  {
    codCiudad: 3080,
    codPcia: 10,
    CP: 4653,
    letra: '',
    nombre: 'Toquero',
  },
  {
    codCiudad: 1469,
    codPcia: 2,
    CP: 8160,
    letra: '',
    nombre: 'TORNQUIST',
  },
  {
    codCiudad: 2059,
    codPcia: 10,
    CP: 4409,
    letra: '',
    nombre: 'Toro',
  },
  {
    codCiudad: 2665,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Toro Pampa',
  },
  {
    codCiudad: 2160,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Toro Yaco',
  },
  {
    codCiudad: 3025,
    codPcia: 10,
    CP: 4644,
    letra: '',
    nombre: 'Toroyoc',
  },
  {
    codCiudad: 1131,
    codPcia: 2,
    CP: 6703,
    letra: '',
    nombre: 'TORRES',
  },
  {
    codCiudad: 530,
    codPcia: 13,
    CP: 2512,
    letra: '',
    nombre: 'TORTUGAS',
  },
  {
    codCiudad: 323,
    codPcia: 2,
    CP: 1667,
    letra: '',
    nombre: 'TORTUGUITAS',
  },
  {
    codCiudad: 2405,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'Torzalito',
  },
  {
    codCiudad: 1086,
    codPcia: 4,
    CP: 6141,
    letra: '',
    nombre: 'TOSQUITA',
  },
  {
    codCiudad: 1630,
    codPcia: 13,
    CP: 3060,
    letra: '',
    nombre: 'TOSTADO',
  },
  {
    codCiudad: 2634,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'Totoral',
  },
  {
    codCiudad: 461,
    codPcia: 13,
    CP: 2144,
    letra: '',
    nombre: 'TOTORAS',
  },
  {
    codCiudad: 1817,
    codPcia: 10,
    CP: 4141,
    letra: '',
    nombre: 'Totorilla',
  },
  {
    codCiudad: 1818,
    codPcia: 10,
    CP: 4141,
    letra: '',
    nombre: 'Totoritas',
  },
  {
    codCiudad: 3118,
    codPcia: 13,
    CP: 2456,
    letra: '',
    nombre: 'TRAIL',
  },
  {
    codCiudad: 801,
    codPcia: 3,
    CP: 4124,
    letra: '',
    nombre: 'TRANCAS',
  },
  {
    codCiudad: 1381,
    codPcia: 15,
    CP: 4124,
    letra: '',
    nombre: 'TRANCAS',
  },
  {
    codCiudad: 2841,
    codPcia: 10,
    CP: 4552,
    letra: '',
    nombre: 'Tranquitas',
  },
  {
    codCiudad: 1213,
    codPcia: 17,
    CP: 9100,
    letra: '',
    nombre: 'TRELEW',
  },
  {
    codCiudad: 1368,
    codPcia: 2,
    CP: 6400,
    letra: '',
    nombre: 'TRENQUE LAUQUEN',
  },
  {
    codCiudad: 1204,
    codPcia: 21,
    CP: 8340,
    letra: '',
    nombre: 'TRENQUE LAUQUEN',
  },
  {
    codCiudad: 2266,
    codPcia: 10,
    CP: 4421,
    letra: '',
    nombre: 'Tres Acequias',
  },
  {
    codCiudad: 1089,
    codPcia: 1,
    CP: 6231,
    letra: '',
    nombre: 'TRES ALGARROBOS',
  },
  {
    codCiudad: 1179,
    codPcia: 2,
    CP: 7500,
    letra: '',
    nombre: 'TRES ARROYOS',
  },
  {
    codCiudad: 3193,
    codPcia: 5,
    CP: 3220,
    letra: '',
    nombre: 'TRES BOCAS',
  },
  {
    codCiudad: 1703,
    codPcia: 20,
    CP: 3353,
    letra: '',
    nombre: 'TRES CAPONES',
  },
  {
    codCiudad: 1946,
    codPcia: 10,
    CP: 4400,
    letra: '',
    nombre: 'Tres Cerritos',
  },
  {
    codCiudad: 2060,
    codPcia: 10,
    CP: 4409,
    letra: '',
    nombre: 'Tres Cruces',
  },
  {
    codCiudad: 2335,
    codPcia: 10,
    CP: 4425,
    letra: '',
    nombre: 'Tres Cruces',
  },
  {
    codCiudad: 776,
    codPcia: 16,
    CP: 3703,
    letra: '',
    nombre: 'TRES ISLETAS',
  },
  {
    codCiudad: 1434,
    codPcia: 23,
    CP: 9301,
    letra: '',
    nombre: 'TRES LAGOS',
  },
  {
    codCiudad: 3196,
    codPcia: 14,
    CP: 3062,
    letra: '',
    nombre: 'TRES LAGUNAS',
  },
  {
    codCiudad: 2989,
    codPcia: 10,
    CP: 4633,
    letra: '',
    nombre: 'Tres Morros',
  },
  {
    codCiudad: 1573,
    codPcia: 2,
    CP: 8162,
    letra: '',
    nombre: 'TRES PICOS',
  },
  {
    codCiudad: 2796,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'Tres Pozos',
  },
  {
    codCiudad: 2727,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'Tres Pozos',
  },
  {
    codCiudad: 1139,
    codPcia: 2,
    CP: 6727,
    letra: '',
    nombre: 'TRES SARGENTOS',
  },
  {
    codCiudad: 2406,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'Tres Yuchanes',
  },
  {
    codCiudad: 1473,
    codPcia: 17,
    CP: 9203,
    letra: '',
    nombre: 'TREVELIN',
  },
  {
    codCiudad: 2161,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Trigal',
  },
  {
    codCiudad: 3068,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'Trigo Huayco',
  },
  {
    codCiudad: 813,
    codPcia: 3,
    CP: 4151,
    letra: '',
    nombre: 'TRINIDAD',
  },
  {
    codCiudad: 370,
    codPcia: 2,
    CP: 1806,
    letra: '',
    nombre: 'TRISTAN SUAREZ',
  },
  {
    codCiudad: 1104,
    codPcia: 2,
    CP: 6501,
    letra: '',
    nombre: 'TROPEZON',
  },
  {
    codCiudad: 3069,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'Trusuca',
  },
  {
    codCiudad: 1768,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Tte Gral R N Fra',
  },
  {
    codCiudad: 772,
    codPcia: 18,
    CP: 3611,
    letra: '',
    nombre: 'TTE. GRAL. J C SANCH',
  },
  {
    codCiudad: 1241,
    codPcia: 4,
    CP: 5286,
    letra: '',
    nombre: 'TUCLAME',
  },
  {
    codCiudad: 3070,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'Tuctuca',
  },
  {
    codCiudad: 3026,
    codPcia: 10,
    CP: 4644,
    letra: '',
    nombre: 'Tuite',
  },
  {
    codCiudad: 2635,
    codPcia: 10,
    CP: 4449,
    letra: '',
    nombre: 'Tunalito',
  },
  {
    codCiudad: 2557,
    codPcia: 10,
    CP: 4446,
    letra: '',
    nombre: 'Tunalito',
  },
  {
    codCiudad: 1322,
    codPcia: 9,
    CP: 5560,
    letra: '',
    nombre: 'TUNUYAN',
  },
  {
    codCiudad: 1425,
    codPcia: 9,
    CP: 5561,
    letra: '',
    nombre: 'TUPUNGATO',
  },
  {
    codCiudad: 2912,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'Tuyunti',
  },
  {
    codCiudad: 2108,
    codPcia: 10,
    CP: 4413,
    letra: '',
    nombre: 'U Embarcadero Fcgb',
  },
  {
    codCiudad: 1510,
    codPcia: 6,
    CP: 3287,
    letra: '',
    nombre: 'UBAJAY',
  },
  {
    codCiudad: 589,
    codPcia: 4,
    CP: 2677,
    letra: '',
    nombre: 'UCACHA',
  },
  {
    codCiudad: 2990,
    codPcia: 10,
    CP: 4633,
    letra: '',
    nombre: 'Uchogol',
  },
  {
    codCiudad: 2991,
    codPcia: 10,
    CP: 4633,
    letra: '',
    nombre: 'Uchuyoc',
  },
  {
    codCiudad: 1685,
    codPcia: 2,
    CP: 7151,
    letra: '',
    nombre: 'UDAQUIOLA',
  },
  {
    codCiudad: 1364,
    codPcia: 11,
    CP: 5409,
    letra: '',
    nombre: 'ULLUM',
  },
  {
    codCiudad: 878,
    codPcia: 4,
    CP: 5109,
    letra: '',
    nombre: 'UNQUILLO',
  },
  {
    codCiudad: 1108,
    codPcia: 2,
    CP: 6553,
    letra: '',
    nombre: 'URDAMPILLETA',
  },
  {
    codCiudad: 1312,
    codPcia: 6,
    CP: 2826,
    letra: '',
    nombre: 'URDINARRAÍN',
  },
  {
    codCiudad: 601,
    codPcia: 2,
    CP: 2718,
    letra: '',
    nombre: 'URQUIZA',
  },
  {
    codCiudad: 2815,
    codPcia: 10,
    CP: 4542,
    letra: '',
    nombre: 'Urundel',
  },
  {
    codCiudad: 1245,
    codPcia: 24,
    CP: 9410,
    letra: '',
    nombre: 'USHUAIA',
  },
  {
    codCiudad: 1483,
    codPcia: 9,
    CP: 5545,
    letra: '',
    nombre: 'USPALLATA',
  },
  {
    codCiudad: 1033,
    codPcia: 4,
    CP: 5885,
    letra: '',
    nombre: 'V DE LAS ROSAS',
  },
  {
    codCiudad: 921,
    codPcia: 4,
    CP: 5248,
    letra: '',
    nombre: 'V DE M DEL RIO SECO',
  },
  {
    codCiudad: 2913,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'V General Guemes',
  },
  {
    codCiudad: 3104,
    codPcia: 10,
    CP: 5236,
    letra: '',
    nombre: 'V General Mitre',
  },
  {
    codCiudad: 2407,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'V Mayor Zabaleta',
  },
  {
    codCiudad: 3090,
    codPcia: 10,
    CP: 5233,
    letra: '',
    nombre: 'V R Del Saladillo',
  },
  {
    codCiudad: 674,
    codPcia: 13,
    CP: 3046,
    letra: '',
    nombre: 'V SARALEGUI',
  },
  {
    codCiudad: 969,
    codPcia: 9,
    CP: 5521,
    letra: '',
    nombre: 'V.NUEVA DE GUAYMALLE',
  },
  {
    codCiudad: 1203,
    codPcia: 22,
    CP: 8336,
    letra: '',
    nombre: 'VA. REGGINA',
  },
  {
    codCiudad: 1769,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Vaca Perdida',
  },
  {
    codCiudad: 2728,
    codPcia: 10,
    CP: 4530,
    letra: '',
    nombre: 'Vado Hondo',
  },
  {
    codCiudad: 1128,
    codPcia: 2,
    CP: 6667,
    letra: '',
    nombre: 'VALDES (25 DE MAYO)',
  },
  {
    codCiudad: 376,
    codPcia: 2,
    CP: 1822,
    letra: '',
    nombre: 'VALENTIN ALSINA',
  },
  {
    codCiudad: 2992,
    codPcia: 10,
    CP: 4633,
    letra: '',
    nombre: 'Valle Delgado',
  },
  {
    codCiudad: 2162,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Valle Encantado',
  },
  {
    codCiudad: 1249,
    codPcia: 4,
    CP: 5168,
    letra: '',
    nombre: 'VALLE HERMOSO',
  },
  {
    codCiudad: 1255,
    codPcia: 3,
    CP: 4707,
    letra: '',
    nombre: 'VALLE VIEJO',
  },
  {
    codCiudad: 1844,
    codPcia: 10,
    CP: 4191,
    letra: '',
    nombre: 'Vaqueria',
  },
  {
    codCiudad: 2408,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'Vaqueria',
  },
  {
    codCiudad: 1970,
    codPcia: 10,
    CP: 4401,
    letra: '',
    nombre: 'Vaqueros',
  },
  {
    codCiudad: 1455,
    codPcia: 2,
    CP: 6030,
    letra: '',
    nombre: 'VEDIA',
  },
  {
    codCiudad: 2109,
    codPcia: 10,
    CP: 4413,
    letra: '',
    nombre: 'Vega De Arizaro',
  },
  {
    codCiudad: 1127,
    codPcia: 2,
    CP: 6660,
    letra: '',
    nombre: 'VEINTICINCO DE MAYO',
  },
  {
    codCiudad: 990,
    codPcia: 9,
    CP: 5615,
    letra: '',
    nombre: 'VEINTICINCO DE MAYO',
  },
  {
    codCiudad: 1971,
    codPcia: 10,
    CP: 4401,
    letra: '',
    nombre: 'Velardes',
  },
  {
    codCiudad: 559,
    codPcia: 13,
    CP: 2600,
    letra: '',
    nombre: 'VENADO TUERTO',
  },
  {
    codCiudad: 2666,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Vencida',
  },
  {
    codCiudad: 756,
    codPcia: 13,
    CP: 3550,
    letra: '',
    nombre: 'VERA',
  },
  {
    codCiudad: 2507,
    codPcia: 10,
    CP: 4440,
    letra: '',
    nombre: 'Vera Cruz',
  },
  {
    codCiudad: 679,
    codPcia: 13,
    CP: 3054,
    letra: '',
    nombre: 'VERA Y PINTADO',
  },
  {
    codCiudad: 3160,
    codPcia: 2,
    CP: 7135,
    letra: '',
    nombre: 'VERGARA',
  },
  {
    codCiudad: 416,
    codPcia: 2,
    CP: 1917,
    letra: '',
    nombre: 'VERONICA',
  },
  {
    codCiudad: 2409,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'Vertientes S Rita',
  },
  {
    codCiudad: 2939,
    codPcia: 10,
    CP: 4562,
    letra: '',
    nombre: 'Vespucio',
  },
  {
    codCiudad: 3001,
    codPcia: 10,
    CP: 4634,
    letra: '',
    nombre: 'Veta Mina Aguilar',
  },
  {
    codCiudad: 692,
    codPcia: 6,
    CP: 3109,
    letra: '',
    nombre: 'VIALE',
  },
  {
    codCiudad: 1326,
    codPcia: 4,
    CP: 2671,
    letra: '',
    nombre: 'VIAMONTE',
  },
  {
    codCiudad: 371,
    codPcia: 2,
    CP: 1808,
    letra: '',
    nombre: 'VICENTE CASARES',
  },
  {
    codCiudad: 305,
    codPcia: 2,
    CP: 1638,
    letra: '',
    nombre: 'VICENTE LOPEZ',
  },
  {
    codCiudad: 762,
    codPcia: 13,
    CP: 3563,
    letra: '',
    nombre: 'VICTOR MANUEL',
  },
  {
    codCiudad: 309,
    codPcia: 2,
    CP: 1644,
    letra: '',
    nombre: 'VICTORIA',
  },
  {
    codCiudad: 699,
    codPcia: 6,
    CP: 3153,
    letra: '',
    nombre: 'VICTORIA',
  },
  {
    codCiudad: 2797,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'Victorica',
  },
  {
    codCiudad: 1441,
    codPcia: 4,
    CP: 6140,
    letra: '',
    nombre: 'VICUÑA MACKENNA',
  },
  {
    codCiudad: 675,
    codPcia: 13,
    CP: 3048,
    letra: '',
    nombre: 'VIDELA',
  },
  {
    codCiudad: 1209,
    codPcia: 22,
    CP: 8500,
    letra: '',
    nombre: 'VIEDMA',
  },
  {
    codCiudad: 2590,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'Vieja Pozo',
  },
  {
    codCiudad: 799,
    codPcia: 3,
    CP: 4117,
    letra: '',
    nombre: 'VILLA A GUZMAN - CRU',
  },
  {
    codCiudad: 955,
    codPcia: 11,
    CP: 5427,
    letra: '',
    nombre: 'VILLA ABERASTAIN',
  },
  {
    codCiudad: 287,
    codPcia: 2,
    CP: 1607,
    letra: '',
    nombre: 'VILLA ADELINA',
  },
  {
    codCiudad: 2993,
    codPcia: 10,
    CP: 4633,
    letra: '',
    nombre: 'Villa Alem',
  },
  {
    codCiudad: 876,
    codPcia: 4,
    CP: 5105,
    letra: '',
    nombre: 'VILLA ALLENDE',
  },
  {
    codCiudad: 425,
    codPcia: 13,
    CP: 2101,
    letra: '',
    nombre: 'VILLA AMELIA',
  },
  {
    codCiudad: 1598,
    codPcia: 13,
    CP: 3583,
    letra: '',
    nombre: 'VILLA ANA',
  },
  {
    codCiudad: 754,
    codPcia: 16,
    CP: 3540,
    letra: '',
    nombre: 'VILLA ANGELA',
  },
  {
    codCiudad: 1653,
    codPcia: 4,
    CP: 5189,
    letra: '',
    nombre: 'VILLA ANISACATE',
  },
  {
    codCiudad: 1048,
    codPcia: 4,
    CP: 5935,
    letra: '',
    nombre: 'VILLA ASCASUBI',
  },
  {
    codCiudad: 1315,
    codPcia: 4,
    CP: 5935,
    letra: '',
    nombre: 'VILLA ASCASUBI',
  },
  {
    codCiudad: 843,
    codPcia: 14,
    CP: 4317,
    letra: '',
    nombre: 'VILLA ATAMISQUI',
  },
  {
    codCiudad: 1841,
    codPcia: 10,
    CP: 4190,
    letra: '',
    nombre: 'Villa Aurelia',
  },
  {
    codCiudad: 1559,
    codPcia: 11,
    CP: 0,
    letra: '',
    nombre: 'VILLA AURORA',
  },
  {
    codCiudad: 315,
    codPcia: 2,
    CP: 1653,
    letra: '',
    nombre: 'VILLA BALLESTER',
  },
  {
    codCiudad: 1289,
    codPcia: 4,
    CP: 5147,
    letra: '',
    nombre: 'VILLA BELGRANO',
  },
  {
    codCiudad: 1294,
    codPcia: 16,
    CP: 3545,
    letra: '',
    nombre: 'Villa Berthet',
  },
  {
    codCiudad: 330,
    codPcia: 2,
    CP: 1682,
    letra: '',
    nombre: 'VILLA BOSCH',
  },
  {
    codCiudad: 374,
    codPcia: 2,
    CP: 1822,
    letra: '',
    nombre: 'VILLA CARAZA',
  },
  {
    codCiudad: 895,
    codPcia: 4,
    CP: 5152,
    letra: '',
    nombre: 'VILLA CARLOS PAZ',
  },
  {
    codCiudad: 563,
    codPcia: 13,
    CP: 2607,
    letra: '',
    nombre: 'VILLA CAÑAS',
  },
  {
    codCiudad: 364,
    codPcia: 2,
    CP: 1772,
    letra: '',
    nombre: 'VILLA CELINA',
  },
  {
    codCiudad: 1674,
    codPcia: 6,
    CP: 3252,
    letra: '',
    nombre: 'VILLA CLARA',
  },
  {
    codCiudad: 1632,
    codPcia: 4,
    CP: 2433,
    letra: '',
    nombre: 'VILLA CONCEPCION DEL TIO',
  },
  {
    codCiudad: 638,
    codPcia: 13,
    CP: 2919,
    letra: '',
    nombre: 'VILLA CONSTITUCION',
  },
  {
    codCiudad: 1883,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'Villa Corta',
  },
  {
    codCiudad: 1317,
    codPcia: 4,
    CP: 5891,
    letra: '',
    nombre: 'VILLA CURA BROCHERO',
  },
  {
    codCiudad: 1362,
    codPcia: 4,
    CP: 5248,
    letra: '',
    nombre: 'VILLA DE MARIA DEL RIO SECO',
  },
  {
    codCiudad: 928,
    codPcia: 4,
    CP: 5284,
    letra: '',
    nombre: 'VILLA DE SOTO',
  },
  {
    codCiudad: 1026,
    codPcia: 4,
    CP: 5862,
    letra: '',
    nombre: 'VILLA DEL DIQUE',
  },
  {
    codCiudad: 1543,
    codPcia: 2,
    CP: 8109,
    letra: '',
    nombre: 'VILLA DEL MAR',
  },
  {
    codCiudad: 1027,
    codPcia: 4,
    CP: 5864,
    letra: '',
    nombre: 'VILLA DEL PARQUE',
  },
  {
    codCiudad: 1054,
    codPcia: 4,
    CP: 5963,
    letra: '',
    nombre: 'VILLA DEL ROSARIO',
  },
  {
    codCiudad: 375,
    codPcia: 1,
    CP: 1822,
    letra: '',
    nombre: 'VILLA DIAMANTE - LAN',
  },
  {
    codCiudad: 447,
    codPcia: 13,
    CP: 2124,
    letra: '',
    nombre: 'VILLA DIEGO',
  },
  {
    codCiudad: 574,
    codPcia: 13,
    CP: 2631,
    letra: '',
    nombre: 'VILLA DIVISA DE MAYO',
  },
  {
    codCiudad: 865,
    codPcia: 3,
    CP: 4707,
    letra: '',
    nombre: 'VILLA DOLORES',
  },
  {
    codCiudad: 1028,
    codPcia: 4,
    CP: 5870,
    letra: '',
    nombre: 'VILLA DOLORES',
  },
  {
    codCiudad: 398,
    codPcia: 2,
    CP: 1874,
    letra: '',
    nombre: 'VILLA DOMINICO',
  },
  {
    codCiudad: 1608,
    codPcia: 4,
    CP: 5194,
    letra: '',
    nombre: 'VILLA EL QUILINZO',
  },
  {
    codCiudad: 1542,
    codPcia: 6,
    CP: 3265,
    letra: '',
    nombre: 'VILLA ELISA',
  },
  {
    codCiudad: 408,
    codPcia: 2,
    CP: 1894,
    letra: '',
    nombre: 'VILLA ELISA',
  },
  {
    codCiudad: 526,
    codPcia: 13,
    CP: 2503,
    letra: '',
    nombre: 'VILLA ELOISA',
  },
  {
    codCiudad: 1485,
    codPcia: 18,
    CP: 3526,
    letra: '',
    nombre: 'VILLA ESCOLAR',
  },
  {
    codCiudad: 1492,
    codPcia: 18,
    CP: 3526,
    letra: '',
    nombre: 'VILLA ESCOLAR FSA',
  },
  {
    codCiudad: 1631,
    codPcia: 4,
    CP: 5012,
    letra: '',
    nombre: 'VILLA ESQUIU',
  },
  {
    codCiudad: 2294,
    codPcia: 10,
    CP: 4423,
    letra: '',
    nombre: 'Villa Fanny',
  },
  {
    codCiudad: 1133,
    codPcia: 2,
    CP: 6706,
    letra: '',
    nombre: 'VILLA FLANDRIA',
  },
  {
    codCiudad: 446,
    codPcia: 13,
    CP: 2124,
    letra: '',
    nombre: 'VILLA GDOR GALVEZ',
  },
  {
    codCiudad: 1665,
    codPcia: 4,
    CP: 5194,
    letra: '',
    nombre: 'VILLA GENERAL BELGRANO',
  },
  {
    codCiudad: 1227,
    codPcia: 2,
    CP: 2912,
    letra: '',
    nombre: 'VILLA GENERAL SAVIO',
  },
  {
    codCiudad: 1157,
    codPcia: 2,
    CP: 7165,
    letra: '',
    nombre: 'VILLA GESELL',
  },
  {
    codCiudad: 900,
    codPcia: 4,
    CP: 5176,
    letra: '',
    nombre: 'VILLA GIARDINO',
  },
  {
    codCiudad: 3105,
    codPcia: 13,
    CP: 2124,
    letra: '',
    nombre: 'Villa Gobernador Galvez',
  },
  {
    codCiudad: 916,
    codPcia: 4,
    CP: 5236,
    letra: '',
    nombre: 'VILLA GRAL MITRE',
  },
  {
    codCiudad: 3153,
    codPcia: 18,
    CP: 3615,
    letra: '',
    nombre: 'VILLA GRAL. MANUEL BELGRANO',
  },
  {
    codCiudad: 1930,
    codPcia: 10,
    CP: 4200,
    letra: '',
    nombre: 'Villa Grimanesa',
  },
  {
    codCiudad: 3157,
    codPcia: 6,
    CP: 3127,
    letra: '',
    nombre: 'VILLA HERNANDARIAS',
  },
  {
    codCiudad: 350,
    codPcia: 2,
    CP: 1752,
    letra: '',
    nombre: 'VILLA INSUPERABLE',
  },
  {
    codCiudad: 954,
    codPcia: 11,
    CP: 5425,
    letra: '',
    nombre: 'VILLA KRAUSE',
  },
  {
    codCiudad: 1415,
    codPcia: 21,
    CP: 8407,
    letra: '',
    nombre: 'VILLA LA ANGOSTURA',
  },
  {
    codCiudad: 1552,
    codPcia: 12,
    CP: 5883,
    letra: '',
    nombre: 'VILLA LARCA',
  },
  {
    codCiudad: 1643,
    codPcia: 2,
    CP: 2761,
    letra: '',
    nombre: 'VILLA LIA',
  },
  {
    codCiudad: 1997,
    codPcia: 10,
    CP: 4403,
    letra: '',
    nombre: 'Villa Los Tarcos',
  },
  {
    codCiudad: 325,
    codPcia: 2,
    CP: 1672,
    letra: '',
    nombre: 'VILLA LYNCH',
  },
  {
    codCiudad: 362,
    codPcia: 2,
    CP: 1768,
    letra: '',
    nombre: 'VILLA MADERO',
  },
  {
    codCiudad: 1701,
    codPcia: 6,
    CP: 3272,
    letra: '',
    nombre: 'VILLA MANTERO',
  },
  {
    codCiudad: 1036,
    codPcia: 4,
    CP: 5900,
    letra: '',
    nombre: 'VILLA MARIA',
  },
  {
    codCiudad: 285,
    codPcia: 2,
    CP: 1603,
    letra: '',
    nombre: 'VILLA MARTELLI',
  },
  {
    codCiudad: 2680,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Villa Matoque',
  },
  {
    codCiudad: 946,
    codPcia: 8,
    CP: 5313,
    letra: '',
    nombre: 'VILLA MAZAN',
  },
  {
    codCiudad: 999,
    codPcia: 12,
    CP: 5730,
    letra: '',
    nombre: 'VILLA MERCEDES',
  },
  {
    codCiudad: 1581,
    codPcia: 13,
    CP: 3061,
    letra: '',
    nombre: 'VILLA MINETTI',
  },
  {
    codCiudad: 472,
    codPcia: 13,
    CP: 2175,
    letra: '',
    nombre: 'VILLA MUGUETA',
  },
  {
    codCiudad: 1037,
    codPcia: 4,
    CP: 5903,
    letra: '',
    nombre: 'VILLA NUEVA',
  },
  {
    codCiudad: 1302,
    codPcia: 4,
    CP: 5903,
    letra: '',
    nombre: 'VILLA NUEVA',
  },
  {
    codCiudad: 766,
    codPcia: 13,
    CP: 3580,
    letra: '',
    nombre: 'VILLA OCAMPO',
  },
  {
    codCiudad: 3203,
    codPcia: 5,
    CP: 3486,
    letra: '',
    nombre: 'VILLA OLIVARI',
  },
  {
    codCiudad: 1715,
    codPcia: 6,
    CP: 2823,
    letra: '',
    nombre: 'VILLA PARANACITO',
  },
  {
    codCiudad: 2798,
    codPcia: 10,
    CP: 4535,
    letra: '',
    nombre: 'Villa Petrona',
  },
  {
    codCiudad: 807,
    codPcia: 3,
    CP: 4144,
    letra: '',
    nombre: 'VILLA QUINTERNO',
  },
  {
    codCiudad: 633,
    codPcia: 2,
    CP: 2914,
    letra: '',
    nombre: 'VILLA RAMALLO',
  },
  {
    codCiudad: 1442,
    codPcia: 4,
    CP: 5101,
    letra: '',
    nombre: 'VILLA RETIRO',
  },
  {
    codCiudad: 3192,
    codPcia: 16,
    CP: 3703,
    letra: '',
    nombre: 'VILLA RIO BERMEJITO',
  },
  {
    codCiudad: 3127,
    codPcia: 14,
    CP: 4301,
    letra: '',
    nombre: 'VILLA ROBLES',
  },
  {
    codCiudad: 1380,
    codPcia: 2,
    CP: 7101,
    letra: '',
    nombre: 'VILLA ROCH',
  },
  {
    codCiudad: 301,
    codPcia: 2,
    CP: 1631,
    letra: '',
    nombre: 'VILLA ROSA',
  },
  {
    codCiudad: 1132,
    codPcia: 2,
    CP: 6705,
    letra: '',
    nombre: 'VILLA RUIZ',
  },
  {
    codCiudad: 2914,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'Villa Saavedra',
  },
  {
    codCiudad: 1553,
    codPcia: 10,
    CP: 4401,
    letra: '',
    nombre: 'VILLA SAN LORENZO',
  },
  {
    codCiudad: 832,
    codPcia: 14,
    CP: 4208,
    letra: '',
    nombre: 'VILLA SAN MARTIN',
  },
  {
    codCiudad: 980,
    codPcia: 9,
    CP: 5570,
    letra: '',
    nombre: 'VILLA SAN MARTIN',
  },
  {
    codCiudad: 738,
    codPcia: 5,
    CP: 3463,
    letra: '',
    nombre: 'VILLA SAN MARTIN',
  },
  {
    codCiudad: 938,
    codPcia: 8,
    CP: 5301,
    letra: '',
    nombre: 'VILLA SANAGASTA',
  },
  {
    codCiudad: 1091,
    codPcia: 4,
    CP: 6273,
    letra: '',
    nombre: 'VILLA SARMIENTO',
  },
  {
    codCiudad: 2061,
    codPcia: 10,
    CP: 4409,
    letra: '',
    nombre: 'Villa Sola',
  },
  {
    codCiudad: 1794,
    codPcia: 10,
    CP: 4127,
    letra: '',
    nombre: 'Villa Trancas',
  },
  {
    codCiudad: 3152,
    codPcia: 13,
    CP: 2345,
    letra: '',
    nombre: 'VILLA TRINIDAD',
  },
  {
    codCiudad: 1314,
    codPcia: 4,
    CP: 5203,
    letra: '',
    nombre: 'VILLA TULUMBA',
  },
  {
    codCiudad: 3170,
    codPcia: 6,
    CP: 3113,
    letra: '',
    nombre: 'VILLA URQUIZA',
  },
  {
    codCiudad: 711,
    codPcia: 6,
    CP: 3240,
    letra: '',
    nombre: 'VILLAGUAY',
  },
  {
    codCiudad: 345,
    codPcia: 2,
    CP: 1731,
    letra: '',
    nombre: 'VILLARS',
  },
  {
    codCiudad: 2163,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Villitas',
  },
  {
    codCiudad: 2667,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Vinal Macho',
  },
  {
    codCiudad: 2668,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Vinal Pozo',
  },
  {
    codCiudad: 2669,
    codPcia: 10,
    CP: 4452,
    letra: '',
    nombre: 'Vinalito',
  },
  {
    codCiudad: 2591,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'Viqal Pozo',
  },
  {
    codCiudad: 1541,
    codPcia: 5,
    CP: 3342,
    letra: '',
    nombre: 'VIRASORO',
  },
  {
    codCiudad: 2481,
    codPcia: 10,
    CP: 4434,
    letra: '',
    nombre: 'Virgilio Tedin',
  },
  {
    codCiudad: 3210,
    codPcia: 13,
    CP: 2311,
    letra: '',
    nombre: 'VIRGINIA',
  },
  {
    codCiudad: 2031,
    codPcia: 10,
    CP: 4407,
    letra: '',
    nombre: 'Virrey Toledo',
  },
  {
    codCiudad: 3071,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'Viscachani',
  },
  {
    codCiudad: 1884,
    codPcia: 10,
    CP: 4193,
    letra: '',
    nombre: 'Vizcacheral',
  },
  {
    codCiudad: 3027,
    codPcia: 10,
    CP: 4644,
    letra: '',
    nombre: 'Vizcarra',
  },
  {
    codCiudad: 1031,
    codPcia: 4,
    CP: 5877,
    letra: '',
    nombre: 'VLLA. YACANTO',
  },
  {
    codCiudad: 2884,
    codPcia: 10,
    CP: 4554,
    letra: '',
    nombre: 'Vlta De Las Tobas',
  },
  {
    codCiudad: 2215,
    codPcia: 10,
    CP: 4419,
    letra: '',
    nombre: 'Volcan Azufre',
  },
  {
    codCiudad: 2994,
    codPcia: 10,
    CP: 4633,
    letra: '',
    nombre: 'Volcan Higuera',
  },
  {
    codCiudad: 2995,
    codPcia: 10,
    CP: 4633,
    letra: '',
    nombre: 'Volcan Higueras',
  },
  {
    codCiudad: 582,
    codPcia: 4,
    CP: 2655,
    letra: '',
    nombre: 'W ESCALANTE',
  },
  {
    codCiudad: 1125,
    codPcia: 2,
    CP: 6646,
    letra: '',
    nombre: 'WARNES',
  },
  {
    codCiudad: 3112,
    codPcia: 4,
    CP: 6144,
    letra: '',
    nombre: 'WASHINGTON',
  },
  {
    codCiudad: 2592,
    codPcia: 10,
    CP: 4448,
    letra: '',
    nombre: 'Weisburg',
  },
  {
    codCiudad: 604,
    codPcia: 13,
    CP: 2722,
    letra: '',
    nombre: 'WHEELWRIGHT',
  },
  {
    codCiudad: 399,
    codPcia: 2,
    CP: 1875,
    letra: '',
    nombre: 'WILDE',
  },
  {
    codCiudad: 1663,
    codPcia: 19,
    CP: 6313,
    letra: '',
    nombre: 'WINIFREDA',
  },
  {
    codCiudad: 2752,
    codPcia: 10,
    CP: 4534,
    letra: '',
    nombre: 'Yacara',
  },
  {
    codCiudad: 2915,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'Yacay',
  },
  {
    codCiudad: 2164,
    codPcia: 10,
    CP: 4415,
    letra: '',
    nombre: 'Yacera',
  },
  {
    codCiudad: 2916,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'Yacimiento Tonono',
  },
  {
    codCiudad: 2369,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'Yacochuya',
  },
  {
    codCiudad: 1972,
    codPcia: 10,
    CP: 4401,
    letra: '',
    nombre: 'Yacones',
  },
  {
    codCiudad: 3002,
    codPcia: 10,
    CP: 4634,
    letra: '',
    nombre: 'Yacoraite',
  },
  {
    codCiudad: 2950,
    codPcia: 10,
    CP: 4564,
    letra: '',
    nombre: 'Yacuy',
  },
  {
    codCiudad: 1627,
    codPcia: 22,
    CP: 8534,
    letra: '',
    nombre: 'YAMINUE',
  },
  {
    codCiudad: 2370,
    codPcia: 10,
    CP: 4427,
    letra: '',
    nombre: 'Yanchuya',
  },
  {
    codCiudad: 710,
    codPcia: 5,
    CP: 3231,
    letra: '',
    nombre: 'YAPEYU',
  },
  {
    codCiudad: 2917,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'Yariguarenda',
  },
  {
    codCiudad: 2410,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'Yasquiasme',
  },
  {
    codCiudad: 1819,
    codPcia: 10,
    CP: 4141,
    letra: '',
    nombre: 'Yasyamayo',
  },
  {
    codCiudad: 2508,
    codPcia: 10,
    CP: 4440,
    letra: '',
    nombre: 'Yatasto',
  },
  {
    codCiudad: 3072,
    codPcia: 10,
    CP: 4651,
    letra: '',
    nombre: 'Yavi Chico',
  },
  {
    codCiudad: 1435,
    codPcia: 15,
    CP: 4107,
    letra: '',
    nombre: 'YERBA BUENA',
  },
  {
    codCiudad: 795,
    codPcia: 3,
    CP: 4107,
    letra: '',
    nombre: 'YERBA BUENA',
  },
  {
    codCiudad: 2805,
    codPcia: 10,
    CP: 4537,
    letra: '',
    nombre: 'Yuchan',
  },
  {
    codCiudad: 1770,
    codPcia: 10,
    CP: 3636,
    letra: '',
    nombre: 'Yunca',
  },
  {
    codCiudad: 2918,
    codPcia: 10,
    CP: 4560,
    letra: '',
    nombre: 'Zanja Honda',
  },
  {
    codCiudad: 1998,
    codPcia: 10,
    CP: 4403,
    letra: '',
    nombre: 'Zanjon',
  },
  {
    codCiudad: 1374,
    codPcia: 21,
    CP: 8340,
    letra: '',
    nombre: 'ZAPALA',
  },
  {
    codCiudad: 2411,
    codPcia: 10,
    CP: 4430,
    letra: '',
    nombre: 'Zapallito',
  },
  {
    codCiudad: 620,
    codPcia: 2,
    CP: 2800,
    letra: '',
    nombre: 'ZARATE',
  },
  {
    codCiudad: 444,
    codPcia: 13,
    CP: 2123,
    letra: '',
    nombre: 'ZAVALLA',
  },
  {
    codCiudad: 3182,
    codPcia: 13,
    CP: 2409,
    letra: '',
    nombre: 'ZENON PEREIRA',
  },
];
